import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, resolveDirective as _resolveDirective, withDirectives as _withDirectives, withCtx as _withCtx, createTextVNode as _createTextVNode, withModifiers as _withModifiers, Fragment as _Fragment, normalizeStyle as _normalizeStyle, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, normalizeClass as _normalizeClass, createBlock as _createBlock, renderList as _renderList, mergeProps as _mergeProps } from "vue"

const _hoisted_1 = {
  class: "form-control mb-4 no-border p-0 w-50",
  id: "demand_edit_thirdType"
}
const _hoisted_2 = { class: "d-block font-medium text-primary" }
const _hoisted_3 = { class: "d-flex" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { class: "card-title flex-grow-1 justify-content-between align-items-center mb-0" }
const _hoisted_6 = { class: "d-flex justify-content-between" }
const _hoisted_7 = { class: "font-semi-bold font-size-12" }
const _hoisted_8 = { class: "card-body" }
const _hoisted_9 = { class: "row form-group" }
const _hoisted_10 = {
  class: "col-lg-3 col-md-6 col-sm-12 form-control no-border",
  id: "demand_edit_identity_title"
}
const _hoisted_11 = { class: "d-block mb-0 small text-muted" }
const _hoisted_12 = {
  class: "col-lg-3 col-md-6 col-sm-12 form-control no-border",
  id: "demand_edit_identity_usageName"
}
const _hoisted_13 = { class: "d-block mb-0 small text-muted" }
const _hoisted_14 = {
  class: "col-lg-3 col-md-6 col-sm-12 form-control no-border",
  id: "demand_edit_identity_familyName"
}
const _hoisted_15 = { class: "d-block mb-0 small text-muted" }
const _hoisted_16 = {
  class: "col-lg-3 col-md-6 col-sm-12 form-control no-border",
  id: "demand_edit_identity_firstName"
}
const _hoisted_17 = { class: "d-block mb-0 small text-muted" }
const _hoisted_18 = {
  class: "col-lg-3 col-md-6 col-sm-12 form-control no-border",
  id: "demand_edit_identity_birthDate"
}
const _hoisted_19 = { class: "d-block mb-0 small text-muted" }
const _hoisted_20 = { class: "row items-center justify-end" }
const _hoisted_21 = {
  class: "col-lg-3 col-md-6 col-sm-12 form-control no-border",
  id: "demand_edit_identity_age"
}
const _hoisted_22 = { class: "d-block mb-0 small text-muted" }
const _hoisted_23 = {
  class: "col-lg-3 col-md-6 col-sm-12 form-control no-border",
  id: "demand_edit_identity_nationality"
}
const _hoisted_24 = { class: "d-block mb-0 small text-muted" }
const _hoisted_25 = {
  key: 0,
  class: "col-lg-3 col-md-6 col-sm-12 form-control no-border",
  id: "demand_edit_identity_gender"
}
const _hoisted_26 = { class: "d-block mb-0 small text-muted" }
const _hoisted_27 = {
  class: "col-lg-3 col-md-6 col-sm-12 form-control no-border",
  id: "demand_edit_identity_bornCountry"
}
const _hoisted_28 = { class: "d-block mb-0 small text-muted" }
const _hoisted_29 = {
  key: 1,
  class: "col-lg-3 col-md-6 col-sm-12 form-control no-border",
  id: "demand_edit_identity_cityOfBirth"
}
const _hoisted_30 = { class: "d-block mb-0 small text-muted" }
const _hoisted_31 = {
  class: "col-lg-3 col-md-6 col-sm-12 form-control no-border",
  id: "demand_edit_identity_birthPostalCode"
}
const _hoisted_32 = { class: "d-block mb-0 small text-muted" }
const _hoisted_33 = {
  class: "col-lg-3 col-md-6 col-sm-12 form-control no-border",
  id: "demand_edit_identity_cityOfBirth"
}
const _hoisted_34 = { class: "d-block mb-0 small text-muted" }
const _hoisted_35 = {
  key: 3,
  class: "col-lg-3 col-md-6 col-sm-12 form-control no-border",
  id: "demand_edit_identity_birthDepartement"
}
const _hoisted_36 = { class: "d-block mb-0 small text-muted" }
const _hoisted_37 = {
  class: "col-lg-3 col-md-6 col-sm-12 form-control no-border",
  id: "demand_edit_identity_phone"
}
const _hoisted_38 = { class: "d-block mb-0 small text-muted" }
const _hoisted_39 = {
  class: "col-lg-3 col-md-6 col-sm-12 form-control no-border",
  id: "demand_edit_identity_taxeGeographicalZone"
}
const _hoisted_40 = { class: "d-block mb-0 small text-muted" }
const _hoisted_41 = {
  key: 0,
  class: "col-lg-3 col-md-6 col-sm-12 form-control no-border",
  id: "demand_edit_identity_naceCode"
}
const _hoisted_42 = { class: "d-block mb-0 small text-muted" }
const _hoisted_43 = {
  class: "col-lg-3 col-md-6 col-sm-12 form-control no-border",
  id: "demand_edit_identity_name"
}
const _hoisted_44 = { class: "d-block mb-0 small text-muted" }
const _hoisted_45 = {
  class: "col-lg-3 col-md-6 col-sm-12 form-control no-border",
  id: "demand_edit_identity_commercialName"
}
const _hoisted_46 = { class: "d-block mb-0 small text-muted" }
const _hoisted_47 = {
  class: "col-lg-3 col-md-6 col-sm-12 form-control no-border",
  id: "demand_edit_identity_SIREN"
}
const _hoisted_48 = { class: "d-block mb-0 small text-muted" }
const _hoisted_49 = {
  class: "col-lg-3 col-md-6 col-sm-12 form-control no-border",
  id: "demand_edit_identity_legalCategory"
}
const _hoisted_50 = { class: "d-block mb-0 small text-muted" }
const _hoisted_51 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_52 = {
  key: 1,
  class: "col-lg-3 col-md-6 col-sm-12 form-control no-border",
  id: "demand_edit_identity_creationDate"
}
const _hoisted_53 = { class: "d-block mb-0 small text-muted" }
const _hoisted_54 = { class: "row items-center justify-end" }
const _hoisted_55 = {
  class: "col-lg-3 col-md-6 col-sm-12 form-control no-border",
  id: "demand_edit_identity_Ape"
}
const _hoisted_56 = { class: "d-block mb-0 small text-muted" }
const _hoisted_57 = {
  class: "col-lg-3 col-md-6 col-sm-12 form-control no-border",
  id: "demand_edit_identity_taxeGeographicalZone"
}
const _hoisted_58 = { class: "d-block mb-0 small text-muted" }
const _hoisted_59 = {
  class: "col-lg-3 col-md-6 col-sm-12 form-control no-border",
  id: "demand_edit_identity_tvaIntracom"
}
const _hoisted_60 = { class: "d-block mb-0 small text-muted" }
const _hoisted_61 = {
  class: "col-lg-3 col-md-6 col-sm-12 form-control no-border",
  id: "demand_edit_identity_commercialRegisterNumber"
}
const _hoisted_62 = { class: "d-block mb-0 small text-muted" }
const _hoisted_63 = {
  class: "col-lg-3 col-md-6 col-sm-12 form-control no-border",
  id: "demand_edit_identity_isCreated"
}
const _hoisted_64 = { class: "d-block mb-0 small text-muted" }
const _hoisted_65 = {
  class: "col-lg-3 col-md-6 col-sm-12 form-control no-border",
  id: "demand_edit_identity_customerType"
}
const _hoisted_66 = { class: "d-block mb-0 small text-muted" }
const _hoisted_67 = {
  class: "col-lg-3 col-md-6 col-sm-12 form-control no-border",
  id: "demand_edit_identity_activity"
}
const _hoisted_68 = { class: "d-block mb-0 small text-muted" }
const _hoisted_69 = {
  class: "col-lg-3 col-md-6 col-sm-12 form-control no-border",
  id: "demand_edit_identity_activity"
}
const _hoisted_70 = { class: "d-block mb-0 small text-muted" }
const _hoisted_71 = {
  class: "col-lg-3 col-md-6 col-sm-12 form-control no-border",
  id: "demand_edit_identity_activity"
}
const _hoisted_72 = { class: "d-block mb-0 small text-muted" }
const _hoisted_73 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_74 = { class: "mt-3 pl-3 pr-3 col-lg-12 col-sm-12 col-xs-12" }
const _hoisted_75 = {
  class: "card-title flex-grow-1 justify-content-between align-items-center mb-0",
  id: "demand_edit_identity_manager"
}
const _hoisted_76 = { class: "d-flex justify-content-between" }
const _hoisted_77 = { class: "font-semi-bold font-size-12" }
const _hoisted_78 = { class: "card-body" }
const _hoisted_79 = { class: "row form-group" }
const _hoisted_80 = {
  class: "col-lg-3 col-md-6 col-sm-12 form-control no-border",
  id: "demand_edit_identity_manager_title"
}
const _hoisted_81 = { class: "d-block mb-0 small text-muted" }
const _hoisted_82 = {
  class: "col-lg-3 col-md-6 col-sm-12 form-control no-border",
  id: "demand_edit_identity_manager_familyName"
}
const _hoisted_83 = { class: "d-block mb-0 small text-muted" }
const _hoisted_84 = {
  class: "col-lg-3 col-md-6 col-sm-12 form-control no-border",
  id: "demand_edit_identity_manager_firstName"
}
const _hoisted_85 = { class: "d-block mb-0 small text-muted" }
const _hoisted_86 = {
  class: "col-lg-3 col-md-6 col-sm-12 form-control no-border",
  id: "demand_edit_identity_manager_birthDate"
}
const _hoisted_87 = { class: "row" }
const _hoisted_88 = { class: "col-9" }
const _hoisted_89 = { class: "d-block mb-0 small text-muted" }
const _hoisted_90 = { class: "row items-center justify-end" }
const _hoisted_91 = {
  class: "col-3",
  id: "demand_edit_identity_manager_age"
}
const _hoisted_92 = { class: "d-block mb-0 small text-muted" }
const _hoisted_93 = {
  class: "col-lg-3 col-md-6 col-sm-12 form-control no-border",
  id: "demand_edit_identity_manager_phone"
}
const _hoisted_94 = { class: "d-block mb-0 small text-muted" }
const _hoisted_95 = {
  class: "col-lg-3 col-md-6 col-sm-12 form-control no-border",
  id: "demand_edit_identity_manager_entryDate"
}
const _hoisted_96 = { class: "d-block mb-0 small text-muted" }
const _hoisted_97 = { class: "row items-center justify-end" }
const _hoisted_98 = {
  class: "col-lg-3 col-md-6 col-sm-12 form-control no-border",
  id: "demand_edit_identity_manager_relationType"
}
const _hoisted_99 = { class: "d-block mb-0 small text-muted" }
const _hoisted_100 = {
  class: "col-lg-3 col-md-6 col-sm-12 form-control no-border",
  id: "demand_edit_identity_manager_bornCountry"
}
const _hoisted_101 = { class: "d-block mb-0 small text-muted" }
const _hoisted_102 = {
  key: 0,
  class: "col-lg-3 col-md-6 col-sm-12 form-control no-border",
  id: "demand_edit_identity_manager_gender"
}
const _hoisted_103 = { class: "d-block mb-0 small text-muted" }
const _hoisted_104 = {
  class: "col-lg-3 col-md-6 col-sm-12 form-control no-border",
  id: "demand_edit_identity_manager_cityOfBirth"
}
const _hoisted_105 = { class: "d-block mb-0 small text-muted" }
const _hoisted_106 = { class: "card-body" }
const _hoisted_107 = { class: "row form-group" }
const _hoisted_108 = {
  class: "col-lg-3 col-md-6 col-sm-12 form-control no-border",
  id: "demand_edit_situation_maritalStatus"
}
const _hoisted_109 = { class: "d-block mb-0 small text-muted" }
const _hoisted_110 = {
  class: "col-lg-3 col-md-6 col-sm-12 form-control no-border",
  id: "demand_edit_situation_matrimonialRegime"
}
const _hoisted_111 = { class: "d-block mb-0 small text-muted" }
const _hoisted_112 = {
  class: "col-lg-3 col-md-6 col-sm-12 form-control no-border",
  id: "demand_edit_situation_peopleInCharge"
}
const _hoisted_113 = { class: "d-block mb-0 small text-muted" }
const _hoisted_114 = {
  class: "col-lg-3 col-md-6 col-sm-12 form-control no-border",
  id: "demand_edit_situation_retirementPassage"
}
const _hoisted_115 = { class: "d-block mb-0 small text-muted" }
const _hoisted_116 = { class: "row items-center justify-end" }
const _hoisted_117 = { class: "align-items-end row" }
const _hoisted_118 = { class: "col-8" }
const _hoisted_119 = { class: "d-block mb-0 small text-muted" }
const _hoisted_120 = { class: "row items-center justify-end" }
const _hoisted_121 = {
  class: "col-3",
  id: "demand_edit_situation_age"
}
const _hoisted_122 = { class: "col-1" }
const _hoisted_123 = { class: "card-title flex-grow-1 justify-content-between align-items-center mb-0" }
const _hoisted_124 = {
  class: "d-flex align-items-center",
  id: "demand_edit_meansOfCommunication_meansOfCommunication"
}
const _hoisted_125 = { class: "font-semi-bold font-size-12" }
const _hoisted_126 = { class: "card-body" }
const _hoisted_127 = { class: "d-flex" }
const _hoisted_128 = { class: "flex-grow-1" }
const _hoisted_129 = {
  class: "row",
  id: "contactsDiv"
}
const _hoisted_130 = ["id"]
const _hoisted_131 = { class: "d-block mb-0 small text-muted" }
const _hoisted_132 = ["id"]
const _hoisted_133 = ["id"]
const _hoisted_134 = { class: "d-block mb-0 small text-muted" }
const _hoisted_135 = ["id"]
const _hoisted_136 = { class: "d-block mb-0 small text-muted" }
const _hoisted_137 = ["id"]
const _hoisted_138 = { class: "d-block mb-0 small text-muted" }
const _hoisted_139 = ["id"]
const _hoisted_140 = { class: "d-block mb-0 small text-muted" }
const _hoisted_141 = { class: "card-title flex-grow-1 justify-content-between align-items-center mb-0" }
const _hoisted_142 = { class: "d-flex align-items-center" }
const _hoisted_143 = { class: "font-semi-bold font-size-12" }
const _hoisted_144 = { class: "card-body" }
const _hoisted_145 = { class: "d-flex" }
const _hoisted_146 = { class: "flex-grow-1" }
const _hoisted_147 = { class: "row" }
const _hoisted_148 = ["id"]
const _hoisted_149 = { class: "d-block mb-0 small text-muted" }
const _hoisted_150 = ["id"]
const _hoisted_151 = { class: "d-block mb-0 small text-muted" }
const _hoisted_152 = ["id"]
const _hoisted_153 = { class: "d-block mb-0 small text-muted" }
const _hoisted_154 = ["id"]
const _hoisted_155 = { class: "d-block mb-0 small text-muted" }
const _hoisted_156 = ["id"]
const _hoisted_157 = { class: "d-block mb-0 small text-muted" }
const _hoisted_158 = ["id"]
const _hoisted_159 = { class: "d-block mb-0 small text-muted" }
const _hoisted_160 = ["id"]
const _hoisted_161 = { class: "d-block mb-0 small text-muted" }
const _hoisted_162 = ["id"]
const _hoisted_163 = { class: "d-block mb-0 small text-muted" }
const _hoisted_164 = {
  class: "col-lg-3 col-md-6 col-sm-12 form-control no-border",
  id: "third_edit_contact_nationality"
}
const _hoisted_165 = { class: "d-block mb-0 small text-muted" }
const _hoisted_166 = {
  class: "col-lg-3 col-md-6 col-sm-12 form-control no-border",
  id: "third_edit_contact_birthplaceCity"
}
const _hoisted_167 = { class: "d-block mb-0 small text-muted" }
const _hoisted_168 = {
  key: 0,
  class: "col-lg-3 col-md-6 col-sm-12 form-control no-border",
  id: "third_edit_contact_birthplaceCityName"
}
const _hoisted_169 = { class: "d-block mb-0 small text-muted" }
const _hoisted_170 = {
  class: "col-lg-3 col-md-6 col-sm-12 form-control no-border",
  id: "third_edit_contact_birthplaceCountry"
}
const _hoisted_171 = { class: "d-block mb-0 small text-muted" }
const _hoisted_172 = {
  class: "col-lg-3 col-md-6 col-sm-12 form-control no-border",
  id: "third_edit_identity_postalCode_cityOfBirth"
}
const _hoisted_173 = { class: "d-block mb-0 small text-muted" }
const _hoisted_174 = {
  class: "col-lg-3 col-md-6 col-sm-12 form-control no-border",
  id: "third_edit_identity_postalCode_country"
}
const _hoisted_175 = { class: "d-block mb-0 small text-muted" }
const _hoisted_176 = {
  class: "col-lg-3 col-md-6 col-sm-12 form-control no-border",
  id: "third_edit_contact_address"
}
const _hoisted_177 = { class: "d-block mb-0 small text-muted" }
const _hoisted_178 = {
  class: "col-lg-3 col-md-6 col-sm-12 form-control no-border",
  id: "third_edit_contact_address"
}
const _hoisted_179 = { class: "d-block mb-0 small text-muted" }
const _hoisted_180 = {
  class: "col-lg-3 col-md-6 col-sm-12 form-control no-border",
  id: "third_edit_contact_addressSupplement"
}
const _hoisted_181 = { class: "d-block mb-0 small text-muted" }
const _hoisted_182 = {
  class: "col-lg-3 col-md-6 col-sm-12 form-control no-border",
  id: "third_edit_identity_birthDate"
}
const _hoisted_183 = { class: "d-block mb-0 small text-muted" }
const _hoisted_184 = { class: "row items-center justify-end" }
const _hoisted_185 = ["id"]
const _hoisted_186 = { class: "d-block mb-0 small text-muted" }
const _hoisted_187 = { class: "d-block mb-0 small text-muted" }
const _hoisted_188 = { class: "d-block mb-0 small text-muted" }
const _hoisted_189 = ["id"]
const _hoisted_190 = { class: "d-block mb-0 small text-muted" }
const _hoisted_191 = { class: "card-title flex-grow-1 justify-content-between align-items-center mb-0" }
const _hoisted_192 = { class: "d-flex align-items-center" }
const _hoisted_193 = { class: "font-semi-bold font-size-12" }
const _hoisted_194 = { class: "card-body" }
const _hoisted_195 = { class: "d-flex" }
const _hoisted_196 = { class: "flex-grow-1" }
const _hoisted_197 = {
  class: "row",
  id: "jobsDiv"
}
const _hoisted_198 = ["id"]
const _hoisted_199 = { class: "d-block mb-0 small text-muted" }
const _hoisted_200 = ["id"]
const _hoisted_201 = { class: "d-block mb-0 small text-muted" }
const _hoisted_202 = ["id"]
const _hoisted_203 = { class: "d-block mb-0 small text-muted" }
const _hoisted_204 = ["id"]
const _hoisted_205 = { class: "d-block mb-0 small text-muted" }
const _hoisted_206 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_207 = ["id"]
const _hoisted_208 = { class: "d-block mb-0 small text-muted" }
const _hoisted_209 = ["id"]
const _hoisted_210 = { class: "d-block mb-0 small text-muted" }
const _hoisted_211 = { class: "row items-center justify-end" }
const _hoisted_212 = ["id"]
const _hoisted_213 = { class: "d-block mb-0 small text-muted" }
const _hoisted_214 = ["id"]
const _hoisted_215 = { class: "d-block mb-0 small text-muted" }
const _hoisted_216 = {
  class: "col-lg-3 col-md-6 col-sm-12 form-control no-border",
  id: `demand_edit_profession_professionType`
}
const _hoisted_217 = { class: "d-block mb-0 small text-muted" }
const _hoisted_218 = { class: "p-2" }
const _hoisted_219 = { class: "card-title flex-grow-1 justify-content-between align-items-center mb-0" }
const _hoisted_220 = { class: "d-flex align-items-center" }
const _hoisted_221 = { class: "font-semi-bold font-size-12" }
const _hoisted_222 = { class: "card-body" }
const _hoisted_223 = { class: "row form-group" }
const _hoisted_224 = ["id"]
const _hoisted_225 = { class: "d-block mb-0 small text-muted" }
const _hoisted_226 = ["id"]
const _hoisted_227 = { class: "d-block mb-0 small text-muted" }
const _hoisted_228 = ["id"]
const _hoisted_229 = { class: "d-block mb-0 small text-muted" }
const _hoisted_230 = ["id"]
const _hoisted_231 = { class: "d-block mb-0 small text-muted" }
const _hoisted_232 = ["id"]
const _hoisted_233 = { class: "d-block mb-0 small text-muted" }
const _hoisted_234 = { class: "card-title flex-grow-1 justify-content-between align-items-center mb-0" }
const _hoisted_235 = { class: "d-flex align-items-center" }
const _hoisted_236 = { class: "font-semi-bold font-size-12" }
const _hoisted_237 = { class: "card-body" }
const _hoisted_238 = { class: "d-flex" }
const _hoisted_239 = { class: "flex-grow-1" }
const _hoisted_240 = { class: "row" }
const _hoisted_241 = ["id"]
const _hoisted_242 = { class: "d-block mb-0 small text-muted" }
const _hoisted_243 = ["id"]
const _hoisted_244 = { class: "d-block mb-0 small text-muted" }
const _hoisted_245 = ["id"]
const _hoisted_246 = { class: "d-block mb-0 small text-muted" }
const _hoisted_247 = {
  class: "col-lg-3 col-md-6 col-sm-12 form-control no-border",
  id: "third_edit_identity_establishment_adress_street"
}
const _hoisted_248 = { class: "d-block mb-0 small text-muted" }
const _hoisted_249 = ["id"]
const _hoisted_250 = { class: "d-block mb-0 small text-muted" }
const _hoisted_251 = ["id"]
const _hoisted_252 = { class: "d-block mb-0 small text-muted" }
const _hoisted_253 = ["id"]
const _hoisted_254 = { class: "d-block mb-0 small text-muted" }
const _hoisted_255 = ["id"]
const _hoisted_256 = { class: "d-block mb-0 small text-muted" }
const _hoisted_257 = ["id"]
const _hoisted_258 = { class: "d-block mb-0 small text-muted" }
const _hoisted_259 = ["id"]
const _hoisted_260 = { class: "d-block mb-0 small text-muted" }
const _hoisted_261 = ["id"]
const _hoisted_262 = { class: "d-block mb-0 small text-muted" }
const _hoisted_263 = { class: "card-title flex-grow-1 justify-content-between align-items-center mb-0" }
const _hoisted_264 = { class: "d-flex align-items-center" }
const _hoisted_265 = { class: "font-semi-bold font-size-12" }
const _hoisted_266 = { class: "card-body" }
const _hoisted_267 = { class: "d-flex" }
const _hoisted_268 = { class: "flex-grow-1" }
const _hoisted_269 = { class: "d-flex" }
const _hoisted_270 = { class: "flex-grow-1" }
const _hoisted_271 = { class: "row" }
const _hoisted_272 = {
  key: 0,
  class: "col-lg-3 col-md-6 col-sm-12 form-control no-border",
  id: "third_edit_identity_establishment_siren"
}
const _hoisted_273 = {
  key: 1,
  class: "col-lg-3 col-md-6 col-sm-12 form-control no-border",
  id: "third_edit_identity_establishment_siren"
}
const _hoisted_274 = {
  class: "col-lg-3 col-md-6 col-sm-12 form-control no-border",
  id: "third_edit_identity_establishment_name"
}
const _hoisted_275 = { class: "d-block mb-0 small text-muted" }
const _hoisted_276 = {
  class: "col-lg-3 col-md-6 col-sm-12 form-control no-border",
  id: "third_edit_identity_establishment_type"
}
const _hoisted_277 = { class: "p-2" }
const _hoisted_278 = { class: "card-title flex-grow-1 justify-content-between align-items-center mb-0" }
const _hoisted_279 = { class: "d-flex align-items-center" }
const _hoisted_280 = { class: "font-semi-bold font-size-12" }
const _hoisted_281 = { class: "card-body" }
const _hoisted_282 = { class: "row form-group" }
const _hoisted_283 = {
  class: "col-lg-3 col-md-6 col-sm-12 form-control no-border",
  id: "third_edit_identity_establishment_adress_addressType"
}
const _hoisted_284 = { class: "d-block mb-0 small text-muted" }
const _hoisted_285 = {
  class: "col-lg-3 col-md-6 col-sm-12 form-control no-border",
  id: "third_edit_identity_establishment_adress_street"
}
const _hoisted_286 = { class: "d-block mb-0 small text-muted" }
const _hoisted_287 = {
  class: "col-lg-3 col-md-6 col-sm-12 form-control no-border",
  id: "third_edit_identity_establishment_adress_street"
}
const _hoisted_288 = { class: "d-block mb-0 small text-muted" }
const _hoisted_289 = {
  class: "col-lg-3 col-md-6 col-sm-12 form-control no-border",
  id: "third_edit_identity_establishment_adress_street"
}
const _hoisted_290 = { class: "d-block mb-0 small text-muted" }
const _hoisted_291 = {
  class: "col-lg-3 col-md-6 col-sm-12 form-control no-border",
  id: "third_edit_identity_establishment_adress_codePostal"
}
const _hoisted_292 = { class: "d-block mb-0 small text-muted" }
const _hoisted_293 = {
  class: "col-lg-3 col-md-6 col-sm-12 form-control no-border",
  id: "third_edit_identity_establishment_adress_city"
}
const _hoisted_294 = { class: "d-block mb-0 small text-muted" }
const _hoisted_295 = {
  class: "col-lg-3 col-md-6 col-sm-12 form-control no-border",
  id: "third_edit_identity_establishment_adress_country"
}
const _hoisted_296 = { class: "d-block mb-0 small text-muted" }
const _hoisted_297 = { class: "card-title flex-grow-1 justify-content-between align-items-center mb-0" }
const _hoisted_298 = { class: "d-flex align-items-center" }
const _hoisted_299 = { class: "font-semi-bold font-size-12" }
const _hoisted_300 = { class: "card-body" }
const _hoisted_301 = { class: "d-flex" }
const _hoisted_302 = { class: "flex-grow-1" }
const _hoisted_303 = { class: "row" }
const _hoisted_304 = ["id"]
const _hoisted_305 = { class: "d-block mb-0 small text-muted" }
const _hoisted_306 = { class: "row items-center justify-end" }
const _hoisted_307 = { class: "d-flex" }
const _hoisted_308 = { class: "card-title mb-0" }
const _hoisted_309 = { class: "col-12 form-control no-border" }
const _hoisted_310 = { class: "font-size-12 font-semi-bold" }
const _hoisted_311 = { class: "bg-white pt-0" }
const _hoisted_312 = { class: "d-flex" }
const _hoisted_313 = { class: "form-control no-border w-100" }
const _hoisted_314 = { class: "row" }
const _hoisted_315 = { class: "col-12 border" }
const _hoisted_316 = { class: "align-items-center d-flex pb-3" }
const _hoisted_317 = { class: "font-size-12 mr-3" }
const _hoisted_318 = { class: "row items-center justify-end" }
const _hoisted_319 = { class: "row items-center justify-end" }
const _hoisted_320 = { class: "col-12 border" }
const _hoisted_321 = { class: "align-items-center d-flex pb-3" }
const _hoisted_322 = { class: "font-size-12 mr-3" }
const _hoisted_323 = { class: "row items-center justify-end" }
const _hoisted_324 = { class: "row items-center justify-end" }
const _hoisted_325 = { class: "card-title flex-grow-1 justify-content-between align-items-center mb-0" }
const _hoisted_326 = { class: "d-flex align-items-center" }
const _hoisted_327 = { class: "font-semi-bold font-size-12" }
const _hoisted_328 = { class: "card-body" }
const _hoisted_329 = { class: "d-flex" }
const _hoisted_330 = { class: "flex-grow-1" }
const _hoisted_331 = { class: "row" }
const _hoisted_332 = ["id"]
const _hoisted_333 = { class: "d-block mb-0 small text-muted" }
const _hoisted_334 = ["id"]
const _hoisted_335 = { class: "d-block mb-0 small text-muted" }
const _hoisted_336 = ["id"]
const _hoisted_337 = { class: "d-block mb-0 small text-muted" }
const _hoisted_338 = {
  key: 0,
  style: {"color":"red"}
}
const _hoisted_339 = ["id"]
const _hoisted_340 = { class: "d-block mb-0 small text-muted" }
const _hoisted_341 = ["id"]
const _hoisted_342 = { class: "d-block mb-0 small text-muted" }
const _hoisted_343 = ["id"]
const _hoisted_344 = { class: "d-block mb-0 small text-muted" }
const _hoisted_345 = ["id"]
const _hoisted_346 = { class: "d-block mb-0 small text-muted" }
const _hoisted_347 = { key: 0 }
const _hoisted_348 = ["id"]
const _hoisted_349 = { class: "d-flex align-items-center mt-0" }
const _hoisted_350 = {
  key: 0,
  class: "d-block mb-0 small text-muted"
}
const _hoisted_351 = { class: "d-flex align-items-center mt-0" }
const _hoisted_352 = { class: "card-title flex-grow-1 justify-content-between align-items-center mb-0" }
const _hoisted_353 = { class: "d-flex align-items-center" }
const _hoisted_354 = { class: "font-semi-bold font-size-12" }
const _hoisted_355 = { class: "card-body" }
const _hoisted_356 = { class: "d-flex" }
const _hoisted_357 = { class: "flex-grow-1" }
const _hoisted_358 = { class: "row" }
const _hoisted_359 = ["id"]
const _hoisted_360 = { class: "d-block mb-0 small text-muted" }
const _hoisted_361 = ["id"]
const _hoisted_362 = { class: "d-block mb-0 small text-muted" }
const _hoisted_363 = ["id"]
const _hoisted_364 = { class: "d-block mb-0 small text-muted" }
const _hoisted_365 = {
  key: 0,
  style: {"color":"red"}
}
const _hoisted_366 = ["id"]
const _hoisted_367 = { class: "d-block mb-0 small text-muted" }
const _hoisted_368 = ["id"]
const _hoisted_369 = { class: "d-block mb-0 small text-muted" }
const _hoisted_370 = ["id"]
const _hoisted_371 = { class: "d-block mb-0 small text-muted" }
const _hoisted_372 = ["id"]
const _hoisted_373 = { class: "d-block mb-0 small text-muted" }
const _hoisted_374 = { key: 0 }
const _hoisted_375 = ["id"]
const _hoisted_376 = { class: "d-flex align-items-center mt-0" }
const _hoisted_377 = {
  key: 0,
  class: "d-block mb-0 small text-muted"
}
const _hoisted_378 = { class: "d-flex align-items-center mt-0" }
const _hoisted_379 = { class: "card-title flex-grow-1 justify-content-between align-items-center mb-0" }
const _hoisted_380 = { class: "d-flex align-items-center" }
const _hoisted_381 = { class: "font-semi-bold font-size-12" }
const _hoisted_382 = { class: "card-body" }
const _hoisted_383 = { class: "p-2 bg-white default-border-radius mb-3" }
const _hoisted_384 = { class: "d-flex" }
const _hoisted_385 = { class: "flex-grow-1" }
const _hoisted_386 = { class: "row" }
const _hoisted_387 = {
  class: "col-lg-3 col-md-3 col-sm-3 form-control no-border",
  id: "demand_edit_signature_signaturMethod"
}
const _hoisted_388 = { class: "d-block mb-0 small text-muted" }
const _hoisted_389 = {
  key: 0,
  class: "col-lg-3 col-md-6 col-sm-12 form-control no-border",
  id: "demand_edit_identity_customerType"
}
const _hoisted_390 = { class: "d-block mb-0 small text-muted" }
const _hoisted_391 = {
  key: 1,
  class: "col-lg-3 col-md-6 col-sm-12 form-control no-border",
  id: "demand_edit_identity_activity"
}
const _hoisted_392 = { class: "d-block mb-0 small text-muted" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_select = _resolveComponent("q-select")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_input = _resolveComponent("q-input")!
  const _component_q_date = _resolveComponent("q-date")!
  const _component_q_popup_proxy = _resolveComponent("q-popup-proxy")!
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_item_section = _resolveComponent("q-item-section")!
  const _component_q_item = _resolveComponent("q-item")!
  const _component_q_item_label = _resolveComponent("q-item-label")!
  const _component_q_toggle = _resolveComponent("q-toggle")!
  const _component_q_expansion_item = _resolveComponent("q-expansion-item")!
  const _component_q_list = _resolveComponent("q-list")!
  const _component_PartyProDetails = _resolveComponent("PartyProDetails")!
  const _component_Comment = _resolveComponent("Comment")!
  const _component_q_tooltip = _resolveComponent("q-tooltip")!
  const _component_q_th = _resolveComponent("q-th")!
  const _component_q_tr = _resolveComponent("q-tr")!
  const _component_twCurrencyInput = _resolveComponent("twCurrencyInput")!
  const _component_q_td = _resolveComponent("q-td")!
  const _component_q_table = _resolveComponent("q-table")!
  const _component_PartyAccount = _resolveComponent("PartyAccount")!
  const _component_TaskPartyRelation = _resolveComponent("TaskPartyRelation")!
  const _component_PartyFinancialSituation = _resolveComponent("PartyFinancialSituation")!
  const _component_TaskPartyClassification = _resolveComponent("TaskPartyClassification")!
  const _component_q_form = _resolveComponent("q-form")!
  const _component_third_search_dialog = _resolveComponent("third-search-dialog")!
  const _directive_close_popup = _resolveDirective("close-popup")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_q_form, null, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("label", _hoisted_2, _toDisplayString(_ctx.$t("main.labels.partyType")), 1),
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_q_select, {
              "data-testid": "demand_edit_thirdType",
              dense: "",
              outlined: "",
              modelValue: _ctx.party.type,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.party.type) = $event)),
              options: _ctx.clientType,
              class: "bg-white w-50",
              disable: _ctx.currentRoute === 'TaskDetail'
            }, null, 8, ["modelValue", "options", "disable"]),
            (_ctx.currentRoute !== 'TaskDetail')
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                  _createVNode(_component_q_btn, {
                    "data-testid": "demand_edit_thirdType_button_Rechercher",
                    label: _ctx.$t('main.labels.search'),
                    disable: _ctx.party.type.id === '',
                    onClick: _ctx.searchThird,
                    class: "btn btn-primary ml-3",
                    icon: "search"
                  }, null, 8, ["label", "disable", "onClick"])
                ]))
              : _createCommentVNode("", true)
          ])
        ]),
        _createElementVNode("div", {
          class: _normalizeClass(_ctx.party.type.id === '' ? 'd-none' : '')
        }, [
          _createVNode(_component_q_list, null, {
            default: _withCtx(() => [
              _createVNode(_component_q_expansion_item, {
                "switch-toggle-side": "",
                "expand-separator": "",
                "header-class": "card-header bg-transparent no-border p-4",
                class: _normalizeClass(["card tw-items-dashed-group tw-items-group-with-bg tw-level-two-group", _ctx.currentRoute === 'TaskDetail' ? 'tw-analysis-section' : '']),
                modelValue: _ctx.identityOpened,
                "onUpdate:modelValue": _cache[58] || (_cache[58] = ($event: any) => ((_ctx.identityOpened) = $event)),
                onShow: _ctx.editIdentify,
                onHide: _ctx.editIdentify
              }, {
                header: _withCtx(() => [
                  _createElementVNode("div", _hoisted_5, [
                    _createElementVNode("div", _hoisted_6, [
                      _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.toUpperCase(_ctx.$t("main.labels.identity"))), 1)
                    ])
                  ])
                ]),
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("div", _hoisted_9, [
                      (_ctx.isPersonPhysique)
                        ? _renderSlot(_ctx.$slots, "personPhysique", { key: 0 }, () => [
                            _createElementVNode("div", _hoisted_10, [
                              _createElementVNode("label", _hoisted_11, _toDisplayString(_ctx.$t("main.labels.title")), 1),
                              _createVNode(_component_q_select, {
                                "data-testid": "demand_edit_identity_title",
                                dense: "",
                                outlined: "",
                                "emit-value": "",
                                "map-options": "",
                                modelValue: _ctx.party.person.title.type.value,
                                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.party.person.title.type.value) = $event)),
                                options: _ctx.title
                              }, null, 8, ["modelValue", "options"])
                            ]),
                            _createElementVNode("div", _hoisted_12, [
                              _createElementVNode("label", _hoisted_13, _toDisplayString(_ctx.$t("main.labels.usageName")), 1),
                              _createVNode(_component_q_input, {
                                "data-testid": "demand_edit_identity_usageName",
                                dense: "",
                                outlined: "",
                                modelValue: _ctx.party.person.usageName,
                                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.party.person.usageName) = $event))
                              }, null, 8, ["modelValue"])
                            ]),
                            _createElementVNode("div", _hoisted_14, [
                              _createElementVNode("label", _hoisted_15, _toDisplayString(_ctx.$t("main.labels.familyName")), 1),
                              _createVNode(_component_q_input, {
                                "data-testid": "demand_edit_identity_familyName",
                                dense: "",
                                outlined: "",
                                id: "familyName",
                                modelValue: _ctx.party.person.familyName,
                                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.party.person.familyName) = $event))
                              }, null, 8, ["modelValue"])
                            ]),
                            _createElementVNode("div", _hoisted_16, [
                              _createElementVNode("label", _hoisted_17, _toDisplayString(_ctx.$t("main.labels.firstName")), 1),
                              _createVNode(_component_q_input, {
                                "data-testid": "demand_edit_identity_firstName",
                                dense: "",
                                outlined: "",
                                modelValue: _ctx.party.person.firstName,
                                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.party.person.firstName) = $event))
                              }, null, 8, ["modelValue"])
                            ]),
                            _createElementVNode("div", _hoisted_18, [
                              _createElementVNode("label", _hoisted_19, _toDisplayString(_ctx.$t("main.labels.birthDate")), 1),
                              _createVNode(_component_q_input, {
                                "data-testid": "demand_edit_identity_birthDate",
                                dense: "",
                                outlined: "",
                                modelValue: _ctx.party.person.birthDate,
                                "onUpdate:modelValue": [
                                  _cache[7] || (_cache[7] = ($event: any) => ((_ctx.party.person.birthDate) = $event)),
                                  _cache[8] || (_cache[8] = ($event: any) => (_ctx.calculateAge($event, _ctx.party.person)))
                                ],
                                mask: _ctx.maskInput,
                                rules: [(val) => _ctx.validateBirthDate(val)]
                              }, {
                                append: _withCtx(() => [
                                  _createVNode(_component_q_icon, {
                                    name: "event",
                                    class: "cursor-pointer"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_q_popup_proxy, {
                                        ref: "qDateProxy",
                                        cover: "",
                                        "transition-show": "scale",
                                        "transition-hide": "scale"
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_q_date, {
                                            modelValue: _ctx.party.person.birthDate,
                                            "onUpdate:modelValue": [
                                              _cache[5] || (_cache[5] = ($event: any) => ((_ctx.party.person.birthDate) = $event)),
                                              _cache[6] || (_cache[6] = ($event: any) => (
                            _ctx.calculateAge($event, _ctx.party.person)
                            ))
                                            ],
                                            mask: _ctx.maskFormat,
                                            locale: _ctx.FR
                                          }, {
                                            default: _withCtx(() => [
                                              _createElementVNode("div", _hoisted_20, [
                                                _withDirectives(_createVNode(_component_q_btn, {
                                                  label: _ctx.$t(
                                'task.completeDocument.party.person.financialSituation.close'
                              )
                                ,
                                                  color: "primary",
                                                  flat: ""
                                                }, null, 8, ["label"]), [
                                                  [_directive_close_popup]
                                                ])
                                              ])
                                            ]),
                                            _: 1
                                          }, 8, ["modelValue", "mask", "locale"])
                                        ]),
                                        _: 1
                                      }, 512)
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }, 8, ["modelValue", "mask", "rules"])
                            ]),
                            _createElementVNode("div", _hoisted_21, [
                              _createElementVNode("label", _hoisted_22, _toDisplayString(_ctx.$t("main.labels.age")), 1),
                              _createVNode(_component_q_input, {
                                "data-testid": "demand_edit_identity_age",
                                dense: "",
                                outlined: "",
                                modelValue: _ctx.party.person.age,
                                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.party.person.age) = $event)),
                                suffix: " ans",
                                readonly: ""
                              }, null, 8, ["modelValue"])
                            ]),
                            _createElementVNode("div", _hoisted_23, [
                              _createElementVNode("label", _hoisted_24, [
                                _createTextVNode(_toDisplayString(_ctx.$t("main.labels.nationality")) + " ", 1),
                                _cache[100] || (_cache[100] = _createElementVNode("span", { class: "text-danger" }, "*", -1))
                              ]),
                              _createVNode(_component_q_select, {
                                "data-testid": "demand_edit_identity_nationality",
                                dense: "",
                                outlined: "",
                                "emit-value": "",
                                "map-options": "",
                                modelValue: _ctx.party.person.nationality.type.value,
                                "onUpdate:modelValue": [
                                  _cache[10] || (_cache[10] = ($event: any) => ((_ctx.party.person.nationality.type.value) = $event)),
                                  _cache[11] || (_cache[11] = ($event: any) => (_ctx.onNationalityChange($event, _ctx.party.person)))
                                ],
                                options: _ctx.nationality,
                                rules: [(val) => !!val || _ctx.requiredField]
                              }, null, 8, ["modelValue", "options", "rules"])
                            ]),
                            (_ctx.currentRoute === 'TaskDetail')
                              ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                                  _createElementVNode("label", _hoisted_26, _toDisplayString(_ctx.$t("main.labels.gender")), 1),
                                  _createVNode(_component_q_select, {
                                    "data-testid": "demand_edit_identity_gender",
                                    dense: "",
                                    outlined: "",
                                    "emit-value": "",
                                    "map-options": "",
                                    modelValue: _ctx.party.person.gender.type.value,
                                    "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.party.person.gender.type.value) = $event)),
                                    options: _ctx.gender
                                  }, null, 8, ["modelValue", "options"])
                                ]))
                              : _createCommentVNode("", true),
                            _createElementVNode("div", _hoisted_27, [
                              _createElementVNode("label", _hoisted_28, _toDisplayString(_ctx.$t("main.labels.bornCountry")), 1),
                              _createVNode(_component_q_select, {
                                "data-testid": "demand_edit_identity_bornCountry",
                                dense: "",
                                outlined: "",
                                "emit-value": "",
                                "map-options": "",
                                modelValue: _ctx.birthCountryId,
                                "onUpdate:modelValue": [
                                  _cache[13] || (_cache[13] = ($event: any) => ((_ctx.birthCountryId) = $event)),
                                  _cache[14] || (_cache[14] = ($event: any) => (
                      _ctx.changePostalCodeIdentity($event, _ctx.party.person)
                      ))
                                ],
                                options: _ctx.nationality,
                                onInput: _ctx.filterPostalCodeWithCountry
                              }, null, 8, ["modelValue", "options", "onInput"])
                            ]),
                            (_ctx.isBirthCountryFrance)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                                  _createElementVNode("label", _hoisted_30, _toDisplayString(_ctx.$t("main.labels.postalCode_cityOfBirth")), 1),
                                  _createVNode(_component_q_select, {
                                    "data-testid": "demand_edit_identity_cityOfBirth",
                                    dense: "",
                                    outlined: "",
                                    "use-input": "",
                                    "hide-selected": "",
                                    "fill-input": "",
                                    "onUpdate:modelValue": [
                                      _cache[16] || (_cache[16] = ($event: any) => (
                      _ctx.changePostalCodeIdentity($event, _ctx.party.person)
                      )),
                                      _cache[17] || (_cache[17] = ($event: any) => ((_ctx.party.person.birthplace.type.label) = $event))
                                    ],
                                    modelValue: _ctx.party.person.birthplace.type.label,
                                    options: _ctx.postalCodes,
                                    onFilter: _ctx.filterPostalCodeWithCountry
                                  }, {
                                    "no-option": _withCtx(() => [
                                      _createVNode(_component_q_item, null, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_q_item_section, { class: "text-grey" }, {
                                            default: _withCtx(() => [
                                              _createTextVNode(_toDisplayString(_ctx.$t("main.noResults")), 1)
                                            ]),
                                            _: 1
                                          })
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    append: _withCtx(() => [
                                      _createVNode(_component_q_icon, {
                                        name: "search",
                                        onClick: _cache[15] || (_cache[15] = _withModifiers(() => {}, ["stop"]))
                                      })
                                    ]),
                                    _: 1
                                  }, 8, ["modelValue", "options", "onFilter"])
                                ]))
                              : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                                  _createElementVNode("div", _hoisted_31, [
                                    _createElementVNode("label", _hoisted_32, _toDisplayString(_ctx.$t("main.labels.postalCode")), 1),
                                    _createVNode(_component_q_input, {
                                      "data-testid": "demand_edit_identity_birthPostalCode",
                                      dense: "",
                                      outlined: "",
                                      "model-value": "99999",
                                      readonly: ""
                                    })
                                  ]),
                                  _createElementVNode("div", _hoisted_33, [
                                    _createElementVNode("label", _hoisted_34, _toDisplayString(_ctx.$t("main.labels.cityOfBirth")), 1),
                                    _createVNode(_component_q_input, {
                                      "data-testid": "demand_edit_identity_cityOfBirthInput",
                                      dense: "",
                                      outlined: "",
                                      modelValue: _ctx.birthCityName,
                                      "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.birthCityName) = $event))
                                    }, null, 8, ["modelValue"])
                                  ])
                                ], 64)),
                            (_ctx.isBirthCountryFrance)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                                  _createElementVNode("label", _hoisted_36, _toDisplayString(_ctx.$t("main.labels.birthdepartement")), 1),
                                  _createVNode(_component_q_input, {
                                    "data-testid": "demand_edit_identity_birthDepartement",
                                    dense: "",
                                    outlined: "",
                                    "emit-value": "",
                                    "map-options": "",
                                    modelValue: _ctx.birthPlaceDepartment,
                                    "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.birthPlaceDepartment) = $event)),
                                    readonly: ""
                                  }, null, 8, ["modelValue"])
                                ]))
                              : _createCommentVNode("", true),
                            _createElementVNode("div", _hoisted_37, [
                              _createElementVNode("label", _hoisted_38, _toDisplayString(_ctx.$t("main.labels.telephone")), 1),
                              (_ctx.phonesListSize === 0)
                                ? _renderSlot(_ctx.$slots, "default", { key: 0 }, () => [
                                    _createVNode(_component_q_input, {
                                      "data-testid": "demand_edit_identity_phone0",
                                      dense: "",
                                      outlined: "",
                                      "fill-mask": "",
                                      modelValue: _ctx.phoneContact.contactMechanism.phoneNumber,
                                      "onUpdate:modelValue": [
                                        _cache[20] || (_cache[20] = ($event: any) => ((_ctx.phoneContact.contactMechanism.phoneNumber) = $event)),
                                        _ctx.updateContactList
                                      ],
                                      rules: _ctx.phoneRules
                                    }, null, 8, ["modelValue", "onUpdate:modelValue", "rules"])
                                  ], true)
                                : (_ctx.phonesListSize === 1)
                                  ? _renderSlot(_ctx.$slots, "default", { key: 1 }, () => [
                                      _createVNode(_component_q_input, {
                                        "data-testid": "demand_edit_identity_phone1",
                                        dense: "",
                                        outlined: "",
                                        "fill-mask": "",
                                        modelValue: _ctx.contacts[0].contactMechanism.phoneNumber,
                                        "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.contacts[0].contactMechanism.phoneNumber) = $event)),
                                        rules: _ctx.phoneRules
                                      }, null, 8, ["modelValue", "rules"])
                                    ], true)
                                  : _renderSlot(_ctx.$slots, "default", { key: 2 }, () => [
                                      _createVNode(_component_q_input, {
                                        "data-testid": "demand_edit_identity_phoneContact",
                                        dense: "",
                                        outlined: "",
                                        "fill-mask": "",
                                        modelValue: _ctx.phoneContact,
                                        "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.phoneContact) = $event)),
                                        disable: "",
                                        rules: _ctx.phoneRules
                                      }, null, 8, ["modelValue", "rules"])
                                    ], true)
                            ]),
                            _createElementVNode("div", _hoisted_39, [
                              _createElementVNode("label", _hoisted_40, _toDisplayString(_ctx.$t("main.labels.geographicalZone")), 1),
                              _createVNode(_component_q_select, {
                                "data-testid": "demand_edit_identity_taxeGeographicalZone",
                                dense: "",
                                outlined: "",
                                "emit-value": "",
                                "map-options": "",
                                modelValue: _ctx.party.person.taxGeographicZone,
                                "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.party.person.taxGeographicZone) = $event)),
                                options: _ctx.geographicalZoneItems
                              }, null, 8, ["modelValue", "options"])
                            ])
                          ], true)
                        : _createCommentVNode("", true),
                      (_ctx.isPersonMorale)
                        ? _renderSlot(_ctx.$slots, "personPhysique", { key: 1 }, () => [
                            (_ctx.party.organization.codeNace)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_41, [
                                  _createElementVNode("label", _hoisted_42, _toDisplayString(`${_ctx.$t(
                        "middleOffice.party.organization.identity.naceCode"
                      )}`), 1),
                                  _createVNode(_component_q_select, {
                                    "data-testid": "demand_edit_identity_naceCode",
                                    dense: "",
                                    outlined: "",
                                    "emit-value": "",
                                    "map-options": "",
                                    "use-input": "",
                                    "hide-selected": "",
                                    "fill-input": "",
                                    "input-debounce": "0",
                                    modelValue: _ctx.party.organization.codeNace.type.value,
                                    "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.party.organization.codeNace.type.value) = $event)),
                                    options: _ctx.filteredNaceOptions,
                                    onFilter: _ctx.filterNaceOptions
                                  }, null, 8, ["modelValue", "options", "onFilter"])
                                ]))
                              : _createCommentVNode("", true),
                            _createElementVNode("div", _hoisted_43, [
                              _createElementVNode("label", _hoisted_44, [
                                _createTextVNode(_toDisplayString(_ctx.$t("middleOffice.party.organization.identity.name")) + " ", 1),
                                _cache[101] || (_cache[101] = _createElementVNode("span", { class: "text-danger" }, "*", -1))
                              ]),
                              _createVNode(_component_q_input, {
                                "data-testid": "demand_edit_identity_name",
                                dense: "",
                                outlined: "",
                                modelValue: _ctx.party.organization.name,
                                "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((_ctx.party.organization.name) = $event))
                              }, null, 8, ["modelValue"])
                            ]),
                            _createElementVNode("div", _hoisted_45, [
                              _createElementVNode("label", _hoisted_46, _toDisplayString(_ctx.$t(
                        "middleOffice.party.organization.identity.commercialName"
                      )), 1),
                              _createVNode(_component_q_input, {
                                "data-testid": "demand_edit_identity_commercialName",
                                dense: "",
                                outlined: "",
                                modelValue: _ctx.party.organization.commercialName,
                                "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.party.organization.commercialName) = $event))
                              }, null, 8, ["modelValue"])
                            ]),
                            _createElementVNode("div", _hoisted_47, [
                              _createElementVNode("label", _hoisted_48, [
                                _createTextVNode(_toDisplayString(_ctx.$t("demand.filtreMenu.SIREN")) + " ", 1),
                                _cache[102] || (_cache[102] = _createElementVNode("span", { class: "text-danger" }, "*", -1))
                              ]),
                              _createVNode(_component_q_input, {
                                "data-testid": "demand_edit_identity_SIREN",
                                dense: "",
                                mask: _ctx.getSirenMask(_ctx.party?.type?.id),
                                outlined: "",
                                modelValue: _ctx.party.organization.siren,
                                "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => ((_ctx.party.organization.siren) = $event))
                              }, null, 8, ["mask", "modelValue"])
                            ]),
                            _createElementVNode("div", _hoisted_49, [
                              _createElementVNode("label", _hoisted_50, [
                                _createTextVNode(_toDisplayString(_ctx.$t(
                        "middleOffice.party.organization.identity.legalCategory"
                      )) + " ", 1),
                                (_ctx.isPartySupplierOrDistributor())
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_51, "*"))
                                  : _createCommentVNode("", true)
                              ]),
                              _createVNode(_component_q_select, {
                                "data-testid": "demand_edit_identity_legalCategory",
                                dense: "",
                                outlined: "",
                                "emit-value": "",
                                "map-options": "",
                                "use-input": "",
                                "hide-selected": "",
                                "fill-input": "",
                                "input-debounce": "0",
                                modelValue: _ctx.party.organization.legalCategory.type.value,
                                "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => ((_ctx.party.organization.legalCategory.type.value) = $event)),
                                options: _ctx.filteredLegalCategoryOptions,
                                onFilter: _ctx.filterLegalCategory,
                                rules: [(val) => !!val || _ctx.requiredField]
                              }, null, 8, ["modelValue", "options", "onFilter", "rules"])
                            ]),
                            (_ctx.party.organization.isCreated)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_52, [
                                  _createElementVNode("label", _hoisted_53, _toDisplayString(_ctx.$t(
                        "middleOffice.party.organization.identity.creationDate"
                      )), 1),
                                  _createVNode(_component_q_input, {
                                    "data-testid": "demand_edit_identity_creationDateInput",
                                    dense: "",
                                    outlined: "",
                                    modelValue: _ctx.party.organization.creationDate,
                                    "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event: any) => ((_ctx.party.organization.creationDate) = $event)),
                                    mask: _ctx.maskInput
                                  }, {
                                    append: _withCtx(() => [
                                      _createVNode(_component_q_icon, {
                                        "data-testid": "demand_edit_identity_creationDateIcon",
                                        name: "event",
                                        class: "cursor-pointer"
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_q_popup_proxy, {
                                            "data-testid": "demand_edit_identity_creationDatePopupProxy",
                                            ref: "qDateProxy",
                                            cover: "",
                                            "transition-show": "scale",
                                            "transition-hide": "scale"
                                          }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_q_date, {
                                                "data-testid": "demand_edit_identity_creationDateDate",
                                                modelValue: _ctx.party.organization.creationDate,
                                                "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => ((_ctx.party.organization.creationDate) = $event)),
                                                mask: _ctx.maskFormat,
                                                locale: _ctx.FR
                                              }, {
                                                default: _withCtx(() => [
                                                  _createElementVNode("div", _hoisted_54, [
                                                    _withDirectives(_createVNode(_component_q_btn, {
                                                      "data-testid": "demand_edit_identity_creationDateButton",
                                                      label: _ctx.$t(
                                'task.completeDocument.party.person.financialSituation.close'
                              )
                                ,
                                                      color: "primary",
                                                      flat: ""
                                                    }, null, 8, ["label"]), [
                                                      [_directive_close_popup]
                                                    ])
                                                  ])
                                                ]),
                                                _: 1
                                              }, 8, ["modelValue", "mask", "locale"])
                                            ]),
                                            _: 1
                                          }, 512)
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  }, 8, ["modelValue", "mask"])
                                ]))
                              : _createCommentVNode("", true),
                            _createElementVNode("div", _hoisted_55, [
                              _createElementVNode("label", _hoisted_56, [
                                _createTextVNode(_toDisplayString(_ctx.$t("party.APE")) + " ", 1),
                                _cache[103] || (_cache[103] = _createElementVNode("span", { class: "text-danger" }, " * ", -1))
                              ]),
                              _createVNode(_component_q_select, {
                                rules: [(val) => !!val || _ctx.requiredField],
                                "data-testid": "demand_edit_identity_Ape",
                                dense: "",
                                outlined: "",
                                "emit-value": "",
                                "map-options": "",
                                "use-input": "",
                                "hide-selected": "",
                                "fill-input": "",
                                "input-debounce": "0",
                                modelValue: _ctx.party.organization.activitySector.type.value,
                                "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event: any) => ((_ctx.party.organization.activitySector.type.value) = $event)),
                                options: _ctx.filteredActivitySectorOptions,
                                onFilter: _ctx.filterActivitySector,
                                class: _normalizeClass(_ctx.isPartyOrganizationEligible.notEligible ? 'input-error' : '')
                              }, {
                                option: _withCtx((scope) => [
                                  _createVNode(_component_q_item, _normalizeProps(_guardReactiveProps(scope.itemProps)), {
                                    default: _withCtx(() => [
                                      _createVNode(_component_q_item_section, null, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_q_item_label, {
                                            style: _normalizeStyle({
                            color: scope.opt.flagEligible === false || scope.opt.flagEligible === 0 ? 'red' : 'inherit'
                          })
                                          }, {
                                            default: _withCtx(() => [
                                              _createTextVNode(_toDisplayString(scope.opt.label), 1)
                                            ]),
                                            _: 2
                                          }, 1032, ["style"])
                                        ]),
                                        _: 2
                                      }, 1024)
                                    ]),
                                    _: 2
                                  }, 1040)
                                ]),
                                _: 1
                              }, 8, ["rules", "modelValue", "options", "onFilter", "class"])
                            ]),
                            _createElementVNode("div", _hoisted_57, [
                              _createElementVNode("label", _hoisted_58, _toDisplayString(_ctx.$t("main.labels.geographicalZone")), 1),
                              _createVNode(_component_q_select, {
                                "data-testid": "demand_edit_identity_taxeGeographicalZone",
                                dense: "",
                                outlined: "",
                                "emit-value": "",
                                "map-options": "",
                                modelValue: _ctx.party.organization.taxGeographicZone,
                                "onUpdate:modelValue": _cache[32] || (_cache[32] = ($event: any) => ((_ctx.party.organization.taxGeographicZone) = $event)),
                                options: _ctx.geographicalZoneItems
                              }, null, 8, ["modelValue", "options"])
                            ]),
                            _createElementVNode("div", _hoisted_59, [
                              _createElementVNode("label", _hoisted_60, [
                                _createTextVNode(_toDisplayString(_ctx.$t("middleOffice.party.organization.identity.tvaIntracom")) + " ", 1),
                                _cache[104] || (_cache[104] = _createElementVNode("span", { class: "text-danger" }, "*", -1))
                              ]),
                              _createVNode(_component_q_input, {
                                "data-testid": "demand_edit_identity_tvaIntracom",
                                dense: "",
                                outlined: "",
                                modelValue: _ctx.party.organization.businessData.TVA_intracom,
                                "onUpdate:modelValue": _cache[33] || (_cache[33] = ($event: any) => ((_ctx.party.organization.businessData.TVA_intracom) = $event))
                              }, null, 8, ["modelValue"])
                            ]),
                            _createElementVNode("div", _hoisted_61, [
                              _createElementVNode("label", _hoisted_62, _toDisplayString(_ctx.$t(
                        "middleOffice.party.organization.identity.commercialRegister"
                      )), 1),
                              _createVNode(_component_q_input, {
                                "data-testid": "demand_edit_identity_commercialRegisterNumber",
                                dense: "",
                                outlined: "",
                                modelValue: _ctx.party.organization.commercialRegister,
                                "onUpdate:modelValue": _cache[34] || (_cache[34] = ($event: any) => ((_ctx.party.organization.commercialRegister) = $event))
                              }, null, 8, ["modelValue"])
                            ]),
                            _createElementVNode("div", _hoisted_63, [
                              _createElementVNode("label", _hoisted_64, _toDisplayString(_ctx.$t("middleOffice.party.organization.identity.isCreated")), 1),
                              _createVNode(_component_q_toggle, {
                                "data-testid": "demand_edit_identity_isCreated",
                                modelValue: _ctx.party.organization.isCreated,
                                "onUpdate:modelValue": _cache[35] || (_cache[35] = ($event: any) => ((_ctx.party.organization.isCreated) = $event)),
                                color: "primary"
                              }, null, 8, ["modelValue"])
                            ]),
                            (_ctx.party.businessData)
                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                                  _createElementVNode("div", _hoisted_65, [
                                    _createElementVNode("label", _hoisted_66, _toDisplayString(_ctx.$t("middleOffice.party.organization.identity.customerType")), 1),
                                    _createVNode(_component_q_input, {
                                      "data-testid": "demand_edit_identity_customerType",
                                      dense: "",
                                      outlined: "",
                                      modelValue: _ctx.party.businessData.customerType,
                                      "onUpdate:modelValue": _cache[36] || (_cache[36] = ($event: any) => ((_ctx.party.businessData.customerType) = $event))
                                    }, null, 8, ["modelValue"])
                                  ]),
                                  _createElementVNode("div", _hoisted_67, [
                                    _createElementVNode("label", _hoisted_68, _toDisplayString(_ctx.$t("middleOffice.party.organization.identity.activity")), 1),
                                    _createVNode(_component_q_input, {
                                      "data-testid": "demand_edit_identity_activity",
                                      dense: "",
                                      outlined: "",
                                      modelValue: _ctx.party.businessData.activity,
                                      "onUpdate:modelValue": _cache[37] || (_cache[37] = ($event: any) => ((_ctx.party.businessData.activity) = $event))
                                    }, null, 8, ["modelValue"])
                                  ])
                                ], 64))
                              : _createCommentVNode("", true),
                            _createElementVNode("div", _hoisted_69, [
                              _createElementVNode("label", _hoisted_70, _toDisplayString(`${_ctx.$t("middleOffice.party.organization.identity.naceCode")}`), 1),
                              _createVNode(_component_q_select, {
                                "data-testid": "third_edit_identity_naceCode",
                                dense: "",
                                outlined: "",
                                "emit-value": "",
                                "map-options": "",
                                "use-input": "",
                                "hide-selected": "",
                                "fill-input": "",
                                "input-debounce": "0",
                                modelValue: _ctx.party.organization.codeNACE.type.value,
                                "onUpdate:modelValue": _cache[38] || (_cache[38] = ($event: any) => ((_ctx.party.organization.codeNACE.type.value) = $event)),
                                options: _ctx.filteredNaceOptions,
                                onFilter: _ctx.filterNaceOptions
                              }, null, 8, ["modelValue", "options", "onFilter"])
                            ]),
                            _createElementVNode("div", _hoisted_71, [
                              _createElementVNode("label", _hoisted_72, [
                                _createTextVNode(_toDisplayString(`${_ctx.$t("middleOffice.party.organization.identity.QualificationTypeGroupe")}`) + " ", 1),
                                (_ctx.isPartySupplierOrDistributor())
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_73, " * "))
                                  : _createCommentVNode("", true)
                              ]),
                              _createVNode(_component_q_select, {
                                "data-testid": "third_edit_identity_qualificationTypeGroupe",
                                dense: "",
                                outlined: "",
                                "emit-value": "",
                                "map-options": "",
                                clearable: "",
                                "model-value": _ctx.party.organization.codeQualificationType?.type?.value,
                                "onUpdate:modelValue": _ctx.updateCodeQualificationTypeGroupe,
                                options: _ctx.qualificationTypeGroupeOptions,
                                rules: _ctx.isQualificationTypeGroupeRequired ? [(val) => !!val || _ctx.requiredField] : undefined
                              }, null, 8, ["model-value", "onUpdate:modelValue", "options", "rules"])
                            ]),
                            _createElementVNode("div", _hoisted_74, [
                              (_ctx.manager && _ctx.manager.show && _ctx.selectedPerson)
                                ? (_openBlock(), _createBlock(_component_q_list, { key: 0 }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_q_expansion_item, {
                                        "switch-toggle-side": "",
                                        "expand-icon-toggle": "",
                                        "expand-separator": "",
                                        "header-class": "card-header bg-transparent no-border p-4",
                                        class: "card tw-items-dashed-group tw-items-group-with-bg tw-level-two-group",
                                        modelValue: _ctx.managerOpened,
                                        "onUpdate:modelValue": _cache[57] || (_cache[57] = ($event: any) => ((_ctx.managerOpened) = $event))
                                      }, {
                                        header: _withCtx(() => [
                                          _createElementVNode("div", _hoisted_75, [
                                            _createElementVNode("div", _hoisted_76, [
                                              _createElementVNode("div", _hoisted_77, [
                                                _createTextVNode(_toDisplayString(_ctx.toUpperCase(_ctx.$t("main.labels.manager"))) + " ", 1),
                                                _createVNode(_component_q_btn, {
                                                  "data-testid": "demand_edit_identity_manager_SearchButton",
                                                  class: "btn btn-sm btn-primary ml-2",
                                                  icon: "search",
                                                  onClickCapture: _withModifiers(_ctx.searchManager, ["stop"]),
                                                  disable: _ctx.party.type.id === ''
                                                }, null, 8, ["onClickCapture", "disable"])
                                              ])
                                            ])
                                          ])
                                        ]),
                                        default: _withCtx(() => [
                                          _createElementVNode("div", _hoisted_78, [
                                            _createElementVNode("div", _hoisted_79, [
                                              _createElementVNode("div", _hoisted_80, [
                                                _createElementVNode("label", _hoisted_81, _toDisplayString(_ctx.$t("main.labels.title")), 1),
                                                _createVNode(_component_q_select, {
                                                  "data-testid": "demand_edit_identity_manager_title",
                                                  dense: "",
                                                  outlined: "",
                                                  "emit-value": "",
                                                  "map-options": "",
                                                  style: {"margin-bottom":"20px","margin-right":"10px"},
                                                  modelValue: _ctx.manager.title.type.value,
                                                  "onUpdate:modelValue": _cache[39] || (_cache[39] = ($event: any) => ((_ctx.manager.title.type.value) = $event)),
                                                  options: _ctx.title,
                                                  disable: _ctx.checkEditManager
                                                }, null, 8, ["modelValue", "options", "disable"])
                                              ]),
                                              _createElementVNode("div", _hoisted_82, [
                                                _createElementVNode("label", _hoisted_83, _toDisplayString(_ctx.$t("main.labels.familyName")), 1),
                                                _createVNode(_component_q_input, {
                                                  "data-testid": "demand_edit_identity_manager_familyName",
                                                  dense: "",
                                                  outlined: "",
                                                  modelValue: _ctx.manager.familyName,
                                                  "onUpdate:modelValue": _cache[40] || (_cache[40] = ($event: any) => ((_ctx.manager.familyName) = $event)),
                                                  style: {"margin-bottom":"20px","margin-right":"10px"},
                                                  disable: _ctx.checkEditManager
                                                }, null, 8, ["modelValue", "disable"])
                                              ]),
                                              _createElementVNode("div", _hoisted_84, [
                                                _createElementVNode("label", _hoisted_85, _toDisplayString(_ctx.$t("main.labels.firstName")), 1),
                                                _createVNode(_component_q_input, {
                                                  "data-testid": "demand_edit_identity_manager_firstName",
                                                  dense: "",
                                                  outlined: "",
                                                  modelValue: _ctx.manager.firstName,
                                                  "onUpdate:modelValue": _cache[41] || (_cache[41] = ($event: any) => ((_ctx.manager.firstName) = $event)),
                                                  style: {"margin-bottom":"20px","margin-right":"10px"},
                                                  disable: _ctx.checkEditManager
                                                }, null, 8, ["modelValue", "disable"])
                                              ]),
                                              _createElementVNode("div", _hoisted_86, [
                                                _createElementVNode("div", _hoisted_87, [
                                                  _createElementVNode("div", _hoisted_88, [
                                                    _createElementVNode("label", _hoisted_89, _toDisplayString(_ctx.$t("main.labels.birthDate")), 1),
                                                    _createVNode(_component_q_input, {
                                                      "data-testid": "demand_edit_identity_manager_Input_birthDate",
                                                      dense: "",
                                                      outlined: "",
                                                      style: {"margin-right":"10px"},
                                                      ref: "birthDateRef",
                                                      modelValue: _ctx.manager.birthDate,
                                                      "onUpdate:modelValue": [
                                                        _cache[44] || (_cache[44] = ($event: any) => ((_ctx.manager.birthDate) = $event)),
                                                        _cache[45] || (_cache[45] = ($event: any) => (
                                    _ctx.calculateAge($event, _ctx.manager)
                                    ))
                                                      ],
                                                      disable: _ctx.checkEditManager,
                                                      mask: _ctx.maskInput
                                                    }, {
                                                      append: _withCtx(() => [
                                                        _createVNode(_component_q_icon, {
                                                          "data-testid": "demand_edit_identity_manager_birthDateIcon",
                                                          name: "event",
                                                          class: "cursor-pointer"
                                                        }, {
                                                          default: _withCtx(() => [
                                                            _createVNode(_component_q_popup_proxy, {
                                                              "data-testid": "demand_edit_identity_manager_PopupProxy_birthDate",
                                                              ref: "qDateProxy",
                                                              cover: "",
                                                              "transition-show": "scale",
                                                              "transition-hide": "scale"
                                                            }, {
                                                              default: _withCtx(() => [
                                                                _createVNode(_component_q_date, {
                                                                  "data-testid": "demand_edit_identity_manager_Date_birthDate",
                                                                  modelValue: _ctx.manager.birthDate,
                                                                  "onUpdate:modelValue": [
                                                                    _cache[42] || (_cache[42] = ($event: any) => ((_ctx.manager.birthDate) = $event)),
                                                                    _cache[43] || (_cache[43] = ($event: any) => (
                                            _ctx.calculateAge($event, _ctx.manager)
                                            ))
                                                                  ],
                                                                  mask: _ctx.maskFormat,
                                                                  locale: _ctx.FR
                                                                }, {
                                                                  default: _withCtx(() => [
                                                                    _createElementVNode("div", _hoisted_90, [
                                                                      _withDirectives(_createVNode(_component_q_btn, {
                                                                        "data-testid": "demand_edit_identity_manager_Button_birthDate",
                                                                        label: _ctx.$t(
                                                'task.completeDocument.party.person.financialSituation.close'
                                              )
                                                ,
                                                                        color: "primary",
                                                                        flat: ""
                                                                      }, null, 8, ["label"]), [
                                                                        [_directive_close_popup]
                                                                      ])
                                                                    ])
                                                                  ]),
                                                                  _: 1
                                                                }, 8, ["modelValue", "mask", "locale"])
                                                              ]),
                                                              _: 1
                                                            }, 512)
                                                          ]),
                                                          _: 1
                                                        })
                                                      ]),
                                                      _: 1
                                                    }, 8, ["modelValue", "disable", "mask"])
                                                  ]),
                                                  _createElementVNode("div", _hoisted_91, [
                                                    _createElementVNode("label", _hoisted_92, _toDisplayString(_ctx.$t("main.labels.age")), 1),
                                                    _createVNode(_component_q_input, {
                                                      "data-testid": "demand_edit_identity_manager_age",
                                                      dense: "",
                                                      outlined: "",
                                                      modelValue: _ctx.manager.age,
                                                      "onUpdate:modelValue": _cache[46] || (_cache[46] = ($event: any) => ((_ctx.manager.age) = $event)),
                                                      style: {"margin-bottom":"20px","margin-right":"10px"},
                                                      suffix: " ans",
                                                      readonly: ""
                                                    }, null, 8, ["modelValue"])
                                                  ])
                                                ])
                                              ]),
                                              _createElementVNode("div", _hoisted_93, [
                                                _createElementVNode("label", _hoisted_94, _toDisplayString(_ctx.$t("main.labels.telephone")), 1),
                                                _createVNode(_component_q_input, {
                                                  "data-testid": "demand_edit_identity_manager_phone",
                                                  dense: "",
                                                  outlined: "",
                                                  "fill-mask": "",
                                                  modelValue: _ctx.manager.contacts[0].contactMechanism.phoneNumber
                              ,
                                                  "onUpdate:modelValue": _cache[47] || (_cache[47] = ($event: any) => ((_ctx.manager.contacts[0].contactMechanism.phoneNumber
                              ) = $event))
                                                }, null, 8, ["modelValue"])
                                              ]),
                                              _createElementVNode("div", _hoisted_95, [
                                                _createElementVNode("label", _hoisted_96, _toDisplayString(_ctx.$t("main.labels.dateOfEntry")), 1),
                                                _createVNode(_component_q_input, {
                                                  "data-testid": "demand_edit_identity_manager_entryDate",
                                                  dense: "",
                                                  outlined: "",
                                                  mask: _ctx.maskInput,
                                                  modelValue: _ctx.manager.validity.from,
                                                  "onUpdate:modelValue": _cache[49] || (_cache[49] = ($event: any) => ((_ctx.manager.validity.from) = $event))
                                                }, {
                                                  append: _withCtx(() => [
                                                    _createVNode(_component_q_icon, {
                                                      "data-testid": "demand_edit_identity_manager_icon_entryDate",
                                                      name: "event",
                                                      class: "cursor-pointer"
                                                    }, {
                                                      default: _withCtx(() => [
                                                        _createVNode(_component_q_popup_proxy, {
                                                          "data-testid": "demand_edit_identity_manager_popupProxy_entryDate",
                                                          ref: "qDateProxy",
                                                          cover: "",
                                                          "transition-show": "scale",
                                                          "transition-hide": "scale"
                                                        }, {
                                                          default: _withCtx(() => [
                                                            _createVNode(_component_q_date, {
                                                              "data-testid": "demand_edit_identity_manager_date_entryDate",
                                                              mask: _ctx.maskFormat,
                                                              modelValue: _ctx.manager.validity.from,
                                                              "onUpdate:modelValue": _cache[48] || (_cache[48] = ($event: any) => ((_ctx.manager.validity.from) = $event)),
                                                              locale: _ctx.FR
                                                            }, {
                                                              default: _withCtx(() => [
                                                                _createElementVNode("div", _hoisted_97, [
                                                                  _withDirectives(_createVNode(_component_q_btn, {
                                                                    "data-testid": "demand_edit_identity_manager_button_entryDate",
                                                                    label: _ctx.$t(
                                            'task.completeDocument.party.person.financialSituation.close'
                                          )
                                            ,
                                                                    color: "primary",
                                                                    flat: ""
                                                                  }, null, 8, ["label"]), [
                                                                    [_directive_close_popup]
                                                                  ])
                                                                ])
                                                              ]),
                                                              _: 1
                                                            }, 8, ["mask", "modelValue", "locale"])
                                                          ]),
                                                          _: 1
                                                        }, 512)
                                                      ]),
                                                      _: 1
                                                    })
                                                  ]),
                                                  _: 1
                                                }, 8, ["mask", "modelValue"])
                                              ]),
                                              _createElementVNode("div", _hoisted_98, [
                                                _createElementVNode("label", _hoisted_99, _toDisplayString(_ctx.$t("main.labels.relationType")), 1),
                                                _createVNode(_component_q_select, {
                                                  "data-testid": "demand_edit_identity_manager_relationType",
                                                  dense: "",
                                                  outlined: "",
                                                  "emit-value": "",
                                                  "map-options": "",
                                                  style: {"margin-bottom":"20px","margin-right":"10px"},
                                                  modelValue: _ctx.manager.relationType.type.value,
                                                  "onUpdate:modelValue": _cache[50] || (_cache[50] = ($event: any) => ((_ctx.manager.relationType.type.value) = $event)),
                                                  options: _ctx.relationTypes
                                                }, null, 8, ["modelValue", "options"])
                                              ]),
                                              _createElementVNode("div", _hoisted_100, [
                                                _createElementVNode("label", _hoisted_101, _toDisplayString(_ctx.$t("main.labels.bornCountry")), 1),
                                                _createVNode(_component_q_select, {
                                                  "data-testid": "demand_edit_identity_manager_bornCountry",
                                                  dense: "",
                                                  outlined: "",
                                                  "emit-value": "",
                                                  "map-options": "",
                                                  modelValue: _ctx.manager.birthplace.type.config.country.id
                                ,
                                                  "onUpdate:modelValue": [
                                                    _cache[51] || (_cache[51] = ($event: any) => ((_ctx.manager.birthplace.type.config.country.id
                                ) = $event)),
                                                    _cache[52] || (_cache[52] = ($event: any) => (
                                  _ctx.changePostalCodeManager($event, _ctx.manager)
                                  ))
                                                  ],
                                                  options: _ctx.nationality,
                                                  onInput: _ctx.filterPostalCodeManagerWithCountry
                                                }, null, 8, ["modelValue", "options", "onInput"])
                                              ]),
                                              (_ctx.currentRoute === 'TaskDetail')
                                                ? (_openBlock(), _createElementBlock("div", _hoisted_102, [
                                                    _createElementVNode("label", _hoisted_103, _toDisplayString(_ctx.$t("main.labels.gender")), 1),
                                                    _createVNode(_component_q_select, {
                                                      "data-testid": "demand_edit_identity_manager_gender",
                                                      dense: "",
                                                      outlined: "",
                                                      "emit-value": "",
                                                      "map-options": "",
                                                      modelValue: _ctx.manager.gender,
                                                      "onUpdate:modelValue": _cache[53] || (_cache[53] = ($event: any) => ((_ctx.manager.gender) = $event)),
                                                      options: _ctx.gender
                                                    }, null, 8, ["modelValue", "options"])
                                                  ]))
                                                : _createCommentVNode("", true),
                                              _createElementVNode("div", _hoisted_104, [
                                                _createElementVNode("label", _hoisted_105, _toDisplayString(_ctx.$t("main.labels.postalCode_cityOfBirth")), 1),
                                                _createVNode(_component_q_select, {
                                                  "data-testid": "demand_edit_identity_manager_cityOfBirth",
                                                  dense: "",
                                                  outlined: "",
                                                  "use-input": "",
                                                  "hide-selected": "",
                                                  "fill-input": "",
                                                  "onUpdate:modelValue": [
                                                    _cache[55] || (_cache[55] = ($event: any) => (
                                _ctx.changePostalCodeManager($event, _ctx.manager))),
                                                    _cache[56] || (_cache[56] = ($event: any) => ((_ctx.manager.birthplace.type) = $event))
                                                  ],
                                                  modelValue: _ctx.manager.birthplace.type,
                                                  options: _ctx.postalCodes,
                                                  onFilter: _ctx.filterPostalCodeManagerWithCountry
                                                }, {
                                                  "no-option": _withCtx(() => [
                                                    _createVNode(_component_q_item, { "data-testid": "demand_edit_identity_manager_item_cityOfBirth" }, {
                                                      default: _withCtx(() => [
                                                        _createVNode(_component_q_item_section, {
                                                          "data-testid": "demand_edit_identity_manager_itemSection_cityOfBirth",
                                                          class: "text-grey"
                                                        }, {
                                                          default: _withCtx(() => [
                                                            _createTextVNode(_toDisplayString(_ctx.$t("main.noResults")), 1)
                                                          ]),
                                                          _: 1
                                                        })
                                                      ]),
                                                      _: 1
                                                    })
                                                  ]),
                                                  append: _withCtx(() => [
                                                    _createVNode(_component_q_icon, {
                                                      "data-testid": "demand_edit_identity_manager_cityOfBirth_iconSearch",
                                                      name: "search",
                                                      onClick: _cache[54] || (_cache[54] = _withModifiers(() => {}, ["stop"]))
                                                    })
                                                  ]),
                                                  _: 1
                                                }, 8, ["modelValue", "options", "onFilter"])
                                              ])
                                            ])
                                          ])
                                        ]),
                                        _: 1
                                      }, 8, ["modelValue"])
                                    ]),
                                    _: 1
                                  }))
                                : _createCommentVNode("", true)
                            ])
                          ], true)
                        : _createCommentVNode("", true)
                    ]),
                    (this.role?.businessData?.isPartPro && (this.role?.role_code === 'CUSTOMER' || this.role?.role_code === 'COLOCATAIRE'))
                      ? (_openBlock(), _createBlock(_component_PartyProDetails, {
                          key: 0,
                          party: _ctx.matchedSGThirdParty,
                          expansionInitially: true
                        }, null, 8, ["party"]))
                      : _createCommentVNode("", true)
                  ]),
                  (_ctx.currentRoute === 'TaskDetail'
            && this.role?.associatedParty?.role_code === 'CUSTOMER')
                    ? (_openBlock(), _createBlock(_component_Comment, {
                        key: 0,
                        qualificationType: 'PRT-IDT',
                        role: 'CUSTOMER'
                      }))
                    : _createCommentVNode("", true),
                  (_ctx.currentRoute === 'TaskDetail'
            && this.role?.associatedParty?.role_code === 'COLOCATAIRE')
                    ? (_openBlock(), _createBlock(_component_Comment, {
                        key: 1,
                        qualificationType: 'PRT-IDT-COLOC',
                        role: 'COLOCATAIRE'
                      }))
                    : _createCommentVNode("", true),
                  (_ctx.currentRoute === 'TaskDetail'
            && this.role?.associatedParty?.role_code === 'DISTRIBUTOR')
                    ? (_openBlock(), _createBlock(_component_Comment, {
                        key: 2,
                        qualificationType: 'PRT-IDT-DIST',
                        role: 'DISTRIBUTOR'
                      }))
                    : _createCommentVNode("", true),
                  (_ctx.currentRoute === 'TaskDetail'
            && this.role?.associatedParty?.role_code === 'SUPPLIER')
                    ? (_openBlock(), _createBlock(_component_Comment, {
                        key: 3,
                        qualificationType: 'PRT-IDT-SUP',
                        role: 'SUPPLIER'
                      }))
                    : _createCommentVNode("", true)
                ]),
                _: 3
              }, 8, ["class", "modelValue", "onShow", "onHide"])
            ]),
            _: 3
          }),
          (_ctx.isPersonPhysique && _ctx.isPartySupplierOrDistributor())
            ? (_openBlock(), _createBlock(_component_q_list, { key: 0 }, {
                default: _withCtx(() => [
                  _createVNode(_component_q_expansion_item, {
                    "switch-toggle-side": "",
                    "expand-separator": "",
                    onShow: _cache[64] || (_cache[64] = ($event: any) => {
          _ctx.situationBtn = !_ctx.situationBtn;
        _ctx.addExpandSituation(_ctx.party.person.maritalStatuses);
        }),
                    onHide: _cache[65] || (_cache[65] = ($event: any) => {
          _ctx.situationBtn = !_ctx.situationBtn;
        _ctx.removeExpandedItem<
          party.person.maritalStatuses>
        _ctx.party.person.maritalStatuses;
        }),
                    "header-class": "card-header bg-transparent no-border p-4",
                    class: _normalizeClass(["card tw-items-dashed-group tw-items-group-with-bg", _ctx.currentRoute === 'TaskDetail' ? 'tw-analysis-section' : ''])
                  }, {
                    header: _withCtx(() => [...(_cache[105] || (_cache[105] = [
                      _createElementVNode("div", { class: "card-title flex-grow-1 justify-content-between align-items-center mb-0" }, [
                        _createElementVNode("div", { class: "d-flex justify-content-between" }, [
                          _createElementVNode("div", { class: "font-semi-bold font-size-12" }, "SITUATION")
                        ])
                      ], -1)
                    ]))]),
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_106, [
                        _createElementVNode("div", _hoisted_107, [
                          _createElementVNode("div", _hoisted_108, [
                            _createElementVNode("label", _hoisted_109, _toDisplayString(_ctx.$t("party.situation.maritalStatus")), 1),
                            _createVNode(_component_q_select, {
                              data_testid: "demand_edit_situation_maritalStatus",
                              dense: "",
                              outlined: "",
                              "emit-value": "",
                              "map-options": "",
                              modelValue: _ctx.party.person.currentMaritalStatus.type.value,
                              "onUpdate:modelValue": _cache[59] || (_cache[59] = ($event: any) => ((_ctx.party.person.currentMaritalStatus.type.value) = $event)),
                              options: _ctx.statusesMarital,
                              disable: !_ctx.situationCanBeEdited
                            }, null, 8, ["modelValue", "options", "disable"])
                          ]),
                          _createElementVNode("div", _hoisted_110, [
                            _createElementVNode("label", _hoisted_111, _toDisplayString(_ctx.$t("party.situation.matrimonialRegime")), 1),
                            _createVNode(_component_q_select, {
                              data_testid: "demand_edit_situation_matrimonialRegime",
                              dense: "",
                              outlined: "",
                              "emit-value": "",
                              "map-options": "",
                              modelValue: _ctx.party.person.currentMatrimonialRegime.type.value,
                              "onUpdate:modelValue": _cache[60] || (_cache[60] = ($event: any) => ((_ctx.party.person.currentMatrimonialRegime.type.value) = $event)),
                              options: _ctx.matrimonialRegime,
                              disable: !_ctx.situationCanBeEdited
                            }, null, 8, ["modelValue", "options", "disable"])
                          ]),
                          _createElementVNode("div", _hoisted_112, [
                            _createElementVNode("label", _hoisted_113, _toDisplayString(_ctx.$t("party.situation.peopleInCharge")), 1),
                            _createVNode(_component_q_input, {
                              "data-testid": "demand_edit_situation_peopleInCharge",
                              mask: "##",
                              dense: "",
                              outlined: "",
                              "model-value": _ctx.party.person.nbOfDependent,
                              "onUpdate:modelValue": _cache[61] || (_cache[61] = ($event: any) => (
                    _ctx.roundNumber($event, _ctx.party.person, 'nbOfDependent')
                    )),
                              onKeydown: _ctx.globalConfig.formatters.keyHandler,
                              disable: !_ctx.situationCanBeEdited
                            }, null, 8, ["model-value", "onKeydown", "disable"])
                          ]),
                          _createElementVNode("div", _hoisted_114, [
                            _createElementVNode("label", _hoisted_115, _toDisplayString(_ctx.$t("party.situation.becameRetiredIn")), 1),
                            _createVNode(_component_q_input, {
                              "data-testid": "demand_edit_situation_input_retirementPassage",
                              dense: "",
                              outlined: "",
                              modelValue: _ctx.party.person.retirementPassage,
                              "onUpdate:modelValue": _cache[63] || (_cache[63] = ($event: any) => ((_ctx.party.person.retirementPassage) = $event)),
                              mask: _ctx.maskInput,
                              disable: !_ctx.situationCanBeEdited
                            }, {
                              append: _withCtx(() => [
                                _createVNode(_component_q_icon, {
                                  "data-testid": "demand_edit_situation_icon_retirementPassage",
                                  name: "event",
                                  class: "cursor-pointer"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_q_popup_proxy, {
                                      "data-testid": "demand_edit_situation_popupProxy_retirementPassage",
                                      ref: "qDateProxy",
                                      cover: "",
                                      "transition-show": "scale",
                                      "transition-hide": "scale"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_q_date, {
                                          "data-testid": "demand_edit_situation_date_retirementPassage",
                                          modelValue: _ctx.party.person.retirementPassage,
                                          "onUpdate:modelValue": _cache[62] || (_cache[62] = ($event: any) => ((_ctx.party.person.retirementPassage) = $event)),
                                          mask: _ctx.dateMask,
                                          locale: _ctx.FR
                                        }, {
                                          default: _withCtx(() => [
                                            _createElementVNode("div", _hoisted_116, [
                                              _withDirectives(_createVNode(_component_q_btn, {
                                                label: _ctx.$t(
                              'task.completeDocument.party.person.financialSituation.close'
                            )
                              ,
                                                color: "primary",
                                                flat: ""
                                              }, null, 8, ["label"]), [
                                                [_directive_close_popup]
                                              ])
                                            ])
                                          ]),
                                          _: 1
                                        }, 8, ["modelValue", "mask", "locale"])
                                      ]),
                                      _: 1
                                    }, 512)
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }, 8, ["modelValue", "mask", "disable"])
                          ]),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.party.person.birthChildren, (children, index) => {
                            return (_openBlock(), _createElementBlock("div", {
                              class: "col-lg-3 col-md-6 col-sm-12 form-control no-border",
                              id: "demand_edit_situation_birthChildren",
                              key: index
                            }, [
                              _createElementVNode("div", _hoisted_117, [
                                _createElementVNode("div", _hoisted_118, [
                                  _createElementVNode("label", _hoisted_119, _toDisplayString(_ctx.$t("party.situation.childDateOfBirth")), 1),
                                  _createVNode(_component_q_input, {
                                    "data-testid": "demand_edit_situation_input_birthChildren",
                                    dense: "",
                                    outlined: "",
                                    modelValue: _ctx.party.person.birthChildren[index].dateOfBirthChildren
                      ,
                                    "onUpdate:modelValue": [($event: any) => ((_ctx.party.person.birthChildren[index].dateOfBirthChildren
                      ) = $event), ($event: any) => (
                        _ctx.calculateChildrenAge(_ctx.party.person.birthChildren[index])
                        )],
                                    mask: _ctx.maskInput,
                                    disable: !_ctx.situationCanBeEdited
                                  }, {
                                    append: _withCtx(() => [
                                      _createVNode(_component_q_icon, {
                                        "data-testid": "demand_edit_situation_icon_birthChildren",
                                        name: "event",
                                        class: "cursor-pointer"
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_q_popup_proxy, {
                                            "data-testid": "demand_edit_situation_birthChildren",
                                            ref_for: true,
                                            ref: "qDateProxy",
                                            cover: "",
                                            "transition-show": "scale",
                                            "transition-hide": "scale"
                                          }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_q_date, {
                                                "data-testid": "demand_edit_situation_date_birthChildren",
                                                modelValue: _ctx.party.person.birthChildren[index]
                              .dateOfBirthChildren
                              ,
                                                "onUpdate:modelValue": [($event: any) => ((_ctx.party.person.birthChildren[index]
                              .dateOfBirthChildren
                              ) = $event), ($event: any) => (
                                _ctx.calculateChildrenAge(
                                  _ctx.party.person.birthChildren[index]
                                )
                                )],
                                                mask: _ctx.dateMask,
                                                locale: _ctx.FR
                                              }, {
                                                default: _withCtx(() => [
                                                  _createElementVNode("div", _hoisted_120, [
                                                    _withDirectives(_createVNode(_component_q_btn, {
                                                      "data-testid": "demand_edit_situation_button_birthChildren",
                                                      label: _ctx.$t(
                                  'task.completeDocument.party.person.financialSituation.close'
                                )
                                  ,
                                                      color: "primary",
                                                      flat: ""
                                                    }, null, 8, ["label"]), [
                                                      [_directive_close_popup]
                                                    ])
                                                  ])
                                                ]),
                                                _: 1
                                              }, 8, ["modelValue", "onUpdate:modelValue", "mask", "locale"])
                                            ]),
                                            _: 2
                                          }, 1536)
                                        ]),
                                        _: 2
                                      }, 1024)
                                    ]),
                                    _: 2
                                  }, 1032, ["modelValue", "onUpdate:modelValue", "mask", "disable"])
                                ]),
                                _createElementVNode("div", _hoisted_121, [
                                  _cache[106] || (_cache[106] = _createElementVNode("label", { class: "d-block mb-0 small text-muted" }, " Age ", -1)),
                                  _createVNode(_component_q_input, {
                                    "data-testid": "demand_edit_situation_age",
                                    dense: "",
                                    outlined: "",
                                    modelValue: _ctx.party.person.birthChildren[index].childrenAge,
                                    "onUpdate:modelValue": ($event: any) => ((_ctx.party.person.birthChildren[index].childrenAge) = $event),
                                    suffix: " ans",
                                    readonly: ""
                                  }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                ]),
                                _createElementVNode("div", _hoisted_122, [
                                  _createVNode(_component_q_btn, {
                                    "data-testid": "demand_edit_situation_deleteButton",
                                    outline: "",
                                    icon: "delete",
                                    size: "sm",
                                    onClick: ($event: any) => (_ctx.removeBirthChildren(index)),
                                    disable: !_ctx.situationCanBeEdited ||
                        _ctx.$store.getters['authModule/hasMiddleOffice']
                        ,
                                    class: "btn btn-outline-danger mt-3"
                                  }, null, 8, ["onClick", "disable"])
                                ])
                              ])
                            ]))
                          }), 128))
                        ])
                      ]),
                      (_ctx.currentRoute === 'TaskDetail' && _ctx.opinionQualifications.length > 0
          )
                        ? (_openBlock(), _createBlock(_component_Comment, {
                            key: 0,
                            qualificationType: 'PRT-STU'
                          }))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  }, 8, ["class"])
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (_ctx.isPersonPhysique && _ctx.isPartySupplierOrDistributor())
            ? (_openBlock(), _createBlock(_component_q_list, { key: 1 }, {
                default: _withCtx(() => [
                  _createVNode(_component_q_expansion_item, {
                    "switch-toggle-side": "",
                    "expand-separator": "",
                    "header-class": "card-header bg-transparent no-border p-4",
                    class: _normalizeClass(["card tw-items-dashed-group tw-items-group-with-bg", _ctx.currentRoute === 'TaskDetail' ? 'tw-analysis-section' : '']),
                    onShow: _cache[67] || (_cache[67] = ($event: any) => {
            _ctx.communicationPlusBtn = !_ctx.communicationPlusBtn;
          _ctx.addExpandedItem<
            contacts>
            (_ctx.contacts,
              _ctx.$store.getters['demandModule/getContactMechanismInit']);
          }),
                    onHide: _cache[68] || (_cache[68] = ($event: any) => {
            _ctx.communicationPlusBtn = !_ctx.communicationPlusBtn;
          _ctx.removeExpandedItem < _ctx.contacts > _ctx.contacts;
          })
                  }, {
                    header: _withCtx(() => [
                      _createElementVNode("div", _hoisted_123, [
                        _createElementVNode("div", _hoisted_124, [
                          _createElementVNode("div", _hoisted_125, _toDisplayString(_ctx.$t(
                      "task.completeDocument.party.organization.section.meansOfCommunication"
                    )), 1),
                          ((_ctx.isCommunicationPlusBtnDisabled ||
                  _ctx.$store.getters['authModule/hasMiddleOffice']) && _ctx.taskDefinition !== 'STEP_START_ANALYSIS'
                )
                            ? (_openBlock(), _createBlock(_component_q_btn, {
                                key: 0,
                                "data-testid": "demand_edit_meansOfCommunication_addButton",
                                outline: "",
                                icon: "add",
                                onClickCapture: _cache[66] || (_cache[66] = _withModifiers(($event: any) => (
                  _ctx.add(
                    _ctx.contacts,
                    _ctx.$store.getters['demandModule/getContactMechanismInit']
                  )
                  ), ["stop"])),
                                class: "btn btn-primary btn-sm ml-3"
                              }))
                            : _createCommentVNode("", true)
                        ])
                      ])
                    ]),
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_126, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.contacts, (contact, index) => {
                          return (_openBlock(), _createElementBlock("div", {
                            class: "p-2 bg-white default-border-radius mb-3",
                            key: index
                          }, [
                            _createElementVNode("div", _hoisted_127, [
                              _createElementVNode("div", _hoisted_128, [
                                _createElementVNode("div", _hoisted_129, [
                                  _createElementVNode("div", {
                                    class: "col-lg-3 col-md-6 col-sm-12 form-control no-border",
                                    id: 'demand_edit_meansOfCommunication_type_' + index
                                  }, [
                                    _createElementVNode("label", _hoisted_131, _toDisplayString(_ctx.$t("main.type")), 1),
                                    _createVNode(_component_q_select, {
                                      "data-testid": 'demand_edit_meansOfCommunication_type_' + index
                        ,
                                      dense: "",
                                      outlined: "",
                                      modelValue: contact.contactMechanism.type,
                                      "onUpdate:modelValue": ($event: any) => ((contact.contactMechanism.type) = $event),
                                      options: _ctx.contactType,
                                      disable: contact.contactMechanism.blocked ||
                          contact.contactMechanism.type?.config?.disabled
                          
                                    }, null, 8, ["data-testid", "modelValue", "onUpdate:modelValue", "options", "disable"])
                                  ], 8, _hoisted_130),
                                  _createElementVNode("div", {
                                    class: "col-lg-3 col-md-6 col-sm-12 form-control no-border",
                                    id: 'demand_edit_meansOfCommunication_typeValue_' + index
                      
                                  }, [
                                    (contact.contactMechanism.type.id === 'EMAIL_CONTACT'
                      )
                                      ? (_openBlock(), _createElementBlock("div", {
                                          key: 0,
                                          id: 'demand_edit_meansOfCommunication_emailContact_' +
                        index
                        
                                        }, [
                                          _createElementVNode("label", _hoisted_134, _toDisplayString(_ctx.$t(
                              "task.completeDocument.party.organization.meansOfCommunication.emailAddress"
                            )), 1),
                                          _createVNode(_component_q_input, {
                                            "data-testid": 'demand_edit_meansOfCommunication_emailContact_' +
                          index
                          ,
                                            dense: "",
                                            outlined: "",
                                            modelValue: contact.contactMechanism.emailAddress,
                                            "onUpdate:modelValue": ($event: any) => ((contact.contactMechanism.emailAddress) = $event),
                                            rules: [(val) => _ctx.isValidEmail(val)]
                                          }, null, 8, ["data-testid", "modelValue", "onUpdate:modelValue", "rules"])
                                        ], 8, _hoisted_133))
                                      : _createCommentVNode("", true),
                                    (contact.contactMechanism.type.id === 'PHONE_CONTACT'
                      )
                                      ? (_openBlock(), _createElementBlock("div", {
                                          key: 1,
                                          id: 'demand_edit_meansOfCommunication_phoneNumber_' +
                        index
                        
                                        }, [
                                          _createElementVNode("label", _hoisted_136, _toDisplayString(_ctx.$t(
                              "task.completeDocument.party.organization.meansOfCommunication.phoneNumber"
                            )), 1),
                                          _createVNode(_component_q_input, {
                                            "data-testid": 'demand_edit_meansOfCommunication_phoneNumber_' +
                          index
                          ,
                                            dense: "",
                                            outlined: "",
                                            modelValue: contact.contactMechanism.phoneNumber,
                                            "onUpdate:modelValue": ($event: any) => ((contact.contactMechanism.phoneNumber) = $event),
                                            "fill-mask": ""
                                          }, null, 8, ["data-testid", "modelValue", "onUpdate:modelValue"])
                                        ], 8, _hoisted_135))
                                      : _createCommentVNode("", true),
                                    (contact.contactMechanism.type.id ===
                        'MESSENGER_CONTACT'
                      )
                                      ? (_openBlock(), _createElementBlock("div", {
                                          key: 2,
                                          id: 'demand_edit_meansOfCommunication_identifier_' + index
                        
                                        }, [
                                          _createElementVNode("label", _hoisted_138, _toDisplayString(_ctx.$t(
                              "task.completeDocument.party.organization.meansOfCommunication.identifier"
                            )), 1),
                                          _createVNode(_component_q_input, {
                                            "data-testid": 'demand_edit_meansOfCommunication_identifier_' +
                          index
                          ,
                                            dense: "",
                                            outlined: "",
                                            modelValue: contact.contactMechanism.identifier,
                                            "onUpdate:modelValue": ($event: any) => ((contact.contactMechanism.identifier) = $event)
                                          }, null, 8, ["data-testid", "modelValue", "onUpdate:modelValue"])
                                        ], 8, _hoisted_137))
                                      : _createCommentVNode("", true)
                                  ], 8, _hoisted_132),
                                  _createElementVNode("div", {
                                    class: "col-lg-3 col-md-6 col-sm-12 form-control no-border",
                                    id: 'demand_edit_meansOfCommunication_noSolicitation_' +
                      index
                      
                                  }, [
                                    _createElementVNode("label", _hoisted_140, _toDisplayString(_ctx.$t(
                            "middleOffice.party.organization.role.nonSolicitation"
                          )), 1),
                                    _createVNode(_component_q_toggle, {
                                      modelValue: contact.contactMechanism.nonSolicitation,
                                      "onUpdate:modelValue": ($event: any) => ((contact.contactMechanism.nonSolicitation) = $event),
                                      disable: contact.contactMechanism.isDisabled
                                    }, null, 8, ["modelValue", "onUpdate:modelValue", "disable"])
                                  ], 8, _hoisted_139)
                                ])
                              ]),
                              _createElementVNode("div", null, [
                                _createVNode(_component_q_btn, {
                                  "data-testid": "demand_edit_meansOfCommunication_deleteContactButton",
                                  outline: "",
                                  icon: "delete",
                                  onClick: ($event: any) => (_ctx.removeContacts(index, _ctx.contacts)),
                                  class: "btn btn-outline-danger mt-3",
                                  disable: _ctx.$store.getters['authModule/hasMiddleOffice']
                                }, null, 8, ["onClick", "disable"])
                              ])
                            ])
                          ]))
                        }), 128))
                      ])
                    ]),
                    _: 1
                  }, 8, ["class"])
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (!_ctx.isPersonPhysique && _ctx.isPartySupplierOrDistributor())
            ? (_openBlock(), _createBlock(_component_q_list, { key: 2 }, {
                default: _withCtx(() => [
                  _createVNode(_component_q_expansion_item, {
                    "switch-toggle-side": "",
                    "expand-separator": "",
                    "header-class": "card-header bg-transparent no-border p-4",
                    class: _normalizeClass(["card tw-items-dashed-group tw-items-group-with-bg", _ctx.currentRoute === 'TaskDetail' ? 'tw-analysis-section' : '']),
                    onShow: _cache[70] || (_cache[70] = ($event: any) => {
            _ctx.personBtn = !_ctx.personBtn;
          _ctx.addExpandCorrespondent(_ctx.correspondents);
          }),
                    onHide: _cache[71] || (_cache[71] = ($event: any) => {
            _ctx.personBtn = !_ctx.personBtn;
          _ctx.removeExpandedItem < _ctx.correspondents > _ctx.correspondents;
          })
                  }, {
                    header: _withCtx(() => [
                      _createElementVNode("div", _hoisted_141, [
                        _createElementVNode("div", _hoisted_142, [
                          _createElementVNode("div", _hoisted_143, _toDisplayString(_ctx.$t(
                      "task.completeDocument.party.organization.section.contactPerson"
                    )), 1),
                          (_ctx.isPersonBtnDisabled ||
                  _ctx.$store.getters['authModule/hasMiddleOffice']
                )
                            ? (_openBlock(), _createBlock(_component_q_btn, {
                                key: 0,
                                "data-testid": "demand_edit_contactPerson_addButton",
                                outline: "",
                                icon: "add",
                                onClickCapture: _cache[69] || (_cache[69] = _withModifiers(($event: any) => (
                  _ctx.addCorrespondent(
                    _ctx.$store.getters['demandModule/getCorrespondentInit']
                  )
                  ), ["stop"])),
                                class: "btn btn-primary btn-sm ml-3"
                              }))
                            : _createCommentVNode("", true)
                        ])
                      ])
                    ]),
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_144, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.correspondentsList, (c, index) => {
                          return (_openBlock(), _createElementBlock("div", {
                            class: "p-2 bg-white default-border-radius mb-3",
                            key: index
                          }, [
                            _createElementVNode("div", _hoisted_145, [
                              _createElementVNode("div", _hoisted_146, [
                                _createElementVNode("div", _hoisted_147, [
                                  (c.qualificationType?.type?.value === 'CPT')
                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                        (c.businessData)
                                          ? (_openBlock(), _createElementBlock("div", {
                                              key: 0,
                                              class: "col-lg-3 col-md-6 col-sm-12 form-control no-border",
                                              id: 'demand_edit_contactPerson_title_' + index
                                            }, [
                                              _createElementVNode("label", _hoisted_149, _toDisplayString(_ctx.$t("main.labels.title")), 1),
                                              _createVNode(_component_q_select, {
                                                "data-testid": 'demand_edit_contactPerson_title_' + index,
                                                dense: "",
                                                outlined: "",
                                                "emit-value": "",
                                                "map-options": "",
                                                modelValue: c.businessData.titleCode,
                                                "onUpdate:modelValue": ($event: any) => ((c.businessData.titleCode) = $event),
                                                options: _ctx.title,
                                                disable: c.isDisabled
                                              }, null, 8, ["data-testid", "modelValue", "onUpdate:modelValue", "options", "disable"])
                                            ], 8, _hoisted_148))
                                          : _createCommentVNode("", true),
                                        _createElementVNode("div", {
                                          class: "col-lg-3 col-md-6 col-sm-12 form-control no-border",
                                          id: 'demand_edit_contactPerson_name_' + index
                                        }, [
                                          _createElementVNode("label", _hoisted_151, _toDisplayString(_ctx.$t("demand.filtreMenu.name")), 1),
                                          _createVNode(_component_q_input, {
                                            "data-testid": 'demand_edit_contactPerson_name_' + index,
                                            dense: "",
                                            outlined: "",
                                            disable: c.isDisabled,
                                            "model-value": _ctx.getCptInput1(c),
                                            "onUpdate:modelValue": val => _ctx.setCptInput1(c, val)
                                          }, null, 8, ["data-testid", "disable", "model-value", "onUpdate:modelValue"])
                                        ], 8, _hoisted_150),
                                        (c.businessData)
                                          ? (_openBlock(), _createElementBlock("div", {
                                              key: 1,
                                              class: "col-lg-3 col-md-6 col-sm-12 form-control no-border",
                                              id: 'demand_edit_contactPerson_firstName_' + index
                                            }, [
                                              _createElementVNode("label", _hoisted_153, _toDisplayString(_ctx.$t('main.labels.usageName')), 1),
                                              _createVNode(_component_q_input, {
                                                "data-testid": 'demand_edit_contactPerson_firstName_' + index,
                                                dense: "",
                                                outlined: "",
                                                modelValue: c.middleName,
                                                "onUpdate:modelValue": ($event: any) => ((c.middleName) = $event),
                                                disable: c.isDisabled
                                              }, null, 8, ["data-testid", "modelValue", "onUpdate:modelValue", "disable"])
                                            ], 8, _hoisted_152))
                                          : _createCommentVNode("", true),
                                        _createElementVNode("div", {
                                          class: "col-lg-3 col-md-6 col-sm-12 form-control no-border",
                                          id: 'demand_edit_contactPerson_firstName_' + index
                                        }, [
                                          _createElementVNode("label", _hoisted_155, _toDisplayString(_ctx.$t('demand.filtreMenu.firstName')), 1),
                                          _createVNode(_component_q_input, {
                                            "data-testid": 'demand_edit_contactPerson_firstName_' + index,
                                            dense: "",
                                            outlined: "",
                                            disable: c.isDisabled,
                                            "model-value": _ctx.getCptInput2(c),
                                            "onUpdate:modelValue": val => _ctx.setCptInput2(c, val)
                                          }, null, 8, ["data-testid", "disable", "model-value", "onUpdate:modelValue"])
                                        ], 8, _hoisted_154)
                                      ], 64))
                                    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                        (c.businessData)
                                          ? (_openBlock(), _createElementBlock("div", {
                                              key: 0,
                                              class: "col-lg-3 col-md-6 col-sm-12 form-control no-border",
                                              id: 'demand_edit_contactPerson_title_' + index
                                            }, [
                                              _createElementVNode("label", _hoisted_157, _toDisplayString(_ctx.$t("main.labels.title")), 1),
                                              _createVNode(_component_q_select, {
                                                "data-testid": 'demand_edit_contactPerson_title_' + index,
                                                dense: "",
                                                outlined: "",
                                                "emit-value": "",
                                                "map-options": "",
                                                modelValue: c.businessData.titleCode,
                                                "onUpdate:modelValue": ($event: any) => ((c.businessData.titleCode) = $event),
                                                options: _ctx.title,
                                                disable: c.isDisabled
                                              }, null, 8, ["data-testid", "modelValue", "onUpdate:modelValue", "options", "disable"])
                                            ], 8, _hoisted_156))
                                          : _createCommentVNode("", true),
                                        _createElementVNode("div", {
                                          class: "col-lg-3 col-md-6 col-sm-12 form-control no-border",
                                          id: 'demand_edit_contactPerson_name_' + index
                                        }, [
                                          _createElementVNode("label", _hoisted_159, _toDisplayString(_ctx.$t('demand.filtreMenu.name')), 1),
                                          _createVNode(_component_q_input, {
                                            "data-testid": 'demand_edit_contactPerson_name_' + index,
                                            dense: "",
                                            outlined: "",
                                            modelValue: c.familyName,
                                            "onUpdate:modelValue": ($event: any) => ((c.familyName) = $event),
                                            disable: c.isDisabled
                                          }, null, 8, ["data-testid", "modelValue", "onUpdate:modelValue", "disable"])
                                        ], 8, _hoisted_158),
                                        _createElementVNode("div", {
                                          class: "col-lg-3 col-md-6 col-sm-12 form-control no-border",
                                          id: 'demand_edit_contactPerson_firstName_' + index
                                        }, [
                                          _createElementVNode("label", _hoisted_161, _toDisplayString(_ctx.$t('main.labels.usageName')), 1),
                                          _createVNode(_component_q_input, {
                                            "data-testid": 'demand_edit_contactPerson_firstName_' + index,
                                            dense: "",
                                            outlined: "",
                                            modelValue: c.middleName,
                                            "onUpdate:modelValue": ($event: any) => ((c.middleName) = $event),
                                            disable: c.isDisabled
                                          }, null, 8, ["data-testid", "modelValue", "onUpdate:modelValue", "disable"])
                                        ], 8, _hoisted_160),
                                        _createElementVNode("div", {
                                          class: "col-lg-3 col-md-6 col-sm-12 form-control no-border",
                                          id: 'demand_edit_contactPerson_firstName_' + index
                                        }, [
                                          _createElementVNode("label", _hoisted_163, _toDisplayString(_ctx.$t('demand.filtreMenu.firstName')), 1),
                                          _createVNode(_component_q_input, {
                                            "data-testid": 'demand_edit_contactPerson_firstName_' + index,
                                            dense: "",
                                            outlined: "",
                                            modelValue: c.firstName,
                                            "onUpdate:modelValue": ($event: any) => ((c.firstName) = $event),
                                            disable: c.isDisabled
                                          }, null, 8, ["data-testid", "modelValue", "onUpdate:modelValue", "disable"])
                                        ], 8, _hoisted_162)
                                      ], 64)),
                                  (c.businessData)
                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                                        _createElementVNode("div", _hoisted_164, [
                                          _createElementVNode("label", _hoisted_165, _toDisplayString(_ctx.$t("demand.filtreMenu.nationality")), 1),
                                          _createVNode(_component_q_select, {
                                            dense: "",
                                            outlined: "",
                                            "emit-value": "",
                                            "map-options": "",
                                            modelValue: c.businessData.nationality,
                                            "onUpdate:modelValue": ($event: any) => ((c.businessData.nationality) = $event),
                                            options: _ctx.nationality
                                          }, null, 8, ["modelValue", "onUpdate:modelValue", "options"])
                                        ]),
                                        _createElementVNode("div", _hoisted_166, [
                                          _createElementVNode("label", _hoisted_167, _toDisplayString(_ctx.isCorrespondentForeignBirth(c)
                            ? _ctx.$t("main.labels.postalCode")
                            : _ctx.$t("demand.filtreMenu.birthplacecity")), 1),
                                          _createVNode(_component_q_select, {
                                            "data-testid": "third_edit_identity_postalCode_cityOfBirth",
                                            dense: "",
                                            outlined: "",
                                            "use-input": "",
                                            "hide-selected": "",
                                            "fill-input": "",
                                            "model-value": _ctx.getBirthplaceDisplay(c),
                                            "emit-value": "",
                                            "map-options": "",
                                            "onUpdate:modelValue": val => _ctx.onBirthplaceChange(c, val),
                                            "input-debounce": "300",
                                            options: _ctx.filteredPostalCodes,
                                            onFilter: _ctx.filterPostalCodesRealTime
                                          }, {
                                            option: _withCtx((scope) => [
                                              _createVNode(_component_q_item, _mergeProps({ ref_for: true }, scope.itemProps), {
                                                default: _withCtx(() => [
                                                  _createVNode(_component_q_item_section, null, {
                                                    default: _withCtx(() => [
                                                      _createTextVNode(_toDisplayString(scope.opt.label), 1)
                                                    ]),
                                                    _: 2
                                                  }, 1024)
                                                ]),
                                                _: 2
                                              }, 1040)
                                            ]),
                                            "no-option": _withCtx(() => [
                                              _createVNode(_component_q_item, null, {
                                                default: _withCtx(() => [
                                                  _createVNode(_component_q_item_section, { class: "text-grey" }, {
                                                    default: _withCtx(() => [
                                                      _createTextVNode(_toDisplayString(_ctx.$t("main.noResults")), 1)
                                                    ]),
                                                    _: 1
                                                  })
                                                ]),
                                                _: 1
                                              })
                                            ]),
                                            _: 1
                                          }, 8, ["model-value", "onUpdate:modelValue", "options", "onFilter"])
                                        ]),
                                        (_ctx.isCorrespondentForeignBirth(c))
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_168, [
                                              _createElementVNode("label", _hoisted_169, _toDisplayString(_ctx.$t("main.labels.cityOfBirth")), 1),
                                              _createVNode(_component_q_input, {
                                                "data-testid": "third_edit_contact_birthplaceCity",
                                                dense: "",
                                                outlined: "",
                                                modelValue: c.businessData.birthplaceCity,
                                                "onUpdate:modelValue": ($event: any) => ((c.businessData.birthplaceCity) = $event)
                                              }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                            ]))
                                          : _createCommentVNode("", true),
                                        _createElementVNode("div", _hoisted_170, [
                                          _createElementVNode("label", _hoisted_171, _toDisplayString(_ctx.$t("main.labels.bornCountry")), 1),
                                          _createVNode(_component_q_select, {
                                            "data-testid": "third_edit_contact_birthplaceCountry",
                                            dense: "",
                                            outlined: "",
                                            "emit-value": "",
                                            "map-options": "",
                                            modelValue: c.businessData.birthplaceCountry,
                                            "onUpdate:modelValue": ($event: any) => ((c.businessData.birthplaceCountry) = $event),
                                            options: _ctx.nationality
                                          }, null, 8, ["modelValue", "onUpdate:modelValue", "options"])
                                        ]),
                                        _createElementVNode("div", _hoisted_172, [
                                          _createElementVNode("label", _hoisted_173, _toDisplayString(_ctx.$t("demand.filtreMenu.zipCode_City")), 1),
                                          _createVNode(_component_q_tooltip, null, {
                                            default: _withCtx(() => [
                                              _createTextVNode(_toDisplayString(_ctx.getResidenceDisplay(c)), 1)
                                            ]),
                                            _: 2
                                          }, 1024),
                                          _createVNode(_component_q_select, {
                                            "data-testid": "third_edit_identity_postalCode_cityOfBirth",
                                            dense: "",
                                            outlined: "",
                                            "use-input": "",
                                            "hide-selected": "",
                                            "fill-input": "",
                                            "model-value": _ctx.getResidenceDisplay(c),
                                            "emit-value": "",
                                            "map-options": "",
                                            "onUpdate:modelValue": val => _ctx.onResidenceChange(c, val),
                                            disable: _ctx.isMO,
                                            "input-debounce": "300",
                                            options: _ctx.filteredPostalCodes,
                                            onFilter: _ctx.filterPostalCodesRealTime
                                          }, {
                                            option: _withCtx((scope) => [
                                              _createVNode(_component_q_item, _mergeProps({ ref_for: true }, scope.itemProps), {
                                                default: _withCtx(() => [
                                                  _createVNode(_component_q_item_section, null, {
                                                    default: _withCtx(() => [
                                                      _createTextVNode(_toDisplayString(scope.opt.label), 1)
                                                    ]),
                                                    _: 2
                                                  }, 1024)
                                                ]),
                                                _: 2
                                              }, 1040)
                                            ]),
                                            "no-option": _withCtx(() => [
                                              _createVNode(_component_q_item, null, {
                                                default: _withCtx(() => [
                                                  _createVNode(_component_q_item_section, { class: "text-grey-14" }, {
                                                    default: _withCtx(() => [
                                                      _createTextVNode(_toDisplayString(_ctx.$t("main.noResults")), 1)
                                                    ]),
                                                    _: 1
                                                  })
                                                ]),
                                                _: 1
                                              })
                                            ]),
                                            _: 1
                                          }, 8, ["model-value", "onUpdate:modelValue", "disable", "options", "onFilter"])
                                        ]),
                                        _createElementVNode("div", _hoisted_174, [
                                          _createElementVNode("label", _hoisted_175, _toDisplayString(_ctx.$t("demand.filtreMenu.country")), 1),
                                          _createVNode(_component_q_input, {
                                            "data-testid": "third_edit_contact_country",
                                            dense: "",
                                            outlined: "",
                                            modelValue: c.businessData.country,
                                            "onUpdate:modelValue": ($event: any) => ((c.businessData.country) = $event),
                                            readonly: ""
                                          }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                        ]),
                                        _createElementVNode("div", _hoisted_176, [
                                          _createElementVNode("label", _hoisted_177, _toDisplayString(_ctx.$t("demand.filtreMenu.address")), 1),
                                          _createVNode(_component_q_input, {
                                            "data-testid": "third_edit_contact_address",
                                            dense: "",
                                            outlined: "",
                                            modelValue: c.businessData.address,
                                            "onUpdate:modelValue": ($event: any) => ((c.businessData.address) = $event)
                                          }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                        ]),
                                        _createElementVNode("div", _hoisted_178, [
                                          _createElementVNode("label", _hoisted_179, _toDisplayString(_ctx.$t("middleOffice.party.organization.establishments.address.street")), 1),
                                          _createVNode(_component_q_input, {
                                            "data-testid": "third_edit_contact_address",
                                            dense: "",
                                            outlined: "",
                                            modelValue: c.businessData.adressNo,
                                            "onUpdate:modelValue": ($event: any) => ((c.businessData.adressNo) = $event)
                                          }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                        ]),
                                        _createElementVNode("div", _hoisted_180, [
                                          _createElementVNode("label", _hoisted_181, _toDisplayString(_ctx.$t("task.completeDocument.party.person.address.LieuDit")), 1),
                                          _createVNode(_component_q_input, {
                                            dense: "",
                                            outlined: "",
                                            modelValue: c.businessData.adressSupplement,
                                            "onUpdate:modelValue": ($event: any) => ((c.businessData.adressSupplement) = $event)
                                          }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                        ]),
                                        _createElementVNode("div", _hoisted_182, [
                                          _createElementVNode("label", _hoisted_183, _toDisplayString(_ctx.$t("demand.filtreMenu.birthdate")), 1),
                                          _createVNode(_component_q_input, {
                                            "data-testid": "third_edit_identity_birthDate",
                                            dense: "",
                                            outlined: "",
                                            modelValue: c.businessData.birthDate,
                                            "onUpdate:modelValue": ($event: any) => ((c.businessData.birthDate) = $event),
                                            mask: _ctx.maskInput,
                                            rules: [(val) => _ctx.validateBirthDate(val)]
                                          }, {
                                            append: _withCtx(() => [
                                              _createVNode(_component_q_icon, {
                                                name: "event",
                                                class: "cursor-pointer"
                                              }, {
                                                default: _withCtx(() => [
                                                  _createVNode(_component_q_popup_proxy, {
                                                    ref_for: true,
                                                    ref: "qDateProxy",
                                                    cover: "",
                                                    "transition-show": "scale",
                                                    "transition-hide": "scale"
                                                  }, {
                                                    default: _withCtx(() => [
                                                      _createVNode(_component_q_date, {
                                                        modelValue: c.businessData.birthDate,
                                                        "onUpdate:modelValue": ($event: any) => ((c.businessData.birthDate) = $event),
                                                        mask: _ctx.maskFormat,
                                                        locale: _ctx.FR
                                                      }, {
                                                        default: _withCtx(() => [
                                                          _createElementVNode("div", _hoisted_184, [
                                                            _withDirectives(_createVNode(_component_q_btn, {
                                                              label: _ctx.$t('task.completeDocument.party.person.financialSituation.close'),
                                                              color: "primary",
                                                              flat: ""
                                                            }, null, 8, ["label"]), [
                                                              [_directive_close_popup]
                                                            ])
                                                          ])
                                                        ]),
                                                        _: 1
                                                      }, 8, ["modelValue", "onUpdate:modelValue", "mask", "locale"])
                                                    ]),
                                                    _: 2
                                                  }, 1536)
                                                ]),
                                                _: 2
                                              }, 1024)
                                            ]),
                                            _: 2
                                          }, 1032, ["modelValue", "onUpdate:modelValue", "mask", "rules"])
                                        ])
                                      ], 64))
                                    : _createCommentVNode("", true),
                                  _createElementVNode("div", {
                                    class: "col-lg-3 col-md-6 col-sm-12 form-control no-border",
                                    id: 'demand_edit_contactPerson_qualificationType_' + index
                      
                                  }, [
                                    _createElementVNode("label", _hoisted_186, [
                                      _createTextVNode(_toDisplayString(_ctx.$t(
                            "task.completeDocument.party.organization.contactPerson.qualificationType"
                          )) + " ", 1),
                                      _cache[107] || (_cache[107] = _createElementVNode("span", { class: "text-danger" }, "*", -1))
                                    ]),
                                    _createVNode(_component_q_select, {
                                      "data-testid": 'demand_edit_contactPerson_qualificationType_' + index
                        ,
                                      dense: "",
                                      outlined: "",
                                      "emit-value": "",
                                      "map-options": "",
                                      "model-value": c.qualificationType?.type?.value,
                                      "onUpdate:modelValue": (val) => _ctx.updateQualificationType(c, val),
                                      options: _ctx.qualificationType,
                                      disable: c.isDisabled
                                    }, null, 8, ["data-testid", "model-value", "onUpdate:modelValue", "options", "disable"])
                                  ], 8, _hoisted_185),
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(c.contactCorrespondent, (vl, idx) => {
                                    return (_openBlock(), _createElementBlock(_Fragment, null, [
                                      (vl.contactMechanism?.type?.id === 'EMAIL_CONTACT')
                                        ? (_openBlock(), _createElementBlock("div", {
                                            class: "col-lg-3 col-md-6 col-sm-12 form-control no-border",
                                            key: 'email-' + idx
                                          }, [
                                            _createElementVNode("label", _hoisted_187, _toDisplayString(_ctx.$t("middleOffice.party.organization.meansOfCommunication.emailAddress")), 1),
                                            _createVNode(_component_q_input, {
                                              dense: "",
                                              outlined: "",
                                              modelValue: vl.contactMechanism.emailAddress,
                                              "onUpdate:modelValue": ($event: any) => ((vl.contactMechanism.emailAddress) = $event),
                                              rules: [(val) => _ctx.isValidEmail(val)]
                                            }, null, 8, ["modelValue", "onUpdate:modelValue", "rules"])
                                          ]))
                                        : _createCommentVNode("", true)
                                    ], 64))
                                  }), 256)),
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(c.contactCorrespondent, (vl, idx) => {
                                    return (_openBlock(), _createElementBlock(_Fragment, null, [
                                      (vl.contactMechanism?.type?.id === 'PHONE_CONTACT')
                                        ? (_openBlock(), _createElementBlock("div", {
                                            class: "col-lg-3 col-md-6 col-sm-12 form-control no-border",
                                            key: 'phone-' + idx
                                          }, [
                                            _createElementVNode("label", _hoisted_188, _toDisplayString(_ctx.$t("middleOffice.party.organization.meansOfCommunication.phoneNumber")), 1),
                                            _createVNode(_component_q_input, {
                                              dense: "",
                                              outlined: "",
                                              modelValue: vl.contactMechanism.phoneNumber,
                                              "onUpdate:modelValue": ($event: any) => ((vl.contactMechanism.phoneNumber) = $event)
                                            }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                          ]))
                                        : _createCommentVNode("", true)
                                    ], 64))
                                  }), 256)),
                                  _createElementVNode("div", {
                                    class: "col-lg-3 col-md-6 col-sm-12 form-control no-border",
                                    id: 'demand_edit_contactPerson_signingAuthority_' + index
                      
                                  }, [
                                    _createElementVNode("label", _hoisted_190, _toDisplayString(_ctx.$t(
                            "task.completeDocument.party.organization.contactPerson.signingAuthority"
                          )), 1),
                                    _createVNode(_component_q_toggle, {
                                      "data-testid": 'demand_edit_contactPerson_signingAuthority_toggle' +
                        index
                        ,
                                      modelValue: c.signingAuthority,
                                      "onUpdate:modelValue": [($event: any) => ((c.signingAuthority) = $event), ($event: any) => (_ctx.updateSigningAuthority(c))],
                                      disable: c.isDisabled
                                    }, null, 8, ["data-testid", "modelValue", "onUpdate:modelValue", "disable"])
                                  ], 8, _hoisted_189)
                                ])
                              ]),
                              _createElementVNode("div", null, [
                                _createVNode(_component_q_btn, {
                                  "data-testid": 'demand_edit_contactPerson_signingAuthority_deleteButton' +
                    index
                    ,
                                  outline: "",
                                  icon: "delete",
                                  onClick: ($event: any) => (_ctx.remove(index, _ctx.correspondents)),
                                  class: "btn btn-outline-danger mt-3",
                                  disable: _ctx.$store.getters['authModule/hasMiddleOffice']
                                }, null, 8, ["data-testid", "onClick", "disable"])
                              ])
                            ])
                          ]))
                        }), 128))
                      ])
                    ]),
                    _: 1
                  }, 8, ["class"])
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (_ctx.isPersonPhysique && _ctx.isPartySupplierOrDistributor())
            ? (_openBlock(), _createBlock(_component_q_list, { key: 3 }, {
                default: _withCtx(() => [
                  _createVNode(_component_q_expansion_item, {
                    "switch-toggle-side": "",
                    "expand-separator": "",
                    "header-class": "card-header bg-transparent no-border p-4",
                    class: _normalizeClass(["card tw-items-dashed-group tw-items-group-with-bg", _ctx.currentRoute === 'TaskDetail' ? 'tw-analysis-section' : '']),
                    onShow: _cache[74] || (_cache[74] = ($event: any) => {
            _ctx.personJobsBtn = !_ctx.personJobsBtn;
          _ctx.addExpandJobs(_ctx.personJobs);
          }),
                    onHide: _cache[75] || (_cache[75] = ($event: any) => {
            _ctx.personJobsBtn = !_ctx.personJobsBtn;
          _ctx.removeExpandedJobs(_ctx.personJobs);
          })
                  }, {
                    header: _withCtx(() => [
                      _createElementVNode("div", _hoisted_191, [
                        _createElementVNode("div", _hoisted_192, [
                          _createElementVNode("div", _hoisted_193, _toDisplayString(_ctx.$t("middleOffice.party.person.section.occupation")), 1),
                          ((_ctx.isJobsBtnDisabled ||
                  _ctx.$store.getters['authModule/hasMiddleOffice']) && _ctx.taskDefinition !== 'STEP_START_ANALYSIS'
                )
                            ? (_openBlock(), _createBlock(_component_q_btn, {
                                key: 0,
                                "data-testid": "demand_edit_profession_addButton",
                                outline: "",
                                icon: "add",
                                onClickCapture: _cache[72] || (_cache[72] = _withModifiers(($event: any) => (
                  _ctx.add(
                    _ctx.personJobs,
                    _ctx.$store.getters['demandModule/getThirdJobsInit']
                  )
                  ), ["stop"])),
                                class: "btn btn-primary btn-sm ml-3"
                              }))
                            : _createCommentVNode("", true)
                        ])
                      ])
                    ]),
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_194, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.party.person.jobs, (value, index) => {
                          return (_openBlock(), _createElementBlock("div", {
                            class: "p-2 bg-white default-border-radius mb-3",
                            key: index
                          }, [
                            _createElementVNode("div", _hoisted_195, [
                              _createElementVNode("div", _hoisted_196, [
                                _createElementVNode("div", _hoisted_197, [
                                  _createElementVNode("div", {
                                    class: "col-lg-3 col-md-6 col-sm-12 form-control no-border",
                                    id: 'demand_edit_profession_employerName_' + index
                                  }, [
                                    _createElementVNode("label", _hoisted_199, [
                                      _createTextVNode(_toDisplayString(_ctx.$t("main.labels.employerName")) + " ", 1),
                                      _cache[108] || (_cache[108] = _createElementVNode("span", { class: "text-danger" }, "*", -1))
                                    ]),
                                    _createVNode(_component_q_input, {
                                      "data-testid": 'demand_edit_profession_employerName_' + index
                        ,
                                      dense: "",
                                      outlined: "",
                                      modelValue: value.employerName,
                                      "onUpdate:modelValue": ($event: any) => ((value.employerName) = $event),
                                      disable: value.isDisabled,
                                      rules: [(val) => !!val || _ctx.requiredField],
                                      "hide-bottom-space": ""
                                    }, null, 8, ["data-testid", "modelValue", "onUpdate:modelValue", "disable", "rules"])
                                  ], 8, _hoisted_198),
                                  _createElementVNode("div", {
                                    class: "col-lg-3 col-md-6 col-sm-12 form-control no-border",
                                    id: 'demand_edit_profession_activityArea_' + index
                                  }, [
                                    _createElementVNode("label", _hoisted_201, [
                                      _createTextVNode(_toDisplayString(_ctx.$t("main.labels.activityArea")) + " ", 1),
                                      _cache[109] || (_cache[109] = _createElementVNode("span", { class: "text-danger" }, "*", -1))
                                    ]),
                                    _createVNode(_component_q_select, {
                                      "data-testid": 'demand_edit_profession_activityArea_' + index
                        ,
                                      dense: "",
                                      outlined: "",
                                      "emit-value": "",
                                      "map-options": "",
                                      modelValue: value.activity.type.value,
                                      "onUpdate:modelValue": ($event: any) => ((value.activity.type.value) = $event),
                                      options: _ctx.jobActivity,
                                      disable: value.isDisabled,
                                      rules: [(val) => !!val || _ctx.requiredField],
                                      "hide-bottom-space": ""
                                    }, null, 8, ["data-testid", "modelValue", "onUpdate:modelValue", "options", "disable", "rules"])
                                  ], 8, _hoisted_200),
                                  _createElementVNode("div", {
                                    class: "col-lg-3 col-md-6 col-sm-12 form-control no-border",
                                    id: 'demand_edit_profession_primaryEmployer_' + index
                                  }, [
                                    _createElementVNode("label", _hoisted_203, [
                                      _createTextVNode(_toDisplayString(_ctx.$t("main.labels.primaryEmployer")) + " ", 1),
                                      _cache[110] || (_cache[110] = _createElementVNode("span", { class: "text-danger" }, "*", -1))
                                    ]),
                                    _createVNode(_component_q_toggle, {
                                      "data-testid": 'demand_edit_profession_primaryEmployer_' + index
                        ,
                                      modelValue: value.principal,
                                      "onUpdate:modelValue": ($event: any) => ((value.principal) = $event),
                                      disable: value.isDisabled,
                                      rules: [(val) => !!val || _ctx.requiredField],
                                      "hide-bottom-space": ""
                                    }, null, 8, ["data-testid", "modelValue", "onUpdate:modelValue", "disable", "rules"])
                                  ], 8, _hoisted_202),
                                  _createElementVNode("div", {
                                    class: "col-lg-3 col-md-6 col-sm-12 form-control no-border",
                                    id: 'demand_edit_profession_contractType_' + index
                                  }, [
                                    _createElementVNode("label", _hoisted_205, [
                                      _createTextVNode(_toDisplayString(_ctx.$t("main.labels.contractType")) + " ", 1),
                                      (!_ctx.isPartPro)
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_206, "*"))
                                        : _createCommentVNode("", true)
                                    ]),
                                    _createVNode(_component_q_select, {
                                      "data-testid": 'demand_edit_profession_contractType_' + index
                        ,
                                      dense: "",
                                      outlined: "",
                                      "emit-value": "",
                                      "map-options": "",
                                      modelValue: value.contractType.type.value,
                                      "onUpdate:modelValue": ($event: any) => ((value.contractType.type.value) = $event),
                                      options: _ctx.contractTypes,
                                      disable: value.isDisabled,
                                      rules: [(val) => !!val || _ctx.requiredField],
                                      "hide-bottom-space": ""
                                    }, null, 8, ["data-testid", "modelValue", "onUpdate:modelValue", "options", "disable", "rules"])
                                  ], 8, _hoisted_204),
                                  _createElementVNode("div", {
                                    class: "col-lg-3 col-md-6 col-sm-12 form-control no-border",
                                    id: 'demand_edit_profession_occupation_' + index
                                  }, [
                                    _createElementVNode("label", _hoisted_208, [
                                      _createTextVNode(_toDisplayString(_ctx.$t("main.labels.occupation")) + " ", 1),
                                      _cache[111] || (_cache[111] = _createElementVNode("span", { class: "text-danger" }, "*", -1))
                                    ]),
                                    _createVNode(_component_q_select, {
                                      "data-testid": 'demand_edit_profession_occupation_' + index
                        ,
                                      dense: "",
                                      outlined: "",
                                      "emit-value": "",
                                      "map-options": "",
                                      modelValue: value.positionType.type.value,
                                      "onUpdate:modelValue": ($event: any) => ((value.positionType.type.value) = $event),
                                      options: _ctx.jobPositionType,
                                      disable: value.isDisabled,
                                      rules: [(val) => !!val || _ctx.requiredField],
                                      "hide-bottom-space": ""
                                    }, null, 8, ["data-testid", "modelValue", "onUpdate:modelValue", "options", "disable", "rules"])
                                  ], 8, _hoisted_207),
                                  _createElementVNode("div", {
                                    class: "col-lg-3 col-md-6 col-sm-12 form-control no-border",
                                    id: 'demand_edit_profession_entryDate_' + index
                                  }, [
                                    _createElementVNode("label", _hoisted_210, _toDisplayString(_ctx.$t("main.labels.dateOfEntry")), 1),
                                    _createVNode(_component_q_input, {
                                      "data-testid": 'demand_edit_profession_input_entryDate_' + index
                        ,
                                      dense: "",
                                      outlined: "",
                                      modelValue: value.validity.from,
                                      "onUpdate:modelValue": ($event: any) => ((value.validity.from) = $event),
                                      mask: _ctx.maskInput,
                                      disable: value.isDisabled
                                    }, {
                                      append: _withCtx(() => [
                                        _createVNode(_component_q_icon, {
                                          "data-testid": 'demand_edit_profession_icon_entryDate_' + index
                            ,
                                          name: "event",
                                          class: "cursor-pointer"
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_q_popup_proxy, {
                                              "data-testid": 'demand_edit_profession_popupProxy_entryDate_' +
                              index
                              ,
                                              ref_for: true,
                                              ref: "qDateProxy",
                                              cover: "",
                                              "transition-show": "scale",
                                              "transition-hide": "scale"
                                            }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_q_date, {
                                                  "data-testid": 'demand_edit_profession_date_entryDate_' +
                                index
                                ,
                                                  modelValue: value.validity.from,
                                                  "onUpdate:modelValue": ($event: any) => ((value.validity.from) = $event),
                                                  mask: _ctx.dateMask,
                                                  locale: _ctx.FR
                                                }, {
                                                  default: _withCtx(() => [
                                                    _createElementVNode("div", _hoisted_211, [
                                                      _withDirectives(_createVNode(_component_q_btn, {
                                                        "data-testid": 'demand_edit_profession_button_entryDate_' +
                                    index
                                    ,
                                                        label: _ctx.$t(
                                      'task.completeDocument.party.person.financialSituation.close'
                                    )
                                      ,
                                                        color: "primary",
                                                        flat: ""
                                                      }, null, 8, ["data-testid", "label"]), [
                                                        [_directive_close_popup]
                                                      ])
                                                    ])
                                                  ]),
                                                  _: 2
                                                }, 1032, ["data-testid", "modelValue", "onUpdate:modelValue", "mask", "locale"])
                                              ]),
                                              _: 2
                                            }, 1032, ["data-testid"])
                                          ]),
                                          _: 2
                                        }, 1032, ["data-testid"])
                                      ]),
                                      _: 2
                                    }, 1032, ["data-testid", "modelValue", "onUpdate:modelValue", "mask", "disable"])
                                  ], 8, _hoisted_209),
                                  _createElementVNode("div", {
                                    class: "col-lg-3 col-md-6 col-sm-12 form-control no-border",
                                    id: 'demand_edit_profession_employerSeniority_' + index
                                  }, [
                                    _createElementVNode("label", _hoisted_213, _toDisplayString(_ctx.$t("main.labels.employerSeniority")), 1),
                                    _createVNode(_component_q_input, {
                                      "data-testid": 'demand_edit_profession_input_employerSeniority_' +
                        index
                        ,
                                      dense: "",
                                      outlined: "",
                                      modelValue: value.nbYearExpereinceActivity,
                                      "onUpdate:modelValue": [($event: any) => ((value.nbYearExpereinceActivity) = $event), val => { if (val < 0) value.nbYearExpereinceActivity = 0; }],
                                      disable: value?.isDisabled,
                                      type: "number",
                                      min: "0"
                                    }, null, 8, ["data-testid", "modelValue", "onUpdate:modelValue", "disable"])
                                  ], 8, _hoisted_212),
                                  _createElementVNode("div", {
                                    class: "col-lg-3 col-md-6 col-sm-12 form-control no-border",
                                    id: 'demand_edit_profession_socioProfessionalCategory_' +
                      index
                      
                                  }, [
                                    _createElementVNode("label", _hoisted_215, _toDisplayString(_ctx.$t("main.labels.socioprofessionalcategory")), 1),
                                    _createVNode(_component_q_select, {
                                      "data-testid": 'demand_edit_profession_socioProfessionalCategory_' +
                        index
                        ,
                                      dense: "",
                                      outlined: "",
                                      "emit-value": "",
                                      "map-options": "",
                                      "use-input": "",
                                      "hide-selected": "",
                                      "fill-input": "",
                                      "input-debounce": "0",
                                      modelValue: value.occupationType.type.value,
                                      "onUpdate:modelValue": ($event: any) => ((value.occupationType.type.value) = $event),
                                      options: _ctx.filteredSocioProfessionalCategoryOptions,
                                      onFilter: _ctx.filterSocioProfessionalCategory,
                                      "hide-bottom-space": ""
                                    }, null, 8, ["data-testid", "modelValue", "onUpdate:modelValue", "options", "onFilter"])
                                  ], 8, _hoisted_214),
                                  _createElementVNode("div", _hoisted_216, [
                                    _createElementVNode("label", _hoisted_217, _toDisplayString(_ctx.$t("middleOffice.party.person.occupation.professionType")), 1),
                                    _createVNode(_component_q_input, {
                                      dense: "",
                                      outlined: "",
                                      "model-value": value.jobName,
                                      "hide-bottom-space": ""
                                    }, null, 8, ["model-value"])
                                  ])
                                ]),
                                _createElementVNode("div", _hoisted_218, [
                                  _createVNode(_component_q_expansion_item, {
                                    "switch-toggle-side": "",
                                    "header-class": "card-header bg-transparent no-border p-4",
                                    class: "card tw-items-dashed-group tw-items-group-with-bg tw-level-two-group"
                                  }, {
                                    header: _withCtx(() => [
                                      _createElementVNode("div", _hoisted_219, [
                                        _createElementVNode("div", _hoisted_220, [
                                          _createElementVNode("div", _hoisted_221, _toDisplayString(_ctx.$t("main.labels.joblocation")), 1)
                                        ])
                                      ])
                                    ]),
                                    default: _withCtx(() => [
                                      _createElementVNode("div", _hoisted_222, [
                                        _createElementVNode("div", _hoisted_223, [
                                          _createElementVNode("div", {
                                            class: "col-lg-3 col-md-6 col-sm-12 form-control no-border",
                                            id: 'demand_edit_profession_jobLocation_adress_' +
                            index
                            
                                          }, [
                                            _createElementVNode("label", _hoisted_225, _toDisplayString(_ctx.$t("middleOffice.party.person.address.street")), 1),
                                            _createVNode(_component_q_input, {
                                              "data-testid": 'demand_edit_profession_jobLocation_adress_' +
                              index
                              ,
                                              dense: "",
                                              outlined: "",
                                              modelValue: value.jobLocation.street,
                                              "onUpdate:modelValue": ($event: any) => ((value.jobLocation.street) = $event)
                                            }, null, 8, ["data-testid", "modelValue", "onUpdate:modelValue"])
                                          ], 8, _hoisted_224),
                                          _createElementVNode("div", {
                                            class: "col-lg-3 col-md-6 col-sm-12 form-control no-border",
                                            id: 'demand_edit_profession_jobLocation_streetNum_' +
                            index
                            
                                          }, [
                                            _createElementVNode("label", _hoisted_227, _toDisplayString(_ctx.$t(
                                  "middleOffice.party.person.address.streetNum"
                                )), 1),
                                            _createVNode(_component_q_input, {
                                              "data-testid": 'demand_edit_profession_jobLocation_streetNum_' +
                              index
                              ,
                                              dense: "",
                                              outlined: "",
                                              type: "number",
                                              modelValue: value.jobLocation.streetNum,
                                              "onUpdate:modelValue": [($event: any) => ((value.jobLocation.streetNum) = $event), ($event: any) => (
                                _ctx.validateStreetNum(index, $event)
                                )]
                                            }, null, 8, ["data-testid", "modelValue", "onUpdate:modelValue"])
                                          ], 8, _hoisted_226),
                                          _createElementVNode("div", {
                                            class: "col-lg-3 col-md-6 col-sm-12 form-control no-border",
                                            id: 'demand_edit_profession_jobLocation_postalCode_' +
                            index
                            
                                          }, [
                                            _createElementVNode("label", _hoisted_229, _toDisplayString(_ctx.$t(
                                  "middleOffice.party.person.address.postalCode"
                                )), 1),
                                            _createVNode(_component_q_select, {
                                              "data-testid": 'demand_edit_profession_jobLocation_postalCode_' +
                              index
                              ,
                                              dense: "",
                                              outlined: "",
                                              "use-input": "",
                                              "fill-input": "",
                                              "hide-selected": "",
                                              "onUpdate:modelValue": [($event: any) => (
                                _ctx.changePostalCodePerson(index, $event)
                                ), ($event: any) => ((value.jobLocation.postalCode.type) = $event)],
                                              modelValue: value.jobLocation.postalCode.type,
                                              options: _ctx.postalCodes,
                                              onFilter: _ctx.filterPostalCode
                                            }, {
                                              "no-option": _withCtx(() => [
                                                _createVNode(_component_q_item, null, {
                                                  default: _withCtx(() => [
                                                    _createVNode(_component_q_item_section, { class: "text-grey" }, {
                                                      default: _withCtx(() => [
                                                        _createTextVNode(_toDisplayString(_ctx.$t("main.noResults")), 1)
                                                      ]),
                                                      _: 1
                                                    })
                                                  ]),
                                                  _: 1
                                                })
                                              ]),
                                              append: _withCtx(() => [
                                                _createVNode(_component_q_icon, {
                                                  name: "search",
                                                  onClick: _cache[73] || (_cache[73] = _withModifiers(() => {}, ["stop"]))
                                                })
                                              ]),
                                              _: 1
                                            }, 8, ["data-testid", "onUpdate:modelValue", "modelValue", "options", "onFilter"])
                                          ], 8, _hoisted_228),
                                          _createElementVNode("div", {
                                            class: "col-lg-3 col-md-6 col-sm-12 form-control no-border",
                                            id: 'demand_edit_profession_jobLocation_city_' + index
                            
                                          }, [
                                            _createElementVNode("label", _hoisted_231, _toDisplayString(_ctx.$t("middleOffice.party.person.address.city")), 1),
                                            _createVNode(_component_q_input, {
                                              "data-testid": 'demand_edit_profession_jobLocation_city_' +
                              index
                              ,
                                              dense: "",
                                              outlined: "",
                                              modelValue: value.jobLocation.postalCode.city,
                                              "onUpdate:modelValue": ($event: any) => ((value.jobLocation.postalCode.city) = $event),
                                              readonly: ""
                                            }, null, 8, ["data-testid", "modelValue", "onUpdate:modelValue"])
                                          ], 8, _hoisted_230),
                                          _createElementVNode("div", {
                                            class: "col-lg-3 col-md-6 col-sm-12 form-control no-border",
                                            id: 'demand_edit_profession_jobLocation_country_' +
                            index
                            
                                          }, [
                                            _createElementVNode("label", _hoisted_233, _toDisplayString(_ctx.$t("middleOffice.party.person.address.country")), 1),
                                            _createVNode(_component_q_input, {
                                              "data-testid": 'demand_edit_profession_jobLocation_country_' +
                              index
                              ,
                                              dense: "",
                                              outlined: "",
                                              modelValue: value.jobLocation.postalCode.country.name
                                ,
                                              "onUpdate:modelValue": ($event: any) => ((value.jobLocation.postalCode.country.name
                                ) = $event),
                                              readonly: ""
                                            }, null, 8, ["data-testid", "modelValue", "onUpdate:modelValue"])
                                          ], 8, _hoisted_232)
                                        ])
                                      ])
                                    ]),
                                    _: 2
                                  }, 1024)
                                ])
                              ]),
                              _createElementVNode("div", null, [
                                _createVNode(_component_q_btn, {
                                  "data-testid": "demand_edit_profession_jobLocation_deleteButton",
                                  outline: "",
                                  icon: "delete",
                                  onClick: ($event: any) => (_ctx.remove(index, _ctx.personJobs)),
                                  disable: _ctx.$store.getters['authModule/hasMiddleOffice'],
                                  class: "btn btn-outline-danger mt-3"
                                }, null, 8, ["onClick", "disable"])
                              ])
                            ])
                          ]))
                        }), 128))
                      ]),
                      (_ctx.currentRoute === 'TaskDetail' && _ctx.opinionQualifications.length > 0
          )
                        ? (_openBlock(), _createBlock(_component_Comment, {
                            key: 0,
                            qualificationType: 'PRT-PROF'
                          }))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  }, 8, ["class"])
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (_ctx.isPersonPhysique)
            ? (_openBlock(), _createBlock(_component_q_list, { key: 4 }, {
                default: _withCtx(() => [
                  _createVNode(_component_q_expansion_item, {
                    "switch-toggle-side": "",
                    "expand-separator": "",
                    "header-class": "card-header bg-transparent no-border p-4",
                    class: _normalizeClass(["card tw-items-dashed-group tw-items-group-with-bg", _ctx.currentRoute === 'TaskDetail' ? 'tw-analysis-section' : '']),
                    onShow: _cache[78] || (_cache[78] = ($event: any) => {
            _ctx.addressBtn = !_ctx.addressBtn;
          _ctx.addExpandedItem<
            addresses>
            (_ctx.addresses, _ctx.$store.getters['demandModule/getAddressInit']);
          }),
                    onHide: _cache[79] || (_cache[79] = ($event: any) => {
            _ctx.addressBtn = !_ctx.addressBtn;
          _ctx.removeExpandedItem < _ctx.addresses > _ctx.addresses;
          })
                  }, {
                    header: _withCtx(() => [
                      _createElementVNode("div", _hoisted_234, [
                        _createElementVNode("div", _hoisted_235, [
                          _createElementVNode("div", _hoisted_236, _toDisplayString(_ctx.$t("main.labels.adresse").toUpperCase()), 1),
                          (_ctx.isAddressBtnDisabled ||
                  _ctx.$store.getters['authModule/hasMiddleOffice']
                )
                            ? (_openBlock(), _createBlock(_component_q_btn, {
                                key: 0,
                                "data-testid": "demand_edit_address_addButton",
                                outline: "",
                                icon: "add",
                                onClickCapture: _cache[76] || (_cache[76] = _withModifiers(($event: any) => (
                  _ctx.add(
                    _ctx.addresses,
                    _ctx.$store.getters['demandModule/getAddressInit']
                  )
                  ), ["stop"])),
                                class: "btn btn-primary btn-sm ml-3"
                              }))
                            : _createCommentVNode("", true)
                        ])
                      ])
                    ]),
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_237, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.addressesList, (partyAddress, index) => {
                          return (_openBlock(), _createElementBlock("div", {
                            class: "p-2 bg-white default-border-radius mb-3",
                            key: index
                          }, [
                            _createElementVNode("div", _hoisted_238, [
                              _createElementVNode("div", _hoisted_239, [
                                _createElementVNode("div", _hoisted_240, [
                                  _createElementVNode("div", {
                                    class: "col-lg-3 col-md-6 col-sm-12 form-control no-border",
                                    id: 'demand_edit_address_addressType_' + index
                                  }, [
                                    _createElementVNode("label", _hoisted_242, _toDisplayString(_ctx.$t("middleOffice.party.person.address.type")), 1),
                                    _createVNode(_component_q_select, {
                                      "data-testid": 'demand_edit_address_addressType_' + index
                        ,
                                      dense: "",
                                      outlined: "",
                                      "emit-value": "",
                                      "map-options": "",
                                      modelValue: partyAddress.address.type.type.value,
                                      "onUpdate:modelValue": ($event: any) => ((partyAddress.address.type.type.value) = $event),
                                      options: _ctx.addressPreferenceType,
                                      disable: partyAddress.address.isDisabled,
                                      multiple: ""
                                    }, null, 8, ["data-testid", "modelValue", "onUpdate:modelValue", "options", "disable"])
                                  ], 8, _hoisted_241),
                                  _createElementVNode("div", {
                                    class: "col-lg-3 col-md-6 col-sm-12 form-control no-border",
                                    id: 'demand_edit_address_address_' + index
                                  }, [
                                    _createElementVNode("label", _hoisted_244, _toDisplayString(_ctx.$t("main.labels.adresse")), 1),
                                    _createVNode(_component_q_input, {
                                      "data-testid": 'demand_edit_address_address_' + index,
                                      dense: "",
                                      outlined: "",
                                      modelValue: partyAddress.address.line1,
                                      "onUpdate:modelValue": ($event: any) => ((partyAddress.address.line1) = $event),
                                      disable: partyAddress.address.isDisabled
                                    }, null, 8, ["data-testid", "modelValue", "onUpdate:modelValue", "disable"])
                                  ], 8, _hoisted_243),
                                  _createElementVNode("div", {
                                    class: "col-lg-3 col-md-6 col-sm-12 form-control no-border",
                                    id: 'demand_edit_address_streetNum_' + index
                                  }, [
                                    _createElementVNode("label", _hoisted_246, _toDisplayString(_ctx.$t(
                            "middleOffice.party.organization.address.street"
                          )), 1),
                                    _createVNode(_component_q_input, {
                                      "data-testid": 'demand_edit_address_streetNum_' + index,
                                      dense: "",
                                      outlined: "",
                                      modelValue: partyAddress.address.street,
                                      "onUpdate:modelValue": ($event: any) => ((partyAddress.address.street) = $event),
                                      disable: partyAddress.address.isDisabled
                                    }, null, 8, ["data-testid", "modelValue", "onUpdate:modelValue", "disable"])
                                  ], 8, _hoisted_245),
                                  _createElementVNode("div", _hoisted_247, [
                                    _createElementVNode("label", _hoisted_248, _toDisplayString(_ctx.$t("middleOffice.party.organization.establishments.address.lieuDit")), 1),
                                    _createVNode(_component_q_input, {
                                      dense: "",
                                      outlined: "",
                                      modelValue: partyAddress.address.line2,
                                      "onUpdate:modelValue": ($event: any) => ((partyAddress.address.line2) = $event)
                                    }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                  ]),
                                  _createElementVNode("div", {
                                    class: "col-lg-3 col-md-6 col-sm-12 form-control no-border",
                                    id: 'demand_edit_address_postalCode_' + index
                                  }, [
                                    _createElementVNode("label", _hoisted_250, _toDisplayString(_ctx.$t("middleOffice.party.person.address.postalCode")), 1),
                                    _createVNode(_component_q_select, {
                                      "data-testid": 'demand_edit_address_postalCode_' + index,
                                      dense: "",
                                      outlined: "",
                                      "use-input": "",
                                      "hide-selected": "",
                                      "fill-input": "",
                                      "onUpdate:modelValue": [($event: any) => (_ctx.changePostalCode(index, $event)), ($event: any) => ((partyAddress.address.postalCode.type) = $event)],
                                      modelValue: partyAddress.address.postalCode.type,
                                      options: _ctx.postalCodes,
                                      onFilter: _ctx.filterPostalCode,
                                      disable: partyAddress.address.isDisabled
                                    }, {
                                      "no-option": _withCtx(() => [
                                        _createVNode(_component_q_item, null, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_q_item_section, { class: "text-grey" }, {
                                              default: _withCtx(() => [
                                                _createTextVNode(_toDisplayString(_ctx.$t("main.noResults")), 1)
                                              ]),
                                              _: 1
                                            })
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      append: _withCtx(() => [
                                        _createVNode(_component_q_icon, {
                                          name: "search",
                                          onClick: _cache[77] || (_cache[77] = _withModifiers(() => {}, ["stop"]))
                                        })
                                      ]),
                                      _: 1
                                    }, 8, ["data-testid", "onUpdate:modelValue", "modelValue", "options", "onFilter", "disable"])
                                  ], 8, _hoisted_249),
                                  _createElementVNode("div", {
                                    class: "col-lg-3 col-md-6 col-sm-12 form-control no-border",
                                    id: 'demand_edit_address_city_' + index
                                  }, [
                                    _createElementVNode("label", _hoisted_252, _toDisplayString(_ctx.$t("middleOffice.party.organization.address.city")), 1),
                                    _createVNode(_component_q_input, {
                                      "data-testid": 'demand_edit_address_city_' + index,
                                      readonly: "",
                                      dense: "",
                                      outlined: "",
                                      modelValue: partyAddress.address.postalCode.city,
                                      "onUpdate:modelValue": ($event: any) => ((partyAddress.address.postalCode.city) = $event),
                                      disable: partyAddress.address.isDisabled
                                    }, null, 8, ["data-testid", "modelValue", "onUpdate:modelValue", "disable"])
                                  ], 8, _hoisted_251),
                                  _createElementVNode("div", {
                                    class: "col-lg-3 col-md-6 col-sm-12 form-control no-border",
                                    id: 'demand_edit_address_country_' + index
                                  }, [
                                    _createElementVNode("label", _hoisted_254, _toDisplayString(_ctx.$t("middleOffice.party.organization.address.country")), 1),
                                    _createVNode(_component_q_input, {
                                      "data-testid": 'demand_edit_address_country_' + index,
                                      readonly: "",
                                      dense: "",
                                      outlined: "",
                                      modelValue: partyAddress.address.postalCode.country.name,
                                      "onUpdate:modelValue": ($event: any) => ((partyAddress.address.postalCode.country.name) = $event),
                                      disable: partyAddress.address.isDisabled
                                    }, null, 8, ["data-testid", "modelValue", "onUpdate:modelValue", "disable"])
                                  ], 8, _hoisted_253),
                                  _createElementVNode("div", {
                                    class: "col-lg-3 col-md-6 col-sm-12 form-control no-border d-none",
                                    id: 'demand_edit_address_address1_' + index
                                  }, [
                                    _createElementVNode("label", _hoisted_256, _toDisplayString(_ctx.AdressLine1Label), 1),
                                    _createVNode(_component_q_input, {
                                      "data-testid": 'demand_edit_address_address1_' + index,
                                      dense: "",
                                      outlined: "",
                                      modelValue: partyAddress.address.line1,
                                      "onUpdate:modelValue": ($event: any) => ((partyAddress.address.line1) = $event),
                                      disable: partyAddress.address.isDisabled
                                    }, null, 8, ["data-testid", "modelValue", "onUpdate:modelValue", "disable"])
                                  ], 8, _hoisted_255),
                                  _createElementVNode("div", {
                                    class: "col-lg-3 col-md-6 col-sm-12 form-control no-border d-none",
                                    id: 'demand_edit_address_address2_' + index
                                  }, [
                                    _createElementVNode("label", _hoisted_258, _toDisplayString(_ctx.AdressLine2Label), 1),
                                    _createVNode(_component_q_input, {
                                      "data-testid": 'demand_edit_address_address2_' + index,
                                      dense: "",
                                      outlined: "",
                                      modelValue: partyAddress.address.line2,
                                      "onUpdate:modelValue": ($event: any) => ((partyAddress.address.line2) = $event),
                                      disable: partyAddress.address.isDisabled
                                    }, null, 8, ["data-testid", "modelValue", "onUpdate:modelValue", "disable"])
                                  ], 8, _hoisted_257),
                                  _createElementVNode("div", {
                                    class: "col-lg-3 col-md-6 col-sm-12 form-control no-border d-none",
                                    id: 'demand_edit_address_address3_' + index
                                  }, [
                                    _createElementVNode("label", _hoisted_260, _toDisplayString(_ctx.AdressLine3Label), 1),
                                    _createVNode(_component_q_input, {
                                      "data-testid": 'demand_edit_address_address3_' + index,
                                      dense: "",
                                      outlined: "",
                                      modelValue: partyAddress.address.line3,
                                      "onUpdate:modelValue": ($event: any) => ((partyAddress.address.line3) = $event),
                                      disable: partyAddress.address.isDisabled
                                    }, null, 8, ["data-testid", "modelValue", "onUpdate:modelValue", "disable"])
                                  ], 8, _hoisted_259),
                                  _createElementVNode("div", {
                                    class: "col-lg-3 col-md-6 col-sm-12 form-control no-border",
                                    id: 'demand_edit_address_propertyStatus_' + index
                                  }, [
                                    _createElementVNode("label", _hoisted_262, _toDisplayString(_ctx.$t("middleOffice.party.person.address.propertystatus")), 1),
                                    _createVNode(_component_q_select, {
                                      "data-testid": 'demand_edit_address_propertyStatus_' + index
                        ,
                                      dense: "",
                                      outlined: "",
                                      "emit-value": "",
                                      "map-options": "",
                                      modelValue: partyAddress.livingSituation.type.value,
                                      "onUpdate:modelValue": ($event: any) => ((partyAddress.livingSituation.type.value) = $event),
                                      options: _ctx.propertyStatus
                                    }, null, 8, ["data-testid", "modelValue", "onUpdate:modelValue", "options"])
                                  ], 8, _hoisted_261)
                                ])
                              ]),
                              _createElementVNode("div", null, [
                                _createVNode(_component_q_btn, {
                                  "data-testid": "demand_edit_address_deleteButton",
                                  outline: "",
                                  icon: "delete",
                                  onClick: ($event: any) => (_ctx.remove(index, _ctx.addresses)),
                                  class: "btn btn-outline-danger mt-3",
                                  disable: _ctx.$store.getters['authModule/hasMiddleOffice']
                                }, null, 8, ["onClick", "disable"])
                              ])
                            ])
                          ]))
                        }), 128))
                      ])
                    ]),
                    _: 1
                  }, 8, ["class"])
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (_ctx.isPersonMorale)
            ? (_openBlock(), _createBlock(_component_q_list, { key: 5 }, {
                default: _withCtx(() => [
                  _createVNode(_component_q_expansion_item, {
                    "switch-toggle-side": "",
                    "header-class": "card-header bg-transparent no-border p-4",
                    class: "card tw-items-dashed-group tw-items-group-with-bg tw-level-two-group",
                    onShow: _cache[83] || (_cache[83] = ($event: any) => {_ctx.companyPlusBtn = !_ctx.companyPlusBtn;
          _ctx.addExpandedItem(_ctx.facilities, _ctx.$store.getters['thirdModule/getFrenchFacilityInit'])
            }),
                    onHide: _cache[84] || (_cache[84] = ($event: any) => (_ctx.companyPlusBtn = !_ctx.companyPlusBtn)),
                    modelValue: _ctx.facilitiesOpened,
                    "onUpdate:modelValue": _cache[85] || (_cache[85] = ($event: any) => ((_ctx.facilitiesOpened) = $event))
                  }, {
                    header: _withCtx(() => [
                      _createElementVNode("div", _hoisted_263, [
                        _createElementVNode("div", _hoisted_264, [
                          _createElementVNode("div", _hoisted_265, _toDisplayString(_ctx.$t("middleOffice.party.organization.section.establishments")), 1),
                          _createVNode(_component_q_btn, {
                            outline: "",
                            class: "btn btn-primary btn-sm ml-3",
                            icon: "add",
                            onClickCapture: _cache[80] || (_cache[80] = _withModifiers(($event: any) => (
                  _ctx.add(_ctx.facilities, _ctx.$store.getters['thirdModule/getFrenchFacilityInit'])
                  ), ["stop"])),
                            disabled: _ctx.isCompanyPlusBtnDisabled
                          }, null, 8, ["disabled"])
                        ])
                      ])
                    ]),
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_266, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.facilitiesList, (value, index) => {
                          return (_openBlock(), _createElementBlock("div", {
                            class: "p-2 bg-white default-border-radius mb-3",
                            key: index
                          }, [
                            _createElementVNode("div", _hoisted_267, [
                              _createElementVNode("div", _hoisted_268, [
                                _createElementVNode("div", null, [
                                  _createElementVNode("div", _hoisted_269, [
                                    _createElementVNode("div", _hoisted_270, [
                                      _createElementVNode("div", _hoisted_271, [
                                        (_ctx.offer.businessData && _ctx.offer.businessData.API === _ctx.businessDataUtils.offerApiSource)
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_272, [
                                              _cache[112] || (_cache[112] = _createElementVNode("label", { class: "d-block mb-0 small text-muted" }, " SIRET ", -1)),
                                              _createVNode(_component_q_input, {
                                                "data-testid": "third_edit_identity_establishment_siren",
                                                dense: "",
                                                outlined: "",
                                                modelValue: value.siret,
                                                "onUpdate:modelValue": ($event: any) => ((value.siret) = $event)
                                              }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                            ]))
                                          : (_openBlock(), _createElementBlock("div", _hoisted_273, [
                                              _cache[113] || (_cache[113] = _createElementVNode("label", { class: "d-block mb-0 small text-muted" }, " SIRET ", -1)),
                                              _createVNode(_component_q_input, {
                                                "data-testid": "third_edit_identity_establishment_siren",
                                                class: "tw-input-with-prefix",
                                                prefix: _ctx.party?.organization?.siren,
                                                dense: "",
                                                outlined: "",
                                                rules: [(val) => (!!val && val.length === 5) || _ctx.requiredField],
                                                mask: _ctx.siretMask,
                                                modelValue: value.siret,
                                                "onUpdate:modelValue": ($event: any) => ((value.siret) = $event),
                                                autofocus: true,
                                                ref_for: true,
                                                ref: "siret"
                                              }, null, 8, ["prefix", "rules", "mask", "modelValue", "onUpdate:modelValue"])
                                            ])),
                                        _createElementVNode("div", _hoisted_274, [
                                          _createElementVNode("label", _hoisted_275, _toDisplayString(_ctx.$t("middleOffice.party.organization.identity.commercialName")), 1),
                                          _createVNode(_component_q_input, {
                                            "data-testid": "third_edit_identity_establishment_name",
                                            dense: "",
                                            outlined: "",
                                            modelValue: value.name,
                                            "onUpdate:modelValue": ($event: any) => ((value.name) = $event)
                                          }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                        ]),
                                        _createElementVNode("div", _hoisted_276, [
                                          _cache[114] || (_cache[114] = _createElementVNode("label", { class: "d-block mb-0 small text-muted" }, " Type ", -1)),
                                          _createVNode(_component_q_select, {
                                            "data-testid": "third_edit_identity_establishment_type",
                                            dense: "",
                                            outlined: "",
                                            "emit-value": "",
                                            "map-options": "",
                                            modelValue: value.facilityType.type.value,
                                            "onUpdate:modelValue": ($event: any) => ((value.facilityType.type.value) = $event),
                                            options: _ctx.facilityType
                                          }, null, 8, ["modelValue", "onUpdate:modelValue", "options"])
                                        ])
                                      ])
                                    ])
                                  ])
                                ]),
                                _createElementVNode("div", _hoisted_277, [
                                  _createVNode(_component_q_expansion_item, {
                                    "switch-toggle-side": "",
                                    "header-class": "card-header bg-transparent no-border p-4",
                                    class: "card tw-items-dashed-group tw-items-group-with-bg tw-level-two-group"
                                  }, {
                                    header: _withCtx(() => [
                                      _createElementVNode("div", _hoisted_278, [
                                        _createElementVNode("div", _hoisted_279, [
                                          _createElementVNode("div", _hoisted_280, _toDisplayString(_ctx.$t("main.labels.adresse")), 1)
                                        ])
                                      ])
                                    ]),
                                    default: _withCtx(() => [
                                      _createElementVNode("div", _hoisted_281, [
                                        _createElementVNode("div", _hoisted_282, [
                                          _createElementVNode("div", _hoisted_283, [
                                            _createElementVNode("label", _hoisted_284, _toDisplayString(_ctx.$t("middleOffice.party.organization.address.type")), 1),
                                            _createVNode(_component_q_select, {
                                              "data-testid": "third_edit_identity_establishment_adress_addressType",
                                              dense: "",
                                              outlined: "",
                                              multiple: "",
                                              modelValue: _ctx.selectedTypes,
                                              "onUpdate:modelValue": _cache[81] || (_cache[81] = ($event: any) => ((_ctx.selectedTypes) = $event)),
                                              options: _ctx.addressPreference,
                                              "option-value": "value",
                                              "option-label": "label",
                                              "emit-value": "",
                                              "map-options": "",
                                              clearable: "",
                                              behavior: "menu",
                                              class: "simple-multi-select"
                                            }, null, 8, ["modelValue", "options"])
                                          ]),
                                          _createElementVNode("div", _hoisted_285, [
                                            _createElementVNode("label", _hoisted_286, _toDisplayString(_ctx.$t("main.labels.adresse")), 1),
                                            _createVNode(_component_q_input, {
                                              "data-testid": "third_edit_identity_establishment_adress_street",
                                              dense: "",
                                              outlined: "",
                                              modelValue: value.address.line1,
                                              "onUpdate:modelValue": ($event: any) => ((value.address.line1) = $event)
                                            }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                          ]),
                                          _createElementVNode("div", _hoisted_287, [
                                            _createElementVNode("label", _hoisted_288, _toDisplayString(_ctx.$t("middleOffice.party.organization.establishments.address.street")), 1),
                                            _createVNode(_component_q_input, {
                                              "data-testid": "third_edit_identity_establishment_adress_street",
                                              dense: "",
                                              outlined: "",
                                              modelValue: value.address.street,
                                              "onUpdate:modelValue": ($event: any) => ((value.address.street) = $event)
                                            }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                          ]),
                                          _createElementVNode("div", _hoisted_289, [
                                            _createElementVNode("label", _hoisted_290, _toDisplayString(_ctx.$t("middleOffice.party.organization.establishments.address.lieuDit")), 1),
                                            _createVNode(_component_q_input, {
                                              dense: "",
                                              outlined: "",
                                              modelValue: value.address.line2,
                                              "onUpdate:modelValue": ($event: any) => ((value.address.line2) = $event)
                                            }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                          ]),
                                          _createElementVNode("div", _hoisted_291, [
                                            _createElementVNode("label", _hoisted_292, _toDisplayString(_ctx.$t("middleOffice.party.organization.address.codePostal")), 1),
                                            _createVNode(_component_q_select, {
                                              "data-testid": "third_edit_identity_establishment_adress_codePostal",
                                              dense: "",
                                              outlined: "",
                                              "use-input": "",
                                              "fill-input": "",
                                              "hide-selected": "",
                                              "onUpdate:modelValue": [($event: any) => (
                                _ctx.changePostalCodePM(value.address.postalCode, $event, index)
                                ), ($event: any) => ((value.address.postalCode.type) = $event)],
                                              modelValue: value.address.postalCode.type,
                                              options: _ctx.postalCodes,
                                              onFilter: _ctx.filterPostalCode
                                            }, {
                                              "no-option": _withCtx(() => [
                                                _createVNode(_component_q_item, null, {
                                                  default: _withCtx(() => [
                                                    _createVNode(_component_q_item_section, { class: "text-grey" }, {
                                                      default: _withCtx(() => [
                                                        _createTextVNode(_toDisplayString(_ctx.$t("main.noResults")), 1)
                                                      ]),
                                                      _: 1
                                                    })
                                                  ]),
                                                  _: 1
                                                })
                                              ]),
                                              append: _withCtx(() => [
                                                _createVNode(_component_q_icon, {
                                                  name: "search",
                                                  onClick: _cache[82] || (_cache[82] = _withModifiers(() => {}, ["stop"]))
                                                })
                                              ]),
                                              _: 1
                                            }, 8, ["onUpdate:modelValue", "modelValue", "options", "onFilter"])
                                          ]),
                                          _createElementVNode("div", _hoisted_293, [
                                            _createElementVNode("label", _hoisted_294, _toDisplayString(_ctx.$t("middleOffice.party.organization.address.city")), 1),
                                            _createVNode(_component_q_input, {
                                              "data-testid": "third_edit_identity_establishment_adress_city",
                                              dense: "",
                                              outlined: "",
                                              modelValue: value.address.postalCode.city,
                                              "onUpdate:modelValue": ($event: any) => ((value.address.postalCode.city) = $event),
                                              readonly: ""
                                            }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                          ]),
                                          _createElementVNode("div", _hoisted_295, [
                                            _createElementVNode("label", _hoisted_296, _toDisplayString(_ctx.$t("middleOffice.party.organization.address.country")), 1),
                                            _createVNode(_component_q_input, {
                                              "data-testid": "third_edit_identity_establishment_adress_country",
                                              dense: "",
                                              outlined: "",
                                              modelValue: value.address.postalCode.country.name,
                                              "onUpdate:modelValue": ($event: any) => ((value.address.postalCode.country.name) = $event),
                                              readonly: ""
                                            }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                          ])
                                        ])
                                      ])
                                    ]),
                                    _: 2
                                  }, 1024)
                                ])
                              ]),
                              _createElementVNode("div", null, [
                                _createVNode(_component_q_btn, {
                                  icon: "delete",
                                  class: "btn btn-outline-danger mt-3",
                                  onClick: ($event: any) => (_ctx.remove(index, _ctx.facilitiesList))
                                }, null, 8, ["onClick"])
                              ])
                            ])
                          ]))
                        }), 128))
                      ])
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (_ctx.isPersonPhysique && _ctx.isPartySupplierOrDistributor())
            ? (_openBlock(), _createBlock(_component_q_list, { key: 6 }, {
                default: _withCtx(() => [
                  _createVNode(_component_q_expansion_item, {
                    "switch-toggle-side": "",
                    "expand-separator": "",
                    "header-class": "card-header bg-transparent no-border p-4",
                    class: _normalizeClass(["card tw-items-dashed-group tw-items-group-with-bg", _ctx.currentRoute === 'TaskDetail' ? 'tw-analysis-section' : '']),
                    onShow: _cache[87] || (_cache[87] = ($event: any) => (_ctx.analysisBtn = !_ctx.analysisBtn)),
                    onHide: _cache[88] || (_cache[88] = ($event: any) => (_ctx.analysisBtn = !_ctx.analysisBtn))
                  }, {
                    header: _withCtx(() => [
                      _createElementVNode("div", _hoisted_297, [
                        _createElementVNode("div", _hoisted_298, [
                          _createElementVNode("div", _hoisted_299, _toDisplayString(_ctx.$t("demand.financialSituation.title")), 1),
                          (_ctx.isAnalysisBtnDisabled ||
                    _ctx.$store.getters['authModule/hasMiddleOffice']
                  )
                            ? (_openBlock(), _createBlock(_component_q_btn, {
                                key: 0,
                                "data-testid": "demand_edit_financialSituation_addButton",
                                class: "btn btn-primary btn-sm ml-3",
                                icon: "add",
                                onClickCapture: _cache[86] || (_cache[86] = _withModifiers(($event: any) => (_ctx.addAnalysis()), ["stop"]))
                              }))
                            : _createCommentVNode("", true)
                        ])
                      ])
                    ]),
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_300, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.analysis, (value, index) => {
                          return (_openBlock(), _createElementBlock("div", {
                            class: "p-2 bg-white default-border-radius mb-3",
                            key: index
                          }, [
                            _createElementVNode("div", _hoisted_301, [
                              _createElementVNode("div", _hoisted_302, [
                                _createElementVNode("div", _hoisted_303, [
                                  _createElementVNode("div", {
                                    class: "col-lg-3 col-md-6 col-sm-12 form-control no-border",
                                    id: 'demand_edit_financialSituation_analysisDate_' + index
                      
                                  }, [
                                    _createElementVNode("label", _hoisted_305, _toDisplayString(_ctx.$t(
                            "middleOffice.party.person.financialSituation.analysisDate"
                          )), 1),
                                    _createVNode(_component_q_input, {
                                      "data-testid": 'demand_edit_financialSituation_input_analysisDate_' +
                        index
                        ,
                                      dense: "",
                                      outlined: "",
                                      modelValue: value.analysisDate,
                                      "onUpdate:modelValue": ($event: any) => ((value.analysisDate) = $event),
                                      mask: _ctx.maskInput,
                                      disable: value.isDisabled
                                    }, {
                                      append: _withCtx(() => [
                                        _createVNode(_component_q_icon, {
                                          "data-testid": 'demand_edit_financialSituation_icon_analysisDate_' +
                            index
                            ,
                                          name: "event",
                                          class: "cursor-pointer"
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_q_popup_proxy, {
                                              "data-testid": 'demand_edit_financialSituation_popupProxy_analysisDate_' +
                              index
                              ,
                                              ref_for: true,
                                              ref: "qDateProxy",
                                              cover: "",
                                              "transition-show": "scale",
                                              "transition-hide": "scale"
                                            }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_q_date, {
                                                  "data-testid": 'demand_edit_financialSituation_date_analysisDate_' +
                                index
                                ,
                                                  modelValue: value.analysisDate,
                                                  "onUpdate:modelValue": ($event: any) => ((value.analysisDate) = $event),
                                                  mask: _ctx.maskFormat,
                                                  locale: _ctx.FR
                                                }, {
                                                  default: _withCtx(() => [
                                                    _createElementVNode("div", _hoisted_306, [
                                                      _withDirectives(_createVNode(_component_q_btn, {
                                                        "data-testid": 'demand_edit_financialSituation_button_analysisDate_' +
                                    index
                                    ,
                                                        label: _ctx.$t(
                                      'task.completeDocument.party.person.financialSituation.close'
                                    )
                                      ,
                                                        color: "primary",
                                                        flat: ""
                                                      }, null, 8, ["data-testid", "label"]), [
                                                        [_directive_close_popup]
                                                      ])
                                                    ])
                                                  ]),
                                                  _: 2
                                                }, 1032, ["data-testid", "modelValue", "onUpdate:modelValue", "mask", "locale"])
                                              ]),
                                              _: 2
                                            }, 1032, ["data-testid"])
                                          ]),
                                          _: 2
                                        }, 1032, ["data-testid"])
                                      ]),
                                      _: 2
                                    }, 1032, ["data-testid", "modelValue", "onUpdate:modelValue", "mask", "disable"])
                                  ], 8, _hoisted_304)
                                ])
                              ]),
                              _createElementVNode("div", null, [
                                _createVNode(_component_q_btn, {
                                  "data-testid": "demand_edit_financialSituation_deleteButton",
                                  outline: "",
                                  icon: "delete",
                                  onClick: ($event: any) => (_ctx.removeAnalysis(index, _ctx.analysis)),
                                  class: "btn btn-outline-danger mt-3",
                                  disable: _ctx.$store.getters['authModule/hasMiddleOffice']
                                }, null, 8, ["onClick", "disable"])
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_307, [
                              _createElementVNode("div", _hoisted_308, [
                                _createElementVNode("div", _hoisted_309, [
                                  _createElementVNode("span", _hoisted_310, _toDisplayString(_ctx.$t("party.income.details")), 1)
                                ])
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_311, [
                              _createElementVNode("div", _hoisted_312, [
                                _createElementVNode("div", _hoisted_313, [
                                  _createElementVNode("div", _hoisted_314, [
                                    _createElementVNode("div", _hoisted_315, [
                                      _createVNode(_component_q_table, {
                                        class: "no-shadow table table-striped",
                                        dense: "",
                                        rows: _ctx.orderDetail(_ctx.getDetails(value.detail, 'INCOME')),
                                        columns: _ctx.getColumnsRevenusMensuels,
                                        "row-key": (row) => row.resourceUid,
                                        pagination: { rowsPerPage: 0 }
                                      }, {
                                        top: _withCtx(() => [
                                          _createElementVNode("div", _hoisted_316, [
                                            _createElementVNode("span", _hoisted_317, _toDisplayString(_ctx.$t("middleOffice.party.person.section.income")), 1),
                                            _createVNode(_component_q_btn, {
                                              "data-testid": "demand_edit_incomeAndExpenses_incomes_addButton",
                                              outline: "",
                                              icon: "add",
                                              onClick: ($event: any) => (_ctx.addNewDetail(value.detail, 'INCOME')),
                                              disable: _ctx.$store.getters['authModule/hasMiddleOffice']
                                  ,
                                              class: "btn btn-sm btn-primary btn-sm"
                                            }, null, 8, ["onClick", "disable"])
                                          ])
                                        ]),
                                        header: _withCtx((props) => [
                                          _createVNode(_component_q_tr, { props: props }, {
                                            default: _withCtx(() => [
                                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.cols, (col) => {
                                                return (_openBlock(), _createBlock(_component_q_th, {
                                                  key: col.name,
                                                  props: props
                                                }, {
                                                  default: _withCtx(() => [
                                                    (col.name !== 'actions')
                                                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                                          _createTextVNode(_toDisplayString(_ctx.$t(col.label)), 1)
                                                        ], 64))
                                                      : _createCommentVNode("", true)
                                                  ]),
                                                  _: 2
                                                }, 1032, ["props"]))
                                              }), 128)),
                                              _createVNode(_component_q_th, { "auto-width": "" })
                                            ]),
                                            _: 2
                                          }, 1032, ["props"])
                                        ]),
                                        body: _withCtx((props) => [
                                          _createVNode(_component_q_tr, {
                                            props: props,
                                            style: {"height":"0.5rem"}
                                          }, {
                                            default: _withCtx(() => [
                                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.cols, (col, colIndex) => {
                                                return (_openBlock(), _createBlock(_component_q_td, {
                                                  key: col.name,
                                                  props: props
                                                }, {
                                                  default: _withCtx(() => [
                                                    (col.name === 'type')
                                                      ? (_openBlock(), _createBlock(_component_q_select, {
                                                          key: 0,
                                                          "data-testid": 'demand_edit_incomeAndExpenses_incomes_type_' +
                                    props.pageIndex +
                                    '_' +
                                    colIndex
                                    ,
                                                          borderless: "",
                                                          dense: "",
                                                          "emit-value": "",
                                                          "map-options": "",
                                                          modelValue: props.row.nature.type.value,
                                                          "onUpdate:modelValue": ($event: any) => ((props.row.nature.type.value) = $event),
                                                          options: _ctx.getNatureIncome(),
                                                          disable: props.row.isDisabled
                                                        }, null, 8, ["data-testid", "modelValue", "onUpdate:modelValue", "options", "disable"]))
                                                      : _createCommentVNode("", true),
                                                    (col.name === 'periodicity')
                                                      ? (_openBlock(), _createBlock(_component_q_select, {
                                                          key: 1,
                                                          "data-testid": 'demand_edit_incomeAndExpenses_incomes_periodicity_' +
                                    props.pageIndex +
                                    '_' +
                                    colIndex
                                    ,
                                                          borderless: "",
                                                          dense: "",
                                                          "emit-value": "",
                                                          "map-options": "",
                                                          modelValue: props.row.periodicity.type.value,
                                                          "onUpdate:modelValue": ($event: any) => ((props.row.periodicity.type.value) = $event),
                                                          options: _ctx.periodicities,
                                                          disable: props.row.isDisabled
                                                        }, null, 8, ["data-testid", "modelValue", "onUpdate:modelValue", "options", "disable"]))
                                                      : (col.name === 'value')
                                                        ? (_openBlock(), _createBlock(_component_twCurrencyInput, {
                                                            key: 2,
                                                            "data-testid": 'demand_edit_incomeAndExpenses_incomes_value_' +
                                    props.pageIndex +
                                    '_' +
                                    colIndex
                                    ,
                                                            outlined: "",
                                                            dense: "",
                                                            modelValue: props.row.value,
                                                            "onUpdate:modelValue": ($event: any) => ((props.row.value) = $event),
                                                            disable: props.row.isDisabled,
                                                            options: _ctx.currencyConfiguration
                                                          }, null, 8, ["data-testid", "modelValue", "onUpdate:modelValue", "disable", "options"]))
                                                        : (col.name === 'from')
                                                          ? (_openBlock(), _createBlock(_component_q_input, {
                                                              key: 3,
                                                              "data-testid": 'demand_edit_incomeAndExpenses_incomes_input_from_' +
                                    props.pageIndex +
                                    '_' +
                                    colIndex
                                    ,
                                                              dense: "",
                                                              outlined: "",
                                                              modelValue: props.row.validity.from,
                                                              "onUpdate:modelValue": ($event: any) => ((props.row.validity.from) = $event),
                                                              mask: _ctx.maskInput,
                                                              label: _ctx.$t('main.labels.startDate'),
                                                              style: {"margin-right":"10px","min-width":"10rem !important"},
                                                              disable: props.row.isDisabled
                                                            }, {
                                                              append: _withCtx(() => [
                                                                _createVNode(_component_q_icon, {
                                                                  "data-testid": 'demand_edit_incomeAndExpenses_incomes_icon_from_' +
                                        props.pageIndex
                                        ,
                                                                  name: "event",
                                                                  class: "cursor-pointer"
                                                                }, {
                                                                  default: _withCtx(() => [
                                                                    _createVNode(_component_q_popup_proxy, {
                                                                      "data-testid": 'demand_edit_incomeAndExpenses_incomes_popupProxy_from_' +
                                          props.pageIndex +
                                          '_' +
                                          colIndex
                                          ,
                                                                      ref_for: true,
                                                                      ref: "qDateProxy",
                                                                      cover: "",
                                                                      "transition-show": "scale",
                                                                      "transition-hide": "scale"
                                                                    }, {
                                                                      default: _withCtx(() => [
                                                                        _createVNode(_component_q_date, {
                                                                          "data-testid": 'demand_edit_incomeAndExpenses_incomes_date_from_' +
                                            props.pageIndex +
                                            '_' +
                                            colIndex
                                            ,
                                                                          modelValue: props.row.validity.from,
                                                                          "onUpdate:modelValue": ($event: any) => ((props.row.validity.from) = $event),
                                                                          mask: _ctx.maskFormat,
                                                                          locale: _ctx.FR
                                                                        }, {
                                                                          default: _withCtx(() => [
                                                                            _createElementVNode("div", _hoisted_318, [
                                                                              _withDirectives(_createVNode(_component_q_btn, {
                                                                                "data-testid": 'demand_edit_incomeAndExpenses_incomes_button_from_' +
                                                props.pageIndex +
                                                '_' +
                                                colIndex
                                                ,
                                                                                label: _ctx.$t(
                                                  'task.completeDocument.party.person.financialSituation.close'
                                                )
                                                  ,
                                                                                color: "primary",
                                                                                flat: ""
                                                                              }, null, 8, ["data-testid", "label"]), [
                                                                                [_directive_close_popup]
                                                                              ])
                                                                            ])
                                                                          ]),
                                                                          _: 2
                                                                        }, 1032, ["data-testid", "modelValue", "onUpdate:modelValue", "mask", "locale"])
                                                                      ]),
                                                                      _: 2
                                                                    }, 1032, ["data-testid"])
                                                                  ]),
                                                                  _: 2
                                                                }, 1032, ["data-testid"])
                                                              ]),
                                                              _: 2
                                                            }, 1032, ["data-testid", "modelValue", "onUpdate:modelValue", "mask", "label", "disable"]))
                                                          : (col.name === 'until')
                                                            ? (_openBlock(), _createBlock(_component_q_input, {
                                                                key: 4,
                                                                "data-testid": 'demand_edit_incomeAndExpenses_incomes_until_' +
                                    props.pageIndex +
                                    '_' +
                                    colIndex
                                    ,
                                                                dense: "",
                                                                outlined: "",
                                                                modelValue: props.row.validity.until,
                                                                "onUpdate:modelValue": ($event: any) => ((props.row.validity.until) = $event),
                                                                mask: _ctx.maskInput,
                                                                label: _ctx.$t('main.labels.endDate'),
                                                                style: {"margin-right":"10px","min-width":"10rem !important"},
                                                                disable: props.row.isDisabled
                                                              }, {
                                                                append: _withCtx(() => [
                                                                  _createVNode(_component_q_icon, {
                                                                    "data-testid": 'demand_edit_incomeAndExpenses_incomes_icon_endDate_' +
                                        props.pageIndex +
                                        '_' +
                                        colIndex
                                        ,
                                                                    name: "event",
                                                                    class: "cursor-pointer"
                                                                  }, {
                                                                    default: _withCtx(() => [
                                                                      _createVNode(_component_q_popup_proxy, {
                                                                        "data-testid": 'demand_edit_incomeAndExpenses_incomes_popupProxy_endDate_' +
                                          props.pageIndex
                                          ,
                                                                        ref_for: true,
                                                                        ref: "qDateProxy",
                                                                        cover: "",
                                                                        "transition-show": "scale",
                                                                        "transition-hide": "scale"
                                                                      }, {
                                                                        default: _withCtx(() => [
                                                                          _createVNode(_component_q_date, {
                                                                            "data-testid": 'demand_edit_incomeAndExpenses_incomes_date_endDate_' +
                                            props.pageIndex +
                                            '_' +
                                            colIndex
                                            ,
                                                                            modelValue: props.row.validity.until,
                                                                            "onUpdate:modelValue": ($event: any) => ((props.row.validity.until) = $event),
                                                                            mask: _ctx.maskFormat,
                                                                            locale: _ctx.FR
                                                                          }, {
                                                                            default: _withCtx(() => [
                                                                              _createElementVNode("div", _hoisted_319, [
                                                                                _withDirectives(_createVNode(_component_q_btn, {
                                                                                  "data-testid": 'demand_edit_incomeAndExpenses_incomes_button_endDate_' +
                                                props.pageIndex +
                                                '_' +
                                                colIndex
                                                ,
                                                                                  label: _ctx.$t(
                                                  'task.completeDocument.party.person.financialSituation.close'
                                                )
                                                  ,
                                                                                  color: "primary",
                                                                                  flat: ""
                                                                                }, null, 8, ["data-testid", "label"]), [
                                                                                  [_directive_close_popup]
                                                                                ])
                                                                              ])
                                                                            ]),
                                                                            _: 2
                                                                          }, 1032, ["data-testid", "modelValue", "onUpdate:modelValue", "mask", "locale"])
                                                                        ]),
                                                                        _: 2
                                                                      }, 1032, ["data-testid"])
                                                                    ]),
                                                                    _: 2
                                                                  }, 1032, ["data-testid"])
                                                                ]),
                                                                _: 2
                                                              }, 1032, ["data-testid", "modelValue", "onUpdate:modelValue", "mask", "label", "disable"]))
                                                            : (col.name === 'action')
                                                              ? (_openBlock(), _createBlock(_component_q_btn, {
                                                                  key: 5,
                                                                  "data-testid": 'demand_edit_incomeAndExpenses_incomes_deleteButton_' +
                                    props.pageIndex +
                                    '_' +
                                    colIndex
                                    ,
                                                                  outline: "",
                                                                  icon: "delete",
                                                                  class: "btn btn-sm btn-outline-gray-1",
                                                                  onClick: ($event: any) => (
                                      _ctx.removeDetail(
                                        value.detail,
                                        props.rowIndex,
                                        'INCOME',
                                        index
                                      )
                                      ),
                                                                  disable: _ctx.$store.getters[
          'authModule/hasMiddleOffice'
        ]
          
                                                                }, null, 8, ["data-testid", "onClick", "disable"]))
                                                              : _createCommentVNode("", true)
                                                  ]),
                                                  _: 2
                                                }, 1032, ["props"]))
                                              }), 128))
                                            ]),
                                            _: 2
                                          }, 1032, ["props"])
                                        ]),
                                        _: 2
                                      }, 1032, ["rows", "columns", "row-key"])
                                    ]),
                                    _createElementVNode("div", _hoisted_320, [
                                      _createVNode(_component_q_table, {
                                        class: "no-shadow table table-striped",
                                        dense: "",
                                        rows: _ctx.orderDetail(_ctx.getDetails(value.detail, 'EXPENSE')),
                                        columns: _ctx.getColumnsRevenusMensuels,
                                        "row-key": (row) => row.id,
                                        pagination: { rowsPerPage: 0 }
                                      }, {
                                        top: _withCtx(() => [
                                          _createElementVNode("div", _hoisted_321, [
                                            _createElementVNode("span", _hoisted_322, _toDisplayString(_ctx.$t("middleOffice.party.person.section.expense")), 1),
                                            _createVNode(_component_q_btn, {
                                              "data-testid": "'demand_edit_incomeAndExpenses_expenses_addButton",
                                              outline: "",
                                              icon: "add",
                                              onClick: ($event: any) => (_ctx.addNewDetail(value.detail, 'EXPENSE')),
                                              disabled: value.isDisabled ||
                                  _ctx.$store.getters['authModule/hasMiddleOffice']
                                  ,
                                              class: "btn btn-sm btn-primary btn-sm"
                                            }, null, 8, ["onClick", "disabled"])
                                          ])
                                        ]),
                                        header: _withCtx((props) => [
                                          _createVNode(_component_q_tr, { props: props }, {
                                            default: _withCtx(() => [
                                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.cols, (col) => {
                                                return (_openBlock(), _createBlock(_component_q_th, {
                                                  key: col.name,
                                                  props: props
                                                }, {
                                                  default: _withCtx(() => [
                                                    (col.name !== 'actions')
                                                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                                          _createTextVNode(_toDisplayString(_ctx.$t(col.label)), 1)
                                                        ], 64))
                                                      : _createCommentVNode("", true)
                                                  ]),
                                                  _: 2
                                                }, 1032, ["props"]))
                                              }), 128)),
                                              _createVNode(_component_q_th, { "auto-width": "" })
                                            ]),
                                            _: 2
                                          }, 1032, ["props"])
                                        ]),
                                        body: _withCtx((props) => [
                                          _createVNode(_component_q_tr, {
                                            props: props,
                                            style: {"height":"0.5rem"}
                                          }, {
                                            default: _withCtx(() => [
                                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.cols, (col, colIndex) => {
                                                return (_openBlock(), _createBlock(_component_q_td, {
                                                  key: col.name,
                                                  props: props
                                                }, {
                                                  default: _withCtx(() => [
                                                    (col.name === 'type')
                                                      ? (_openBlock(), _createBlock(_component_q_select, {
                                                          key: 0,
                                                          "data-testid": 'demand_edit_incomeAndExpenses_expenses_type_' +
                                    props.pageIndex +
                                    '_' +
                                    colIndex
                                    ,
                                                          borderless: "",
                                                          dense: "",
                                                          "emit-value": "",
                                                          "map-options": "",
                                                          modelValue: props.row.nature.type.value,
                                                          "onUpdate:modelValue": ($event: any) => ((props.row.nature.type.value) = $event),
                                                          options: _ctx.getNatureExpense(),
                                                          disable: props.row.isDisabled
                                                        }, null, 8, ["data-testid", "modelValue", "onUpdate:modelValue", "options", "disable"]))
                                                      : _createCommentVNode("", true),
                                                    (col.name === 'periodicity')
                                                      ? (_openBlock(), _createBlock(_component_q_select, {
                                                          key: 1,
                                                          "data-testid": 'demand_edit_incomeAndExpenses_expenses_periodicity_' +
                                    props.pageIndex +
                                    '_' +
                                    colIndex
                                    ,
                                                          borderless: "",
                                                          dense: "",
                                                          "emit-value": "",
                                                          "map-options": "",
                                                          modelValue: props.row.periodicity.type.value,
                                                          "onUpdate:modelValue": ($event: any) => ((props.row.periodicity.type.value) = $event),
                                                          options: _ctx.periodicities,
                                                          disable: props.row.isDisabled
                                                        }, null, 8, ["data-testid", "modelValue", "onUpdate:modelValue", "options", "disable"]))
                                                      : (col.name === 'value')
                                                        ? (_openBlock(), _createBlock(_component_twCurrencyInput, {
                                                            key: 2,
                                                            "data-testid": 'demand_edit_incomeAndExpenses_expenses_value_' +
                                    props.pageIndex +
                                    '_' +
                                    colIndex
                                    ,
                                                            outlined: "",
                                                            dense: "",
                                                            modelValue: props.row.value,
                                                            "onUpdate:modelValue": ($event: any) => ((props.row.value) = $event),
                                                            disable: props.row.isDisabled,
                                                            options: _ctx.currencyConfiguration
                                                          }, null, 8, ["data-testid", "modelValue", "onUpdate:modelValue", "disable", "options"]))
                                                        : (col.name === 'from')
                                                          ? (_openBlock(), _createBlock(_component_q_input, {
                                                              key: 3,
                                                              "data-testid": 'demand_edit_incomeAndExpenses_expenses_from_' +
                                    props.pageIndex +
                                    '_' +
                                    colIndex
                                    ,
                                                              dense: "",
                                                              outlined: "",
                                                              modelValue: props.row.validity.from,
                                                              "onUpdate:modelValue": ($event: any) => ((props.row.validity.from) = $event),
                                                              mask: _ctx.maskInput,
                                                              label: _ctx.$t('main.labels.startDate'),
                                                              style: {"margin-right":"10px","min-width":"10rem !important"},
                                                              disable: props.row.isDisabled
                                                            }, {
                                                              append: _withCtx(() => [
                                                                _createVNode(_component_q_icon, {
                                                                  "data-testid": 'demand_edit_incomeAndExpenses_expenses_icon_from_' +
                                        props.pageIndex +
                                        '_' +
                                        colIndex
                                        ,
                                                                  name: "event",
                                                                  class: "cursor-pointer"
                                                                }, {
                                                                  default: _withCtx(() => [
                                                                    _createVNode(_component_q_popup_proxy, {
                                                                      "data-testid": 'demand_edit_incomeAndExpenses_expenses_popupProxy_from_' +
                                          props.pageIndex +
                                          '_' +
                                          colIndex
                                          ,
                                                                      ref_for: true,
                                                                      ref: "qDateProxy",
                                                                      cover: "",
                                                                      "transition-show": "scale",
                                                                      "transition-hide": "scale"
                                                                    }, {
                                                                      default: _withCtx(() => [
                                                                        _createVNode(_component_q_date, {
                                                                          "data-testid": 'demand_edit_incomeAndExpenses_expenses_date_from_' +
                                            props.pageIndex +
                                            '_' +
                                            colIndex
                                            ,
                                                                          modelValue: props.row.validity.from,
                                                                          "onUpdate:modelValue": ($event: any) => ((props.row.validity.from) = $event),
                                                                          mask: _ctx.maskFormat,
                                                                          locale: _ctx.FR
                                                                        }, {
                                                                          default: _withCtx(() => [
                                                                            _createElementVNode("div", _hoisted_323, [
                                                                              _withDirectives(_createVNode(_component_q_btn, {
                                                                                "data-testid": 'demand_edit_incomeAndExpenses_expenses_button_from_' +
                                                props.pageIndex +
                                                '_' +
                                                colIndex
                                                ,
                                                                                label: _ctx.$t(
                                                  'task.completeDocument.party.person.financialSituation.close'
                                                )
                                                  ,
                                                                                color: "primary",
                                                                                flat: ""
                                                                              }, null, 8, ["data-testid", "label"]), [
                                                                                [_directive_close_popup]
                                                                              ])
                                                                            ])
                                                                          ]),
                                                                          _: 2
                                                                        }, 1032, ["data-testid", "modelValue", "onUpdate:modelValue", "mask", "locale"])
                                                                      ]),
                                                                      _: 2
                                                                    }, 1032, ["data-testid"])
                                                                  ]),
                                                                  _: 2
                                                                }, 1032, ["data-testid"])
                                                              ]),
                                                              _: 2
                                                            }, 1032, ["data-testid", "modelValue", "onUpdate:modelValue", "mask", "label", "disable"]))
                                                          : (col.name === 'until')
                                                            ? (_openBlock(), _createBlock(_component_q_input, {
                                                                key: 4,
                                                                "data-testid": 'demand_edit_incomeAndExpenses_expenses_until_' +
                                    props.pageIndex +
                                    '_' +
                                    colIndex
                                    ,
                                                                dense: "",
                                                                outlined: "",
                                                                modelValue: props.row.validity.until,
                                                                "onUpdate:modelValue": ($event: any) => ((props.row.validity.until) = $event),
                                                                mask: _ctx.maskInput,
                                                                label: _ctx.$t('main.labels.endDate'),
                                                                style: {"margin-right":"10px","min-width":"10rem !important"},
                                                                disable: props.row.isDisabled
                                                              }, {
                                                                append: _withCtx(() => [
                                                                  _createVNode(_component_q_icon, {
                                                                    "data-testid": 'demand_edit_incomeAndExpenses_expenses_icon_endDate_' +
                                        props.pageIndex +
                                        '_' +
                                        colIndex
                                        ,
                                                                    name: "event",
                                                                    class: "cursor-pointer"
                                                                  }, {
                                                                    default: _withCtx(() => [
                                                                      _createVNode(_component_q_popup_proxy, {
                                                                        "data-testid": 'demand_edit_incomeAndExpenses_expenses_popupProxy_endDate_' +
                                          props.pageIndex +
                                          '_' +
                                          colIndex
                                          ,
                                                                        ref_for: true,
                                                                        ref: "qDateProxy",
                                                                        cover: "",
                                                                        "transition-show": "scale",
                                                                        "transition-hide": "scale"
                                                                      }, {
                                                                        default: _withCtx(() => [
                                                                          _createVNode(_component_q_date, {
                                                                            "data-testid": 'demand_edit_incomeAndExpenses_expenses_date_endDate_' +
                                            props.pageIndex +
                                            '_' +
                                            colIndex
                                            ,
                                                                            modelValue: props.row.validity.until,
                                                                            "onUpdate:modelValue": ($event: any) => ((props.row.validity.until) = $event),
                                                                            mask: _ctx.maskFormat,
                                                                            locale: _ctx.FR
                                                                          }, {
                                                                            default: _withCtx(() => [
                                                                              _createElementVNode("div", _hoisted_324, [
                                                                                _withDirectives(_createVNode(_component_q_btn, {
                                                                                  "data-testid": 'demand_edit_incomeAndExpenses_expenses_button_endDate_' +
                                                props.pageIndex +
                                                '_' +
                                                colIndex
                                                ,
                                                                                  label: _ctx.$t(
                                                  'task.completeDocument.party.person.financialSituation.close'
                                                )
                                                  ,
                                                                                  color: "primary",
                                                                                  flat: ""
                                                                                }, null, 8, ["data-testid", "label"]), [
                                                                                  [_directive_close_popup]
                                                                                ])
                                                                              ])
                                                                            ]),
                                                                            _: 2
                                                                          }, 1032, ["data-testid", "modelValue", "onUpdate:modelValue", "mask", "locale"])
                                                                        ]),
                                                                        _: 2
                                                                      }, 1032, ["data-testid"])
                                                                    ]),
                                                                    _: 2
                                                                  }, 1032, ["data-testid"])
                                                                ]),
                                                                _: 2
                                                              }, 1032, ["data-testid", "modelValue", "onUpdate:modelValue", "mask", "label", "disable"]))
                                                            : (col.name === 'action')
                                                              ? (_openBlock(), _createBlock(_component_q_btn, {
                                                                  key: 5,
                                                                  "data-testid": 'demand_edit_incomeAndExpenses_expenses_deleteButton_' +
                                    props.pageIndex +
                                    '_' +
                                    colIndex
                                    ,
                                                                  outline: "",
                                                                  icon: "delete",
                                                                  class: "btn btn-sm btn-outline-gray-1",
                                                                  onClick: ($event: any) => (
                                      _ctx.removeDetail(
                                        value.detail,
                                        props.rowIndex,
                                        'EXPENSE',
                                        index
                                      )
                                      ),
                                                                  disable: _ctx.$store.getters[
          'authModule/hasMiddleOffice'
        ]
          
                                                                }, null, 8, ["data-testid", "onClick", "disable"]))
                                                              : _createCommentVNode("", true)
                                                  ]),
                                                  _: 2
                                                }, 1032, ["props"]))
                                              }), 128))
                                            ]),
                                            _: 2
                                          }, 1032, ["props"])
                                        ]),
                                        _: 2
                                      }, 1032, ["rows", "columns", "row-key"])
                                    ])
                                  ])
                                ])
                              ])
                            ])
                          ]))
                        }), 128))
                      ]),
                      (_ctx.currentRoute === 'TaskDetail' && _ctx.opinionQualifications.length > 0
          )
                        ? (_openBlock(), _createBlock(_component_Comment, {
                            key: 0,
                            qualificationType: 'PRT-STF'
                          }))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  }, 8, ["class"])
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (_ctx.isPersonPhysique && _ctx.isPartySupplierOrDistributor())
            ? (_openBlock(), _createBlock(_component_q_list, { key: 7 }, {
                default: _withCtx(() => [
                  _createVNode(_component_q_expansion_item, {
                    "switch-toggle-side": "",
                    "expand-separator": "",
                    "header-class": "card-header bg-transparent no-border p-4",
                    class: _normalizeClass(["card tw-items-dashed-group tw-items-group-with-bg tw-level-two-group", _ctx.currentRoute === 'TaskDetail' ? 'tw-analysis-section' : '']),
                    onShow: _cache[90] || (_cache[90] = ($event: any) => {
            _ctx.ExpossureBtn = !_ctx.ExpossureBtn;
          _ctx.addExpandedExpossure(_ctx.exposuresList);
          }),
                    onHide: _cache[91] || (_cache[91] = ($event: any) => {
            _ctx.ExpossureBtn = !_ctx.ExpossureBtn;
          _ctx.removeExpandedItem < _ctx.financialExposures > _ctx.financialExposures;
          })
                  }, {
                    header: _withCtx(() => [
                      _createElementVNode("div", _hoisted_325, [
                        _createElementVNode("div", _hoisted_326, [
                          _createElementVNode("div", _hoisted_327, _toDisplayString(_ctx.$t(
                      "middleOffice.party.organization.section.exposure"
                    ).toUpperCase()), 1),
                          _createVNode(_component_q_btn, {
                            "data-testid": "demand_edit_financialExposure_addButton",
                            class: "btn btn-primary btn-sm ml-3",
                            icon: "add",
                            onClickCapture: _cache[89] || (_cache[89] = _withModifiers(($event: any) => (_ctx.addExpossure()), ["stop"])),
                            disabled: !_ctx.isExposureBtnDisabled
                          }, null, 8, ["disabled"])
                        ])
                      ])
                    ]),
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_328, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.exposuresList, (value, index) => {
                          return (_openBlock(), _createElementBlock("div", {
                            class: "p-2 bg-white default-border-radius mb-3",
                            key: index
                          }, [
                            _createElementVNode("div", null, [
                              _createElementVNode("div", _hoisted_329, [
                                _createElementVNode("div", _hoisted_330, [
                                  _createElementVNode("div", _hoisted_331, [
                                    _createElementVNode("div", {
                                      class: "col-lg-3 col-md-6 col-sm-12 form-control no-border",
                                      id: 'demand_edit_financialExposure_outstadingEntity_' + index
                                    }, [
                                      _createElementVNode("label", _hoisted_333, _toDisplayString(_ctx.$t("middleOffice.party.organization.exposure.Outstanding_entity")), 1),
                                      _createVNode(_component_q_select, {
                                        "data-testid": 'demand_edit_financialExposure_outstadingEntity_' + index,
                                        dense: "",
                                        outlined: "",
                                        "emit-value": "",
                                        "map-options": "",
                                        options: _ctx.financialInstitution,
                                        loading: !_ctx.financialInstitution,
                                        disable: !_ctx.financialInstitution || value.isDisabled,
                                        modelValue: value.financialInstitution.value,
                                        "onUpdate:modelValue": [($event: any) => ((value.financialInstitution.value) = $event), ($event: any) => (_ctx.onFinancialInstitutionChange(value, $event))]
                                      }, null, 8, ["data-testid", "options", "loading", "disable", "modelValue", "onUpdate:modelValue"])
                                    ], 8, _hoisted_332),
                                    _createElementVNode("div", {
                                      class: "col-lg-3 col-md-6 col-sm-12 form-control no-border",
                                      id: 'demand_edit_financialExposure_outstadingType_' + index
                                    }, [
                                      _createElementVNode("label", _hoisted_335, _toDisplayString(_ctx.$t("middleOffice.party.organization.exposure.Outstanding_type")), 1),
                                      _createVNode(_component_q_select, {
                                        "data-testid": 'demand_edit_financialExposure_outstadingType_' + index,
                                        modelValue: value.outstandingType.value,
                                        "onUpdate:modelValue": ($event: any) => ((value.outstandingType.value) = $event),
                                        dense: "",
                                        outlined: "",
                                        "emit-value": "",
                                        "map-options": "",
                                        options: _ctx.typeOutstanding,
                                        loading: !_ctx.typeOutstanding,
                                        disable: !_ctx.typeOutstanding || value.isDisabled
                                      }, null, 8, ["data-testid", "modelValue", "onUpdate:modelValue", "options", "loading", "disable"])
                                    ], 8, _hoisted_334),
                                    _createElementVNode("div", {
                                      class: "col-lg-auto col-md-6 col-sm-12 form-control no-border",
                                      id: 'demand_edit_financialExposure_netOutstading_' + index
                                    }, [
                                      _createElementVNode("label", _hoisted_337, [
                                        _createTextVNode(_toDisplayString(_ctx.$t("middleOffice.party.organization.exposure.net_outstanding")) + " ", 1),
                                        (value.financialInstitution.value === 'CF' || value.financialInstitution.value === 'AFF_LIEE')
                                          ? (_openBlock(), _createElementBlock("span", _hoisted_338, "*"))
                                          : _createCommentVNode("", true)
                                      ]),
                                      _createVNode(_component_twCurrencyInput, {
                                        "data-testid": 'demand_edit_financialExposure_netOutstading_' + index,
                                        modelValue: value.netOutstanding,
                                        "onUpdate:modelValue": [($event: any) => ((value.netOutstanding) = $event), ($event: any) => (_ctx.calculateExposureGrossOutstanding(value))],
                                        disable: value.isDisabled,
                                        options: _ctx.currencyConfiguration,
                                        class: _normalizeClass((value.financialInstitution.value === 'CF' || value.financialInstitution.value === 'AFF_LIEE') &&
                              (!value.netOutstanding || value.netOutstanding === 0) ? 'input-error' : ''
                            )
                                      }, null, 8, ["data-testid", "modelValue", "onUpdate:modelValue", "disable", "options", "class"])
                                    ], 8, _hoisted_336),
                                    _createElementVNode("div", {
                                      class: "col-lg-3 col-md-6 col-sm-12 form-control no-border",
                                      id: 'demand_edit_financialExposure_grossOutstading_' + index
                                    }, [
                                      _createElementVNode("label", _hoisted_340, _toDisplayString(_ctx.$t("middleOffice.party.organization.exposure.gross_outstanding")), 1),
                                      _createVNode(_component_twCurrencyInput, {
                                        modelValue: value.grossOutstanding,
                                        "onUpdate:modelValue": ($event: any) => ((value.grossOutstanding) = $event),
                                        options: _ctx.currencyConfiguration,
                                        disable: ""
                                      }, null, 8, ["modelValue", "onUpdate:modelValue", "options"])
                                    ], 8, _hoisted_339),
                                    _createElementVNode("div", {
                                      class: "col-lg-3 col-md-6 col-sm-12 form-control no-border",
                                      id: 'demand_edit_financialExposure_contractReference_' + index
                                    }, [
                                      _createElementVNode("label", _hoisted_342, _toDisplayString(_ctx.$t("middleOffice.party.organization.exposure.contract_reference")), 1),
                                      _createVNode(_component_q_input, {
                                        "data-testid": 'demand_edit_financialExposure_contractReference_' + index,
                                        dense: "",
                                        outlined: "",
                                        modelValue: value.contractReference,
                                        "onUpdate:modelValue": ($event: any) => ((value.contractReference) = $event),
                                        disable: true
                                      }, null, 8, ["data-testid", "modelValue", "onUpdate:modelValue"])
                                    ], 8, _hoisted_341),
                                    (value.businessData && _ctx.verifyKSIOPCombination(value.financialInstitution.value, value.outstandingType.value))
                                      ? (_openBlock(), _createElementBlock("div", {
                                          key: 0,
                                          class: "col-lg-3 col-md-6 col-sm-12 form-control no-border",
                                          id: 'demand_edit_financialExposure_contractCassiopae_' + index
                                        }, [
                                          _createElementVNode("label", _hoisted_344, _toDisplayString(_ctx.$t("middleOffice.party.organization.exposure.contract_Cassiopae")), 1),
                                          _createVNode(_component_q_input, {
                                            "data-testid": 'demand_edit_financialExposure_contractCassiopae_' + index,
                                            dense: "",
                                            outlined: "",
                                            modelValue: value.businessData.contractCassiopae,
                                            "onUpdate:modelValue": ($event: any) => ((value.businessData.contractCassiopae) = $event)
                                          }, null, 8, ["data-testid", "modelValue", "onUpdate:modelValue"])
                                        ], 8, _hoisted_343))
                                      : _createCommentVNode("", true),
                                    (value.businessData && _ctx.verifyKSIOPCombination(value.financialInstitution.value, value.outstandingType.value))
                                      ? (_openBlock(), _createElementBlock("div", {
                                          key: 1,
                                          class: "col-lg-3 col-md-6 col-sm-12 form-control no-border",
                                          id: 'demand_edit_financialExposure_acteurCassiopae_' + index
                                        }, [
                                          _createElementVNode("label", _hoisted_346, _toDisplayString(_ctx.$t("middleOffice.party.organization.exposure.acteurCassiopae")), 1),
                                          _createVNode(_component_q_input, {
                                            "data-testid": 'demand_edit_financialExposure_acteurCassiopae_' + index,
                                            dense: "",
                                            outlined: "",
                                            modelValue: value.businessData.acteurCassiopae,
                                            "onUpdate:modelValue": ($event: any) => ((value.businessData.acteurCassiopae) = $event)
                                          }, null, 8, ["data-testid", "modelValue", "onUpdate:modelValue"])
                                        ], 8, _hoisted_345))
                                      : _createCommentVNode("", true)
                                  ]),
                                  (_ctx.verifyKSIOPCombination(value.financialInstitution.value, value.outstandingType.value))
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_347, [
                                        (_ctx.$store.getters['authModule/hasMiddleOffice'])
                                          ? (_openBlock(), _createBlock(_component_q_btn, {
                                              key: 0,
                                              class: "btn btn-primary mt-3",
                                              label: _ctx.$t('demand.button.recalculation'),
                                              icon: "calculate",
                                              onClick: ($event: any) => (_ctx.recalculateKSIOP(value, index))
                                            }, null, 8, ["label", "onClick"]))
                                          : _createCommentVNode("", true)
                                      ]))
                                    : _createCommentVNode("", true)
                                ]),
                                _createElementVNode("div", null, [
                                  _createElementVNode("div", {
                                    class: "col-lg-3 col-md-6 col-sm-12 form-control no-border d-flex flex-column",
                                    id: 'demand_edit_financialExposure_toggle_' + index
                                  }, [
                                    _createElementVNode("div", _hoisted_349, [
                                      (value.businessData)
                                        ? (_openBlock(), _createElementBlock("label", _hoisted_350, _toDisplayString(_ctx.$t("middleOffice.party.organization.exposure.to_settle")), 1))
                                        : _createCommentVNode("", true)
                                    ]),
                                    _createElementVNode("div", _hoisted_351, [
                                      (value.businessData)
                                        ? (_openBlock(), _createBlock(_component_q_toggle, {
                                            key: 0,
                                            "data-testid": 'demand_edit_financialExposure_toggle_' + index,
                                            modelValue: value.businessData.toSettle,
                                            "onUpdate:modelValue": ($event: any) => ((value.businessData.toSettle) = $event),
                                            disable: value.isDisabled,
                                            color: "primary",
                                            size: "md"
                                          }, null, 8, ["data-testid", "modelValue", "onUpdate:modelValue", "disable"]))
                                        : _createCommentVNode("", true),
                                      _createVNode(_component_q_btn, {
                                        "data-testid": "demand_edit_financialExposure_deleteButton",
                                        outline: "",
                                        class: "btn btn-outline-danger mt-0",
                                        icon: "delete",
                                        onClick: ($event: any) => (_ctx.removeExpanded(value))
                                      }, null, 8, ["onClick"])
                                    ])
                                  ], 8, _hoisted_348)
                                ])
                              ])
                            ])
                          ]))
                        }), 128))
                      ])
                    ]),
                    _: 1
                  }, 8, ["class"])
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (!_ctx.isPersonPhysique && _ctx.isPartySupplierOrDistributor())
            ? (_openBlock(), _createBlock(_component_q_list, { key: 8 }, {
                default: _withCtx(() => [
                  _createVNode(_component_q_expansion_item, {
                    "switch-toggle-side": "",
                    "expand-separator": "",
                    "header-class": "card-header bg-transparent no-border p-4",
                    class: _normalizeClass(["card tw-items-dashed-group tw-items-group-with-bg tw-level-two-group", _ctx.currentRoute === 'TaskDetail' ? 'tw-analysis-section' : '']),
                    onShow: _cache[93] || (_cache[93] = ($event: any) => {
            _ctx.ExpossureBtn = !_ctx.ExpossureBtn;
          _ctx.addExpandedExpossure(_ctx.exposuresList);
          }),
                    onHide: _cache[94] || (_cache[94] = ($event: any) => {
            _ctx.ExpossureBtn = !_ctx.ExpossureBtn;
          _ctx.removeExpandedItem < _ctx.financialExposures > _ctx.financialExposures;
          })
                  }, {
                    header: _withCtx(() => [
                      _createElementVNode("div", _hoisted_352, [
                        _createElementVNode("div", _hoisted_353, [
                          _createElementVNode("div", _hoisted_354, _toDisplayString(_ctx.$t(
                      "middleOffice.party.organization.section.expossure"
                    ).toUpperCase()), 1),
                          (_ctx.isExposureBtnDisabled ||
                    _ctx.$store.getters['authModule/hasMiddleOffice']
                  )
                            ? (_openBlock(), _createBlock(_component_q_btn, {
                                key: 0,
                                "data-testid": "demand_edit_financialExposure_shareRiskPool_addButton",
                                class: "btn btn-primary btn-sm ml-3",
                                icon: "add",
                                onClickCapture: _cache[92] || (_cache[92] = _withModifiers(($event: any) => (_ctx.addExpossure()), ["stop"]))
                              }))
                            : _createCommentVNode("", true)
                        ])
                      ])
                    ]),
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_355, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.exposuresList, (value, index) => {
                          return (_openBlock(), _createElementBlock("div", {
                            class: "p-2 bg-white default-border-radius mb-3",
                            key: index
                          }, [
                            _createElementVNode("div", null, [
                              _createElementVNode("div", _hoisted_356, [
                                _createElementVNode("div", _hoisted_357, [
                                  _createElementVNode("div", _hoisted_358, [
                                    _createElementVNode("div", {
                                      class: "col-lg-3 col-md-6 col-sm-12 form-control no-border",
                                      id: 'demand_edit_financialExposure_outstandingEntity_' +
                        index
                        
                                    }, [
                                      _createElementVNode("label", _hoisted_360, _toDisplayString(_ctx.$t(
                              "middleOffice.party.organization.exposure.Outstanding_entity"
                            )), 1),
                                      _createVNode(_component_q_select, {
                                        "data-testid": 'demand_edit_financialExposure_outstandingEntity_' +
                          index
                          ,
                                        dense: "",
                                        outlined: "",
                                        "emit-value": "",
                                        "map-options": "",
                                        options: _ctx.financialInstitution,
                                        loading: !_ctx.financialInstitution,
                                        disable: !_ctx.financialInstitution || value.isDisabled,
                                        modelValue: value.financialInstitution.value,
                                        "onUpdate:modelValue": [($event: any) => ((value.financialInstitution.value) = $event), ($event: any) => (_ctx.onFinancialInstitutionChange(value, $event))]
                                      }, null, 8, ["data-testid", "options", "loading", "disable", "modelValue", "onUpdate:modelValue"])
                                    ], 8, _hoisted_359),
                                    _createElementVNode("div", {
                                      class: "col-lg-3 col-md-6 col-sm-12 form-control no-border",
                                      id: 'demand_edit_financialExposure_outstandingType_' + index
                                    }, [
                                      _createElementVNode("label", _hoisted_362, _toDisplayString(_ctx.$t("middleOffice.party.organization.exposure.Outstanding_type")), 1),
                                      _createVNode(_component_q_select, {
                                        "data-testid": 'demand_edit_financialExposure_outstadingType_' + index,
                                        modelValue: value.outstandingType.value,
                                        "onUpdate:modelValue": ($event: any) => ((value.outstandingType.value) = $event),
                                        dense: "",
                                        outlined: "",
                                        "emit-value": "",
                                        "map-options": "",
                                        options: _ctx.typeOutstanding,
                                        loading: !_ctx.typeOutstanding,
                                        disable: !_ctx.typeOutstanding || value.isDisabled
                                      }, null, 8, ["data-testid", "modelValue", "onUpdate:modelValue", "options", "loading", "disable"])
                                    ], 8, _hoisted_361),
                                    _createElementVNode("div", {
                                      class: "col-lg-3 col-md-6 col-sm-12 form-control no-border",
                                      id: 'demand_edit_financialExposure_netOutstanding_' +
                        index
                        
                                    }, [
                                      _createElementVNode("label", _hoisted_364, [
                                        _createTextVNode(_toDisplayString(_ctx.$t(
                              "middleOffice.party.organization.exposure.net_outstanding"
                            )) + " ", 1),
                                        (value.financialInstitution.value === 'CF' || value.financialInstitution.value === 'AFF_LIEE')
                                          ? (_openBlock(), _createElementBlock("span", _hoisted_365, "*"))
                                          : _createCommentVNode("", true)
                                      ]),
                                      _createVNode(_component_twCurrencyInput, {
                                        "data-testid": 'demand_edit_financialExposure_netOutstanding_' +
                          index
                          ,
                                        modelValue: value.netOutstanding,
                                        "onUpdate:modelValue": [($event: any) => ((value.netOutstanding) = $event), ($event: any) => (_ctx.calculateExposureGrossOutstanding(value))],
                                        disable: value.isDisabled,
                                        options: _ctx.currencyConfiguration,
                                        class: _normalizeClass((value.financialInstitution.value === 'CF' || value.financialInstitution.value === 'AFF_LIEE') &&
                              (!value.netOutstanding || value.netOutstanding === 0) ? 'input-error' : ''
                            )
                                      }, null, 8, ["data-testid", "modelValue", "onUpdate:modelValue", "disable", "options", "class"])
                                    ], 8, _hoisted_363),
                                    _createElementVNode("div", {
                                      class: "col-lg-3 col-md-6 col-sm-12 form-control no-border",
                                      id: 'demand_edit_financialExposure_grossOutstanding_' +
                        index
                        
                                    }, [
                                      _createElementVNode("label", _hoisted_367, _toDisplayString(_ctx.$t(
                              "middleOffice.party.organization.exposure.gross_outstanding"
                            )), 1),
                                      _createVNode(_component_twCurrencyInput, {
                                        modelValue: value.grossOutstanding,
                                        "onUpdate:modelValue": ($event: any) => ((value.grossOutstanding) = $event),
                                        options: _ctx.currencyConfiguration,
                                        disable: ""
                                      }, null, 8, ["modelValue", "onUpdate:modelValue", "options"])
                                    ], 8, _hoisted_366),
                                    _createElementVNode("div", {
                                      class: "col-lg-3 col-md-6 col-sm-12 form-control no-border",
                                      id: 'demand_edit_financialExposure_contractReference_' +
                        index
                        
                                    }, [
                                      _createElementVNode("label", _hoisted_369, _toDisplayString(_ctx.$t(
                              "middleOffice.party.organization.exposure.contract_reference"
                            )), 1),
                                      _createVNode(_component_q_input, {
                                        "data-testid": 'demand_edit_financialExposure_contractReference_' +
                          index
                          ,
                                        dense: "",
                                        outlined: "",
                                        modelValue: value.contractReference,
                                        "onUpdate:modelValue": ($event: any) => ((value.contractReference) = $event),
                                        disable: true
                                      }, null, 8, ["data-testid", "modelValue", "onUpdate:modelValue"])
                                    ], 8, _hoisted_368),
                                    (value.businessData && _ctx.verifyKSIOPCombination(value.financialInstitution.value, value.outstandingType.value))
                                      ? (_openBlock(), _createElementBlock("div", {
                                          key: 0,
                                          class: "col-lg-3 col-md-6 col-sm-12 form-control no-border",
                                          id: 'demand_edit_financialExposure_contractCassiopae_' + index
                                        }, [
                                          _createElementVNode("label", _hoisted_371, _toDisplayString(_ctx.$t("middleOffice.party.organization.exposure.contract_Cassiopae")), 1),
                                          _createVNode(_component_q_input, {
                                            "data-testid": 'demand_edit_financialExposure_contractCassiopae_' + index,
                                            dense: "",
                                            outlined: "",
                                            modelValue: value.businessData.contractCassiopae,
                                            "onUpdate:modelValue": ($event: any) => ((value.businessData.contractCassiopae) = $event)
                                          }, null, 8, ["data-testid", "modelValue", "onUpdate:modelValue"])
                                        ], 8, _hoisted_370))
                                      : _createCommentVNode("", true),
                                    (value.businessData && _ctx.verifyKSIOPCombination(value.financialInstitution.value, value.outstandingType.value))
                                      ? (_openBlock(), _createElementBlock("div", {
                                          key: 1,
                                          class: "col-lg-3 col-md-6 col-sm-12 form-control no-border",
                                          id: 'demand_edit_financialExposure_acteurCassiopae_' + index
                                        }, [
                                          _createElementVNode("label", _hoisted_373, _toDisplayString(_ctx.$t("middleOffice.party.organization.exposure.acteurCassiopae")), 1),
                                          _createVNode(_component_q_input, {
                                            "data-testid": 'demand_edit_financialExposure_acteurCassiopae_' + index,
                                            dense: "",
                                            outlined: "",
                                            modelValue: value.businessData.acteurCassiopae,
                                            "onUpdate:modelValue": ($event: any) => ((value.businessData.acteurCassiopae) = $event)
                                          }, null, 8, ["data-testid", "modelValue", "onUpdate:modelValue"])
                                        ], 8, _hoisted_372))
                                      : _createCommentVNode("", true)
                                  ]),
                                  (_ctx.verifyKSIOPCombination(value.financialInstitution.value, value.outstandingType.value))
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_374, [
                                        (_ctx.$store.getters['authModule/hasMiddleOffice'])
                                          ? (_openBlock(), _createBlock(_component_q_btn, {
                                              key: 0,
                                              class: "btn btn-primary mt-3",
                                              label: _ctx.$t('demand.button.recalculation'),
                                              icon: "calculate",
                                              onClick: ($event: any) => (_ctx.recalculateKSIOP(value, index))
                                            }, null, 8, ["label", "onClick"]))
                                          : _createCommentVNode("", true)
                                      ]))
                                    : _createCommentVNode("", true)
                                ]),
                                _createElementVNode("div", null, [
                                  _createElementVNode("div", {
                                    class: "col-lg-3 col-md-6 col-sm-12 form-control no-border d-flex flex-column",
                                    id: 'demand_edit_financialExposure_toggle_' + index
                                  }, [
                                    _createElementVNode("div", _hoisted_376, [
                                      (value.businessData)
                                        ? (_openBlock(), _createElementBlock("label", _hoisted_377, _toDisplayString(_ctx.$t("middleOffice.party.organization.exposure.to_settle")), 1))
                                        : _createCommentVNode("", true)
                                    ]),
                                    _createElementVNode("div", _hoisted_378, [
                                      (value.businessData)
                                        ? (_openBlock(), _createBlock(_component_q_toggle, {
                                            key: 0,
                                            "data-testid": 'demand_edit_financialExposure_toggle_' + index,
                                            modelValue: value.businessData.toSettle,
                                            "onUpdate:modelValue": ($event: any) => ((value.businessData.toSettle) = $event),
                                            disable: value.isDisabled,
                                            color: "primary",
                                            size: "md"
                                          }, null, 8, ["data-testid", "modelValue", "onUpdate:modelValue", "disable"]))
                                        : _createCommentVNode("", true),
                                      _createVNode(_component_q_btn, {
                                        "data-testid": "demand_edit_financialExposure_deleteButton",
                                        outline: "",
                                        class: "btn btn-outline-danger mt-0",
                                        icon: "delete",
                                        onClick: ($event: any) => (_ctx.removeExpanded(value))
                                      }, null, 8, ["onClick"])
                                    ])
                                  ], 8, _hoisted_375)
                                ])
                              ])
                            ])
                          ]))
                        }), 128))
                      ])
                    ]),
                    _: 1
                  }, 8, ["class"])
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (_ctx.isPartySupplierOrDistributor())
            ? (_openBlock(), _createBlock(_component_q_expansion_item, {
                key: 9,
                "switch-toggle-side": "",
                "header-class": "card-header bg-transparent no-border p-4",
                class: _normalizeClass(["card tw-items-dashed-group tw-items-group-with-bg", _ctx.currentRoute === 'TaskDetail' ? 'tw-analysis-section' : '']),
                modelValue: _ctx.signatureMethodOpened,
                "onUpdate:modelValue": _cache[99] || (_cache[99] = ($event: any) => ((_ctx.signatureMethodOpened) = $event)),
                onShow: _ctx.editSignatureMethod,
                onHide: _ctx.editSignatureMethod
              }, {
                header: _withCtx(() => [
                  _createElementVNode("div", _hoisted_379, [
                    _createElementVNode("div", _hoisted_380, [
                      _createElementVNode("div", _hoisted_381, _toDisplayString(_ctx.$t("main.labels.complementaryInformation").toUpperCase()), 1)
                    ])
                  ])
                ]),
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_382, [
                    _createElementVNode("div", _hoisted_383, [
                      _createElementVNode("div", _hoisted_384, [
                        _createElementVNode("div", _hoisted_385, [
                          _createElementVNode("div", _hoisted_386, [
                            _createElementVNode("div", _hoisted_387, [
                              _createElementVNode("label", _hoisted_388, _toDisplayString(_ctx.$t("main.labels.signatureMethod")), 1),
                              _createVNode(_component_q_select, {
                                "data-testid": "demand_edit_signature_signaturMethod",
                                dense: "",
                                outlined: "",
                                "emit-value": "",
                                "map-options": "",
                                modelValue: _ctx.role.signatureMethod,
                                "onUpdate:modelValue": [
                                  _cache[95] || (_cache[95] = ($event: any) => ((_ctx.role.signatureMethod) = $event)),
                                  _cache[96] || (_cache[96] = ($event: any) => (_ctx.changeSignature($event)))
                                ],
                                options: _ctx.signatureMethods,
                                "display-value": `${_ctx.role.signatureMethod.resourceUid ? _ctx.$t('demand.party.signatureMethod.' + _ctx.role.signatureMethod.resourceUid) : _ctx.$t('demand.party.signatureMethod.' + _ctx.role.signatureMethod)}`
                              }, null, 8, ["modelValue", "options", "display-value"])
                            ]),
                            (_ctx.party.businessData)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_389, [
                                  _createElementVNode("label", _hoisted_390, _toDisplayString(_ctx.$t("main.labels.renewal")), 1),
                                  _createVNode(_component_q_select, {
                                    "data-testid": "demand_edit_identity_customerType",
                                    dense: "",
                                    outlined: "",
                                    class: "bg-white",
                                    modelValue: _ctx.party.businessData.renewal,
                                    "onUpdate:modelValue": _cache[97] || (_cache[97] = ($event: any) => ((_ctx.party.businessData.renewal) = $event)),
                                    options: _ctx.yesOrNoOptions,
                                    "map-options": "",
                                    "emit-value": ""
                                  }, null, 8, ["modelValue", "options"])
                                ]))
                              : _createCommentVNode("", true),
                            (_ctx.party.businessData)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_391, [
                                  _createElementVNode("label", _hoisted_392, _toDisplayString(_ctx.$t("main.labels.isCfClient")), 1),
                                  _createVNode(_component_q_select, {
                                    "data-testid": "demand_edit_identity_activity",
                                    dense: "",
                                    outlined: "",
                                    modelValue: _ctx.party.businessData.isCfClient,
                                    "onUpdate:modelValue": _cache[98] || (_cache[98] = ($event: any) => ((_ctx.party.businessData.isCfClient) = $event)),
                                    options: _ctx.yesOrNoOptions,
                                    "map-options": "",
                                    "emit-value": ""
                                  }, null, 8, ["modelValue", "options"])
                                ]))
                              : _createCommentVNode("", true)
                          ])
                        ])
                      ])
                    ])
                  ])
                ]),
                _: 1
              }, 8, ["class", "modelValue", "onShow", "onHide"]))
            : _createCommentVNode("", true),
          (_ctx.isPartySupplierOrDistributor())
            ? (_openBlock(), _createBlock(_component_PartyAccount, {
                key: 10,
                party: _ctx.party,
                tabPosition: _ctx.tabPosition,
                role: _ctx.role
              }, null, 8, ["party", "tabPosition", "role"]))
            : _createCommentVNode("", true),
          _createVNode(_component_TaskPartyRelation, { party: _ctx.party }, null, 8, ["party"]),
          (_ctx.isPersonMorale && _ctx.currentRoute === 'TaskDetail' && _ctx.isPartySupplierOrDistributor())
            ? (_openBlock(), _createBlock(_component_PartyFinancialSituation, {
                key: 11,
                party: _ctx.party
              }, null, 8, ["party"]))
            : _createCommentVNode("", true),
          (_ctx.isPartySupplierOrDistributor())
            ? (_openBlock(), _createBlock(_component_TaskPartyClassification, {
                key: 12,
                selectedClassifications: _ctx.isPersonMorale
        ? _ctx.party?.organization?.classifications
        : _ctx.party?.person?.classifications
        
              }, null, 8, ["selectedClassifications"]))
            : _createCommentVNode("", true)
        ], 2)
      ]),
      _: 3
    }),
    (_ctx.showDialog)
      ? (_openBlock(), _createBlock(_component_third_search_dialog, {
          key: 0,
          openDialog: _ctx.openDialog,
          party: _ctx.party,
          role: _ctx.role,
          onOnSelectedItem: _ctx.onSelectedItem,
          onOnClose: _ctx.onCloseThird
        }, null, 8, ["openDialog", "party", "role", "onOnSelectedItem", "onOnClose"]))
      : _createCommentVNode("", true),
    (_ctx.showManagerDialog)
      ? (_openBlock(), _createBlock(_component_third_search_dialog, {
          key: 1,
          openDialog: _ctx.openDialog,
          party: _ctx.party,
          onOnSelectedItem: _ctx.onManagerSelected,
          onOnClose: _ctx.onCloseManager
        }, null, 8, ["openDialog", "party", "onOnSelectedItem", "onOnClose"]))
      : _createCommentVNode("", true)
  ], 64))
}